export const icons = {
    "c5": {
        "type": "SF",
        "rarity": 6,
        "modded": false,
        "skins": {
            "pic_Scarecrow_LL.png": {
                "cn": "稻草人",
                "kr": "스케어크로우",
                "jp": "スケアクロウ",
                "en": "Scarecrow",
                "alt": "pic_Scarecrow_LL_1.png"
            }
        },
        "id": "c5",
        "cn": "稻草人",
        "code": "Scarecrow",
        "icon": "Icon_Scarecrow_SS_1.png",
        "kr": "스케어크로우",
        "jp": "スケアクロウ",
        "en": "Scarecrow"
    },
    "c8": {
        "type": "SF",
        "rarity": 6,
        "modded": false,
        "skins": {
            "pic_Excutioner_LL.png": {
                "cn": "行裁者",
                "kr": "엑스큐셔너",
                "jp": "エクスキューショナー",
                "en": "Executioner",
                "alt": "pic_Excutioner_LL_1.png"
            }
        },
        "id": "c8",
        "cn": "行裁者",
        "code": "Excutioner",
        "icon": "Icon_Excutioner_SS_1.png",
        "kr": "엑스큐셔너",
        "jp": "エクスキューショナー",
        "en": "Executioner"
    },
    "c11": {
        "type": "SF",
        "rarity": 6,
        "modded": false,
        "skins": {
            "pic_Hunter_LL.png": {
                "cn": "猎手",
                "kr": "헌터",
                "jp": "ハンター",
                "en": "Hunter",
                "alt": "pic_Hunter_LL_1.png"
            }
        },
        "id": "c11",
        "cn": "猎手",
        "code": "Hunter",
        "icon": "Icon_Hunter_SS_1.png",
        "kr": "헌터",
        "jp": "ハンター",
        "en": "Hunter"
    },
    "c17": {
        "type": "SF",
        "rarity": 6,
        "modded": false,
        "skins": {
            "pic_Intruder_LL.png": {
                "cn": "干扰者",
                "kr": "인트루더",
                "jp": "イントゥルーダー",
                "en": "Intruder",
                "alt": "pic_Intruder_LL_1.png"
            }
        },
        "id": "c17",
        "cn": "干扰者",
        "code": "Intruder",
        "icon": "Icon_Intruder_SS_1.png",
        "kr": "인트루더",
        "jp": "イントゥルーダー",
        "en": "Intruder"
    },
    "c18": {
        "type": "SF",
        "rarity": 6,
        "modded": false,
        "skins": {
            "pic_Destroyer_LL.png": {
                "cn": "破坏者",
                "kr": "디스트로이어",
                "jp": "デストロイヤー",
                "en": "Destroyer",
                "alt": "pic_Destroyer_LL_1.png"
            }
        },
        "id": "c18",
        "cn": "破坏者",
        "code": "Destroyer",
        "icon": "Icon_Destroyer_SS_1.png",
        "kr": "디스트로이어",
        "jp": "デストロイヤー",
        "en": "Destroyer"
    },
    "c21": {
        "type": "SF",
        "rarity": 6,
        "modded": false,
        "skins": {
            "pic_Weaver_LL.png": {
                "cn": "衔尾蛇",
                "kr": "우로보로스",
                "jp": "ウロボロス",
                "en": "Ouroboros",
                "alt": "pic_Weaver_LL_1.png"
            }
        },
        "id": "c21",
        "cn": "衔尾蛇",
        "code": "Weaver",
        "icon": "Icon_Weaver_SS_1.png",
        "kr": "우로보로스",
        "jp": "ウロボロス",
        "en": "Ouroboros"
    },
    "c23": {
        "type": "SF",
        "rarity": 6,
        "modded": false,
        "skins": {
            "pic_Alchemist_LL.png": {
                "cn": "炼金术士",
                "kr": "알케미스트",
                "jp": "アルケミスト",
                "en": "Alchemist",
                "alt": "pic_Alchemist_LL_1.png"
            }
        },
        "id": "c23",
        "cn": "炼金术士",
        "code": "Alchemist",
        "icon": "Icon_Alchemist_SS_1.png",
        "kr": "알케미스트",
        "jp": "アルケミスト",
        "en": "Alchemist"
    },
    "c24": {
        "type": "SF",
        "rarity": 6,
        "modded": false,
        "skins": {
            "pic_Dreamer_LL.png": {
                "cn": "梦想家",
                "kr": "드리머",
                "jp": "ドリーマー",
                "en": "Dreamer",
                "alt": "pic_Dreamer_LL_1.png"
            }
        },
        "id": "c24",
        "cn": "梦想家",
        "code": "Dreamer",
        "icon": "Icon_Dreamer_SS_1.png",
        "kr": "드리머",
        "jp": "ドリーマー",
        "en": "Dreamer"
    },
    "c26": {
        "type": "SF",
        "rarity": 6,
        "modded": false,
        "skins": {
            "pic_BossGager_LL.png": {
                "cn": "计量官",
                "kr": "게이저",
                "jp": "ゲーガー",
                "en": "Gager",
                "alt": "pic_BossGager_LL_1.png"
            }
        },
        "id": "c26",
        "cn": "计量官",
        "code": "BossGager",
        "icon": "Icon_BossGager_SS_1.png",
        "kr": "게이저",
        "jp": "ゲーガー",
        "en": "Gager"
    },
    "c27": {
        "type": "SF",
        "rarity": 6,
        "modded": false,
        "skins": {
            "pic_BossArchitect_LL.png": {
                "cn": "建筑师",
                "kr": "아키텍트",
                "jp": "アーキテクト",
                "en": "Architect",
                "alt": "pic_BossArchitect_LL_1.png"
            }
        },
        "id": "c27",
        "cn": "建筑师",
        "code": "BossArchitect",
        "icon": "Icon_BossArchitect_SS_1.png",
        "kr": "아키텍트",
        "jp": "アーキテクト",
        "en": "Architect"
    },
    "c33": {
        "type": "SF",
        "rarity": 6,
        "modded": false,
        "skins": {
            "pic_BossCerberus_LL.png": {
                "cn": "末日魔犬",
                "kr": "케르베로스",
                "jp": "ケルベロス",
                "en": "Cerberus",
                "alt": "pic_BossCerberus_LL_1.png"
            }
        },
        "id": "c33",
        "cn": "末日魔犬",
        "code": "BossCerberus",
        "icon": "Icon_BossCerberus_SS_1.png",
        "kr": "케르베로스",
        "jp": "ケルベロス",
        "en": "Cerberus"
    },
    "c35": {
        "type": "SF",
        "rarity": 6,
        "modded": false,
        "skins": {
            "pic_Justice_LL.png": {
                "cn": "法官",
                "kr": "저지",
                "jp": "ジャッジ",
                "en": "Judge",
                "alt": "pic_Justice_LL_1.png"
            }
        },
        "id": "c35",
        "cn": "法官",
        "code": "Justice",
        "icon": "Icon_Justice_SS_1.png",
        "kr": "저지",
        "jp": "ジャッジ",
        "en": "Judge"
    },
    "c45": {
        "type": "SF",
        "rarity": 6,
        "modded": false,
        "skins": {
            "pic_Agent_LL.png": {
                "cn": "代理人",
                "kr": "에이전트",
                "jp": "エージェント",
                "en": "Agent",
                "alt": "pic_Agent_LL_1.png"
            }
        },
        "id": "c45",
        "cn": "代理人",
        "code": "Agent",
        "icon": "Icon_Agent_SS_1.png",
        "kr": "에이전트",
        "jp": "エージェント",
        "en": "Agent"
    },
    "c50": {
        "type": "SF",
        "rarity": 6,
        "modded": false,
        "skins": {
            "pic_Nyto_black_LL.png": {
                "cn": "艾德琳",
                "kr": "아델린",
                "jp": "ネイト(黒)",
                "en": "Adeline",
                "alt": "pic_Nyto_black_LL_1.png"
            }
        },
        "id": "c50",
        "cn": "艾德琳",
        "code": "Nyto_black",
        "icon": "Icon_Nyto_black_SS_1.png",
        "kr": "아델린",
        "jp": "ネイト(黒)",
        "en": "Adeline"
    },
    "c51": {
        "type": "SF",
        "rarity": 6,
        "modded": false,
        "skins": {
            "pic_Nyto_white_LL.png": {
                "cn": "埃莉诺",
                "kr": "알리나",
                "jp": "ネイト(白)",
                "en": "Alina",
                "alt": "pic_Nyto_white_LL_1.png"
            }
        },
        "id": "c51",
        "cn": "埃莉诺",
        "code": "Nyto_white",
        "icon": "Icon_Nyto_white_SS_1.png",
        "kr": "알리나",
        "jp": "ネイト(白)",
        "en": "Alina"
    },
    "c126": {
        "type": "SF",
        "rarity": 6,
        "modded": false,
        "skins": {
            "pic_BossArchitect_Summer_LL.png": {
                "cn": "建筑师-NVW型",
                "kr": "아키텍트-NVW형",
                "jp": "",
                "en": "Architect - NVW Model",
                "alt": "pic_BossArchitect_Summer_LL_1.png"
            }
        },
        "id": "c126",
        "cn": "建筑师-NVW型",
        "code": "BossArchitect_Summer",
        "icon": "Icon_BossArchitect_Summer_SS_1.png",
        "kr": "아키텍트-NVW형",
        "jp": "",
        "en": "Architect - NVW Model"
    },
    "c140": {
        "type": "SF",
        "rarity": 6,
        "modded": false,
        "skins": {
            "pic_Intruder_Halloween_LL.png": {
                "cn": "干扰者-终幕魔女",
                "kr": "인트루더-종막의 마녀",
                "alt": "pic_Intruder_Halloween_LL_1.png"
            }
        },
        "id": "c140",
        "cn": "干扰者-终幕魔女",
        "code": "Intruder_Halloween",
        "icon": "Icon_Intruder_Halloween_SS_1.png",
        "kr": "인트루더-종막의 마녀"
    },
    "c147": {
        "type": "SF",
        "rarity": 6,
        "modded": false,
        "skins": {
            "pic_Destroyer_Christmas_LL.png": {
                "cn": "破坏者-浮掠麋影",
                "kr": "디스트로이어 - 폭주사슴",
                "alt": "pic_Destroyer_Christmas_LL_1.png"
            }
        },
        "id": "c147",
        "cn": "破坏者-浮掠麋影",
        "code": "Destroyer_Christmas",
        "icon": "Icon_Destroyer_Christmas_SS_1.png",
        "kr": "디스트로이어 - 폭주사슴"
    },
    "c157": {
        "type": "SF",
        "rarity": 6,
        "modded": false,
        "skins": {
            "pic_Hunter_WhiteDay_LL.png": {
                "cn": "猎手-裳夜落蛾",
                "kr": "헌터-나방 사냥",
                "alt": "pic_Hunter_WhiteDay_LL_1.png"
            }
        },
        "id": "c157",
        "cn": "猎手-裳夜落蛾",
        "code": "Hunter_WhiteDay",
        "icon": "Icon_Hunter_WhiteDay_SS_1.png",
        "kr": "헌터-나방 사냥"
    },
    "c166": {
        "type": "SF",
        "rarity": 6,
        "modded": false,
        "skins": {
            "pic_Nyto_White_Summer_LL.png": {
                "cn": "埃莉诺-沧龙掠骑者",
                "kr": "알리나-파도용기사",
                "alt": "pic_Nyto_White_Summer_LL_1.png"
            }
        },
        "id": "c166",
        "cn": "埃莉诺-沧龙掠骑者",
        "code": "Nyto_White_Summer",
        "icon": "Icon_Nyto_White_Summer_SS_1.png",
        "kr": "알리나-파도용기사"
    },
    "_": "/images/icons",
    "__": "/images/skins",
    "1": {
        "type": "HG",
        "id": "1",
        "cn": "柯尔特左轮",
        "code": "M1873",
        "icon": "Icon_M1873.png",
        "modded": true,
        "rarity": 4,
        "skins": {
            "pic_M1873.png": {
                "cn": "柯尔特左轮",
                "kr": "콜트 리볼버",
                "jp": "コルトSAA",
                "en": "SAA",
                "alt": "pic_M1873_D.png"
            },
            "pic_M1873Mod.png": {
                "cn": "柯尔特左轮",
                "kr": "콜트 리볼버",
                "jp": "コルトSAA",
                "en": "SAA",
                "icon": "mod",
                "alt": "pic_M1873Mod_D.png"
            },
            "pic_M1873_301.png": {
                "cn": "柯尔特左轮-直达星星的愿望",
                "icon": "Icon_M1873_301.png",
                "alt": "pic_M1873_301_D.png",
                "kr": "콜트 리볼버 - 별똥별의 소원",
                "jp": "星への願い事",
                "en": "Wish Upon A Star"
            },
            "pic_M1873_2105.png": {
                "cn": "柯尔特左轮-奇迹女王",
                "icon": "Icon_M1873_2105.png",
                "alt": "pic_M1873_2105_D.png",
                "kr": "콜트 리볼버 - 기적의 여왕",
                "jp": "ミラクル女王",
                "en": "Queen of Miracles"
            }
        },
        "kr": "콜트 리볼버",
        "jp": "コルトSAA",
        "en": "SAA",
        "moddedIcon": "Icon_M1873Mod.png",
        "modRarity": 5
    },
    "2": {
        "type": "HG",
        "id": "2",
        "cn": "M1911",
        "code": "M1911",
        "icon": "Icon_M1911.png",
        "modded": true,
        "rarity": 2,
        "skins": {
            "pic_M1911.png": {
                "cn": "M1911",
                "kr": "M1911",
                "jp": "M1911",
                "en": "M1911",
                "alt": "pic_M1911_D.png"
            },
            "pic_M1911Mod.png": {
                "cn": "M1911",
                "kr": "M1911",
                "jp": "M1911",
                "en": "M1911",
                "icon": "mod",
                "alt": "pic_M1911Mod_D.png"
            },
            "pic_M1911_4514.png": {
                "cn": "M1911-天空的击破者",
                "icon": "Icon_M1911_4514.png",
                "alt": "pic_M1911_4514_D.png",
                "kr": "M1911 - 천공을 뚫는 자",
                "jp": "天空を破りし者",
                "en": "Breaker of the Sky"
            }
        },
        "kr": "M1911",
        "jp": "M1911",
        "en": "M1911",
        "moddedIcon": "Icon_M1911Mod.png",
        "modRarity": 4
    },
    "3": {
        "type": "HG",
        "id": "3",
        "cn": "M9",
        "code": "M9",
        "icon": "Icon_M9.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_M9.png": {
                "cn": "M9",
                "kr": "M9",
                "jp": "M9",
                "en": "M9",
                "alt": "pic_M9_D.png"
            }
        },
        "kr": "M9",
        "jp": "M9",
        "en": "M9"
    },
    "4": {
        "type": "HG",
        "id": "4",
        "cn": "蟒蛇",
        "code": "Python",
        "icon": "Icon_Python.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_Python.png": {
                "cn": "蟒蛇",
                "kr": "콜트 파이슨",
                "jp": "パイソン",
                "en": "Python",
                "alt": "pic_Python_D.png"
            },
            "pic_Python_6603.png": {
                "cn": "蟒蛇-狩猎时刻",
                "icon": "Icon_Python_6603.png",
                "alt": "pic_Python_6603_D.png",
                "kr": "콜트 파이슨 - 추위사냥",
                "jp": "狩りの刻",
                "en": ""
            }
        },
        "kr": "콜트 파이슨",
        "jp": "パイソン",
        "en": "Python"
    },
    "5": {
        "type": "HG",
        "id": "5",
        "cn": "纳甘左轮",
        "code": "M1895",
        "icon": "Icon_M1895.png",
        "modded": true,
        "rarity": 2,
        "skins": {
            "pic_M1895.png": {
                "cn": "纳甘左轮",
                "kr": "나강 리볼버",
                "jp": "M1895",
                "en": "M1895",
                "alt": "pic_M1895_D.png"
            },
            "pic_M1895Mod.png": {
                "cn": "纳甘左轮",
                "kr": "나강 리볼버",
                "jp": "M1895",
                "en": "M1895",
                "icon": "mod",
                "alt": "pic_M1895Mod_D.png"
            },
            "pic_M1895_2706.png": {
                "cn": "纳甘左轮-群星之绊",
                "icon": "Icon_M1895_2706.png",
                "alt": "pic_M1895_2706_D.png",
                "kr": "나강 리볼버 - 별들의 유대",
                "jp": "星々のキズナ",
                "en": "Astral Bond"
            },
            "pic_M1895_5309.png": {
                "cn": "纳甘左轮-胭雪公主",
                "icon": "Icon_M1895_5309.png",
                "alt": "pic_M1895_5309_D.png",
                "kr": "나강 리볼버 - 눈꽃공주",
                "en": "Rouge Snow Princess"
            },
            "pic_M1895_7107.png": {
                "cn": "纳甘左轮-星云忌廉",
                "icon": "Icon_M1895_7107.png",
                "alt": "pic_M1895_7107_D.png",
                "kr": "나강 리볼버 - 네뷸라 크림",
                "en": ""
            }
        },
        "kr": "나강 리볼버",
        "jp": "M1895",
        "en": "M1895",
        "moddedIcon": "Icon_M1895Mod.png",
        "modRarity": 4
    },
    "6": {
        "type": "HG",
        "id": "6",
        "cn": "托卡列夫",
        "code": "TT33",
        "icon": "Icon_TT33.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_TT33.png": {
                "cn": "托卡列夫",
                "kr": "토카레프",
                "jp": "トカレフ",
                "en": "Tokarev",
                "alt": "pic_TT33_D.png"
            },
            "pic_TT33_601.png": {
                "cn": "托卡列夫-两人的旅程",
                "icon": "Icon_TT33_601.png",
                "alt": "pic_TT33_601_D.png",
                "kr": "토카레프 - 두 사람의 인생",
                "jp": "二人の旅路",
                "en": "A Couple's Journey"
            },
            "pic_TT33_3204.png": {
                "cn": "托卡列夫-格里芬的舞娘",
                "icon": "Icon_TT33_3204.png",
                "alt": "pic_TT33_3204_D.png",
                "kr": "토카레프 - 그리폰의 무희",
                "jp": "グリフィンの舞姫",
                "en": "Griffin's Dancer"
            },
            "pic_TT33_5106.png": {
                "cn": "托卡列夫-甜夜盗贼",
                "icon": "Icon_TT33_5106.png",
                "alt": "pic_TT33_5106_D.png",
                "kr": "토카레프 - 괴도 스위티",
                "jp": "甘い夜の怪盗",
                "en": "Thief of Sweetness"
            },
            "pic_TT33_6205.png": {
                "cn": "托卡列夫-深巷的落雪",
                "icon": "Icon_TT33_6205.png",
                "alt": "pic_TT33_6205_D.png",
                "kr": "토카레프 - 눈 내리는 오솔길",
                "jp": "路地奥の雪",
                "en": "Snowfall in the Alley"
            }
        },
        "kr": "토카레프",
        "jp": "トカレフ",
        "en": "Tokarev"
    },
    "7": {
        "type": "HG",
        "id": "7",
        "cn": "斯捷奇金",
        "code": "APS",
        "icon": "Icon_APS.png",
        "modded": true,
        "rarity": 4,
        "skins": {
            "pic_APS.png": {
                "cn": "斯捷奇金",
                "kr": "스테츠킨",
                "jp": "スチェッキン",
                "en": "Stechkin",
                "alt": "pic_APS_D.png"
            },
            "pic_APSMod.png": {
                "cn": "斯捷奇金",
                "kr": "스테츠킨",
                "jp": "スチェッキン",
                "en": "Stechkin",
                "icon": "mod",
                "alt": "pic_APSMod_D.png"
            },
            "pic_APS_4306.png": {
                "cn": "斯捷奇金-山茶小姐的特别服务",
                "icon": "Icon_APS_4306.png",
                "alt": "pic_APS_4306_D.png",
                "kr": "스테츠킨 - 미스 동백꽃의 특별 서비스",
                "jp": "ミセスツバキのスペシャルサービス",
                "en": "Miss Camellia's Special Service"
            },
            "pic_APS_6808.png": {
                "cn": "斯捷奇金-桃夭灼",
                "icon": "Icon_APS_6808.png",
                "alt": "pic_APS_6808_D.png",
                "kr": "스테츠킨 - 봉숭아 봉오리",
                "jp": "桃夭灼",
                "en": ""
            }
        },
        "kr": "스테츠킨",
        "jp": "スチェッキン",
        "en": "Stechkin",
        "moddedIcon": "Icon_APSMod.png",
        "modRarity": 5
    },
    "8": {
        "type": "HG",
        "id": "8",
        "cn": "马卡洛夫",
        "code": "PM",
        "icon": "Icon_PM.png",
        "modded": true,
        "rarity": 3,
        "skins": {
            "pic_PM.png": {
                "cn": "马卡洛夫",
                "kr": "마카로프",
                "jp": "マカロフ",
                "en": "Makarov",
                "alt": "pic_PM_D.png"
            },
            "pic_PMMod.png": {
                "cn": "马卡洛夫",
                "kr": "마카로프",
                "jp": "マカロフ",
                "en": "Makarov",
                "icon": "mod",
                "alt": "pic_PMMod_D.png"
            },
            "pic_PM_1.png": {
                "cn": "马卡洛夫-南瓜熊熊",
                "icon": "Icon_PM_1.png",
                "alt": "pic_PM_1_D.png",
                "kr": "마카로프 - 잭오랜턴",
                "jp": "かぼちゃクマさん",
                "en": "Pumpkin Mishka"
            },
            "pic_PM_4310.png": {
                "cn": "马卡洛夫-某不科学的向日葵",
                "icon": "Icon_PM_4310.png",
                "alt": "pic_PM_4310_D.png",
                "kr": "마카로프 - 환상 같은 해바라기",
                "jp": "とある非科学の向日葵",
                "en": "A Certain Unscientific Sunflower"
            }
        },
        "kr": "마카로프",
        "jp": "マカロフ",
        "en": "Makarov",
        "moddedIcon": "Icon_PMMod.png",
        "modRarity": 4
    },
    "9": {
        "type": "HG",
        "id": "9",
        "cn": "P38",
        "code": "P38",
        "icon": "Icon_P38.png",
        "modded": false,
        "rarity": 2,
        "skins": {
            "pic_P38.png": {
                "cn": "P38",
                "kr": "P38",
                "jp": "P38",
                "en": "P38",
                "alt": "pic_P38_D.png"
            },
            "pic_P38_2410.png": {
                "cn": "P38-魔女高徒",
                "icon": "Icon_P38_2410.png",
                "alt": "pic_P38_2410_D.png",
                "kr": "P38 - 여름보다 뜨거운 인형",
                "jp": "魔女の高弟",
                "en": "Apprentice Witch"
            }
        },
        "kr": "P38",
        "jp": "P38",
        "en": "P38"
    },
    "10": {
        "type": "HG",
        "id": "10",
        "cn": "PPK",
        "code": "PPK",
        "icon": "Icon_PPK.png",
        "modded": true,
        "rarity": 2,
        "skins": {
            "pic_PPK.png": {
                "cn": "PPK",
                "kr": "PPK",
                "jp": "PPK",
                "en": "PPK",
                "alt": "pic_PPK_D.png"
            },
            "pic_PPKMod.png": {
                "cn": "PPK",
                "kr": "PPK",
                "jp": "PPK",
                "en": "PPK",
                "icon": "mod",
                "alt": "pic_PPKMod_D.png"
            },
            "pic_PPK_3905.png": {
                "cn": "PPK-烈旋音波",
                "icon": "Icon_PPK_3905.png",
                "alt": "pic_PPK_3905_D.png",
                "kr": "PPK - 터뷸런스 소닉",
                "jp": "音速烈旋",
                "en": "Mach Tempest"
            },
            "pic_PPK_6109.png": {
                "cn": "PPK-恋如树影",
                "icon": "Icon_PPK_6109.png",
                "alt": "pic_PPK_6109_D.png",
                "kr": "PPK - 연심은 그늘처럼",
                "jp": "恋は木陰のように",
                "en": "Foliage Romance"
            }
        },
        "kr": "PPK",
        "jp": "PPK",
        "en": "PPK",
        "moddedIcon": "Icon_PPKMod.png",
        "modRarity": 4
    },
    "11": {
        "type": "HG",
        "id": "11",
        "cn": "P08",
        "code": "P08",
        "icon": "Icon_P08.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_P08.png": {
                "cn": "P08",
                "kr": "P08",
                "jp": "P08",
                "en": "P08",
                "alt": "pic_P08_D.png"
            }
        },
        "kr": "P08",
        "jp": "P08",
        "en": "P08"
    },
    "12": {
        "type": "HG",
        "id": "12",
        "cn": "C96",
        "code": "C96",
        "icon": "Icon_C96.png",
        "modded": true,
        "rarity": 3,
        "skins": {
            "pic_C96.png": {
                "cn": "C96",
                "kr": "C96",
                "jp": "C96",
                "en": "C96",
                "alt": "pic_C96_D.png"
            },
            "pic_C96Mod.png": {
                "cn": "C96",
                "kr": "C96",
                "jp": "C96",
                "en": "C96",
                "icon": "mod",
                "alt": "pic_C96Mod_D.png"
            }
        },
        "kr": "C96",
        "jp": "C96",
        "en": "C96",
        "moddedIcon": "Icon_C96Mod.png",
        "modRarity": 4
    },
    "13": {
        "type": "HG",
        "id": "13",
        "cn": "92式",
        "code": "92type",
        "icon": "Icon_92type.png",
        "modded": true,
        "rarity": 3,
        "skins": {
            "pic_92type.png": {
                "cn": "92式",
                "kr": "92식",
                "jp": "92式",
                "en": "Type92",
                "alt": "pic_92type_D.png"
            },
            "pic_92typeMod.png": {
                "cn": "92式",
                "kr": "92식",
                "jp": "92式",
                "en": "Type92",
                "icon": "mod",
                "alt": "pic_92typeMod_D.png"
            },
            "pic_92type_5507.png": {
                "cn": "92式-吻琼苞",
                "icon": "Icon_92type_5507.png",
                "alt": "pic_92type_5507_D.png",
                "kr": "92식 - 꽃봉오리에 입맞춤",
                "jp": "",
                "en": "Snowflake's Kiss"
            }
        },
        "kr": "92식",
        "jp": "92式",
        "en": "Type92",
        "moddedIcon": "Icon_92typeMod.png",
        "modRarity": 4
    },
    "14": {
        "type": "HG",
        "id": "14",
        "cn": "阿斯特拉左轮",
        "code": "357",
        "icon": "Icon_357.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_357.png": {
                "cn": "阿斯特拉左轮",
                "kr": "아스트라 리볼버",
                "jp": "アストラ",
                "en": "Astra",
                "alt": "pic_357_D.png"
            },
            "pic_357_4708.png": {
                "cn": "阿斯特拉左轮-阿斯特拉的泳池漂流",
                "icon": "Icon_357_4708.png",
                "alt": "pic_357_4708_D.png",
                "kr": "아스트라 리볼버 - 아스트라의 표류기",
                "jp": "アストラのプール漂流記",
                "en": "Astra's Pool Adventures"
            }
        },
        "kr": "아스트라 리볼버",
        "jp": "アストラ",
        "en": "Astra"
    },
    "15": {
        "type": "HG",
        "id": "15",
        "cn": "格洛克17",
        "code": "Glock17",
        "icon": "Icon_Glock17.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_Glock17.png": {
                "cn": "格洛克17",
                "kr": "글록17",
                "jp": "G17",
                "en": "G17",
                "alt": "pic_Glock17_D.png"
            }
        },
        "kr": "글록17",
        "jp": "G17",
        "en": "G17"
    },
    "16": {
        "type": "SMG",
        "id": "16",
        "cn": "汤姆森",
        "code": "M1928A1",
        "icon": "Icon_M1928A1.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_M1928A1.png": {
                "cn": "汤姆森",
                "kr": "톰슨",
                "jp": "トンプソン",
                "en": "Thompson",
                "alt": "pic_M1928A1_D.png"
            },
            "pic_M1928A1_1501.png": {
                "cn": "汤姆森-恶魔猎人",
                "icon": "Icon_M1928A1_1501.png",
                "alt": "pic_M1928A1_1501_D.png",
                "kr": "톰슨 - 데빌 헌터",
                "jp": "デモンハンター",
                "en": "Demon Hunter"
            },
            "pic_M1928A1_5703.png": {
                "cn": "汤姆森-无间般若",
                "icon": "Icon_M1928A1_5703.png",
                "alt": "pic_M1928A1_5703_D.png",
                "kr": "톰슨 - 진실의 방으로",
                "jp": "双竜般若",
                "en": "Infernal Hannya"
            }
        },
        "kr": "톰슨",
        "jp": "トンプソン",
        "en": "Thompson"
    },
    "17": {
        "type": "SMG",
        "id": "17",
        "cn": "M3",
        "code": "M3",
        "icon": "Icon_M3.png",
        "modded": false,
        "rarity": 2,
        "skins": {
            "pic_M3.png": {
                "cn": "M3",
                "kr": "M3",
                "jp": "M3",
                "en": "M3",
                "alt": "pic_M3_D.png"
            }
        },
        "kr": "M3",
        "jp": "M3",
        "en": "M3"
    },
    "18": {
        "type": "SMG",
        "id": "18",
        "cn": "MAC-10",
        "code": "MAC10",
        "icon": "Icon_MAC10.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_MAC10.png": {
                "cn": "MAC-10",
                "kr": "MAC-10",
                "jp": "イングラム",
                "en": "Ingram",
                "alt": "pic_MAC10_D.png"
            }
        },
        "kr": "MAC-10",
        "jp": "イングラム",
        "en": "Ingram"
    },
    "19": {
        "type": "SMG",
        "id": "19",
        "cn": "FMG-9",
        "code": "FMG9",
        "icon": "Icon_FMG9.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_FMG9.png": {
                "cn": "FMG-9",
                "kr": "FMG-9",
                "jp": "FMG-9",
                "en": "FMG-9",
                "alt": "pic_FMG9_D.png"
            }
        },
        "kr": "FMG-9",
        "jp": "FMG-9",
        "en": "FMG-9"
    },
    "20": {
        "type": "SMG",
        "id": "20",
        "cn": "维克托",
        "code": "Vector",
        "icon": "Icon_Vector.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_Vector.png": {
                "cn": "维克托",
                "kr": "Vector",
                "jp": "Vector",
                "en": "Vector",
                "alt": "pic_Vector_D.png"
            },
            "pic_Vector_2.png": {
                "cn": "维克托-猫猫肉垫",
                "icon": "Icon_Vector_2.png",
                "alt": "pic_Vector_2_D.png",
                "kr": "Vector - 고양이 발바닥",
                "jp": "にゃんこヴェクター",
                "en": "Kitty Paws"
            },
            "pic_Vector_549.png": {
                "cn": "维克托-地狱火",
                "icon": "Icon_Vector_549.png",
                "alt": "pic_Vector_549_D.png",
                "kr": "Vector - 헬파이어",
                "jp": "ヘルファイア",
                "en": "Hellfire"
            },
            "pic_Vector_1901.png": {
                "cn": "维克托-盲信者",
                "icon": "Icon_Vector_1901.png",
                "alt": "pic_Vector_1901_D.png",
                "kr": "Vector- 맹목적인 믿음",
                "jp": "盲信者",
                "en": "Ardent Devotion"
            },
            "pic_Vector_6701.png": {
                "cn": "维克托-携枝踏玉尘",
                "icon": "Icon_Vector_6701.png",
                "alt": "pic_Vector_6701_D.png",
                "kr": "Vector - 눈밭을 즈려밟으며",
                "jp": "枝を携え玉塵を踏む",
                "en": ""
            }
        },
        "kr": "Vector",
        "jp": "Vector",
        "en": "Vector"
    },
    "21": {
        "type": "SMG",
        "id": "21",
        "cn": "PPSh-41",
        "code": "PPsh41",
        "icon": "Icon_PPsh41.png",
        "modded": true,
        "rarity": 2,
        "skins": {
            "pic_PPsh41.png": {
                "cn": "PPSh-41",
                "kr": "PPSh-41",
                "jp": "PPSh-41",
                "en": "PPSh-41",
                "alt": "pic_PPsh41_D.png"
            },
            "pic_PPsh41Mod.png": {
                "cn": "PPSh-41",
                "kr": "PPSh-41",
                "jp": "PPSh-41",
                "en": "PPSh-41",
                "icon": "mod",
                "alt": "pic_PPsh41Mod_D.png"
            },
            "pic_PPsh41_602.png": {
                "cn": "PPsh-41-契约时刻",
                "icon": "Icon_PPsh41_602.png",
                "alt": "pic_PPsh41_602_D.png",
                "kr": "PPsh-41 - 계약 시간",
                "jp": "約束の時",
                "en": "Moment of Vows"
            },
            "pic_PPsh41_5808.png": {
                "cn": "PPSh-41-气球的彼端",
                "icon": "Icon_PPsh41_5808.png",
                "alt": "pic_PPsh41_5808_D.png",
                "kr": "PPSh-41 - 풍선 저 너머에",
                "jp": "風船の彼方",
                "en": "Beyond the Balloon"
            }
        },
        "kr": "PPSh-41",
        "jp": "PPSh-41",
        "en": "PPSh-41",
        "moddedIcon": "Icon_PPsh41Mod.png",
        "modRarity": 4
    },
    "22": {
        "type": "SMG",
        "id": "22",
        "cn": "PPS-43",
        "code": "PPS43",
        "icon": "Icon_PPS43.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_PPS43.png": {
                "cn": "PPS-43",
                "kr": "PPS-43",
                "jp": "PPS-43",
                "en": "PPS-43",
                "alt": "pic_PPS43_D.png"
            }
        },
        "kr": "PPS-43",
        "jp": "PPS-43",
        "en": "PPS-43"
    },
    "23": {
        "type": "SMG",
        "id": "23",
        "cn": "PP-90",
        "code": "PP90",
        "icon": "Icon_PP90.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_PP90.png": {
                "cn": "PP-90",
                "kr": "PP-90",
                "jp": "PP-90",
                "en": "PP-90",
                "alt": "pic_PP90_D.png"
            }
        },
        "kr": "PP-90",
        "jp": "PP-90",
        "en": "PP-90"
    },
    "24": {
        "type": "SMG",
        "id": "24",
        "cn": "PP-2000",
        "code": "PP2000",
        "icon": "Icon_PP2000.png",
        "modded": false,
        "rarity": 2,
        "skins": {
            "pic_PP2000.png": {
                "cn": "PP-2000",
                "kr": "PP-2000",
                "jp": "PP-2000",
                "en": "PP-2000",
                "alt": "pic_PP2000_D.png"
            }
        },
        "kr": "PP-2000",
        "jp": "PP-2000",
        "en": "PP-2000"
    },
    "25": {
        "type": "SMG",
        "id": "25",
        "cn": "MP40",
        "code": "MP40",
        "icon": "Icon_MP40.png",
        "modded": false,
        "rarity": 2,
        "skins": {
            "pic_MP40.png": {
                "cn": "MP40",
                "kr": "MP40",
                "jp": "MP40",
                "en": "MP40",
                "alt": "pic_MP40_D.png"
            },
            "pic_MP40_902.png": {
                "cn": "MP40-拇指公主",
                "icon": "Icon_MP40_902.png",
                "alt": "pic_MP40_902_D.png",
                "kr": "MP40 - 엄지공주",
                "jp": "親指姫",
                "en": "Thumbelina"
            }
        },
        "kr": "MP40",
        "jp": "MP40",
        "en": "MP40"
    },
    "26": {
        "type": "SMG",
        "id": "26",
        "cn": "MP5",
        "code": "MP5",
        "icon": "Icon_MP5.png",
        "modded": true,
        "rarity": 4,
        "skins": {
            "pic_MP5.png": {
                "cn": "MP5",
                "kr": "MP5",
                "jp": "Gr MP5",
                "en": "Gr MP5",
                "alt": "pic_MP5_D.png"
            },
            "pic_MP5Mod.png": {
                "cn": "MP5",
                "kr": "MP5",
                "jp": "Gr MP5",
                "en": "Gr MP5",
                "icon": "mod",
                "alt": "pic_MP5Mod_D.png"
            },
            "pic_MP5_3.png": {
                "cn": "MP5-暗夜使魔",
                "icon": "Icon_MP5_3.png",
                "alt": "pic_MP5_3_D.png",
                "kr": "MP5 - 드라큘라",
                "jp": "闇夜の使い魔",
                "en": "Nocturnal Familiar"
            },
            "pic_MP5_1205.png": {
                "cn": "MP5-花未眠",
                "icon": "Icon_MP5_1205.png",
                "alt": "pic_MP5_1205_D.png",
                "kr": "MP5 - 잠들지 않는 꽃",
                "jp": "花は眠らない",
                "en": "Sleepless Begonias"
            },
            "pic_MP5_1903.png": {
                "cn": "MP5-小小的一步",
                "icon": "Icon_MP5_1903.png",
                "alt": "pic_MP5_1903_D.png",
                "kr": "MP5 - 작은 한 걸음",
                "jp": "小さな一歩",
                "en": "A Small Step"
            },
            "pic_MP5_3006.png": {
                "cn": "MP5-山苏子",
                "icon": "Icon_MP5_3006.png",
                "alt": "pic_MP5_3006_D.png",
                "kr": "MP5 - 야지마",
                "jp": "踊子草",
                "en": "Vietnamese Balm"
            }
        },
        "kr": "MP5",
        "jp": "Gr MP5",
        "en": "Gr MP5",
        "moddedIcon": "Icon_MP5Mod.png",
        "modRarity": 5
    },
    "27": {
        "type": "SMG",
        "id": "27",
        "cn": "蝎式",
        "code": "VZ61",
        "icon": "Icon_VZ61.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_VZ61.png": {
                "cn": "蝎式",
                "kr": "스콜피온",
                "jp": "スコーピオン",
                "en": "Skorpion",
                "alt": "pic_VZ61_D.png"
            },
            "pic_VZ61_801.png": {
                "cn": "蝎式-深红的星途",
                "icon": "Icon_VZ61_801.png",
                "alt": "pic_VZ61_801_D.png",
                "kr": "스콜피온 - 붉은 은하수",
                "jp": "スカーレットスター",
                "en": "Crimson Starlet"
            }
        },
        "kr": "스콜피온",
        "jp": "スコーピオン",
        "en": "Skorpion"
    },
    "28": {
        "type": "SMG",
        "id": "28",
        "cn": "MP7",
        "code": "MP7",
        "icon": "Icon_MP7.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_MP7.png": {
                "cn": "MP7",
                "kr": "MP7",
                "jp": "Gr MP7",
                "en": "Gr MP7",
                "alt": "pic_MP7_D.png"
            },
            "pic_MP7_2405.png": {
                "cn": "MP7-糖果枪弹",
                "icon": "Icon_MP7_2405.png",
                "alt": "pic_MP7_2405_D.png",
                "kr": "MP7 - 사탕발린 총알",
                "jp": "砂糖菓子の銃弾は撃ちぬけない",
                "en": "Lollipop Ammo"
            },
            "pic_MP7_6806.png": {
                "cn": "MP7-天星落",
                "icon": "Icon_MP7_6806.png",
                "alt": "pic_MP7_6806_D.png",
                "kr": "MP7 - 폴링 블루스타",
                "jp": "天星落",
                "en": ""
            }
        },
        "kr": "MP7",
        "jp": "Gr MP7",
        "en": "Gr MP7"
    },
    "29": {
        "type": "SMG",
        "id": "29",
        "cn": "司登MkⅡ",
        "code": "StenMK2",
        "icon": "Icon_StenMK2.png",
        "modded": true,
        "rarity": 3,
        "skins": {
            "pic_StenMK2.png": {
                "cn": "司登MkⅡ",
                "kr": "스텐MkⅡ",
                "jp": "ステンMK-II",
                "en": "STEN MkⅡ",
                "alt": "pic_StenMK2_D.png"
            },
            "pic_StenMK2Mod.png": {
                "cn": "司登MkⅡ",
                "kr": "스텐MkⅡ",
                "jp": "ステンMK-II",
                "en": "STEN MkⅡ",
                "icon": "mod",
                "alt": "pic_StenMK2Mod_D.png"
            },
            "pic_StenMK2_603.png": {
                "cn": "司登MkⅡ-被回应的心意",
                "icon": "Icon_StenMK2_603.png",
                "alt": "pic_StenMK2_603_D.png",
                "kr": "스텐 MkⅡ - 마음의 대답",
                "jp": "届いた想い",
                "en": "Reciprocated Love"
            }
        },
        "kr": "스텐MkⅡ",
        "jp": "ステンMK-II",
        "en": "STEN MkⅡ",
        "moddedIcon": "Icon_StenMK2Mod.png",
        "modRarity": 4
    },
    "31": {
        "type": "SMG",
        "id": "31",
        "cn": "伯莱塔38型",
        "code": "MAB38",
        "icon": "Icon_MAB38.png",
        "modded": true,
        "rarity": 2,
        "skins": {
            "pic_MAB38.png": {
                "cn": "伯莱塔38型",
                "kr": "베레타 38형",
                "jp": "M38",
                "en": "M38",
                "alt": "pic_MAB38_D.png"
            },
            "pic_MAB38Mod.png": {
                "cn": "伯莱塔38型",
                "kr": "베레타 38형",
                "jp": "M38",
                "en": "M38",
                "icon": "mod",
                "alt": "pic_MAB38Mod_D.png"
            }
        },
        "kr": "베레타 38형",
        "jp": "M38",
        "en": "M38",
        "moddedIcon": "Icon_MAB38Mod.png",
        "modRarity": 4
    },
    "32": {
        "type": "SMG",
        "id": "32",
        "cn": "微型乌兹",
        "code": "MicroUZI",
        "icon": "Icon_MicroUZI.png",
        "modded": true,
        "rarity": 3,
        "skins": {
            "pic_MicroUZI.png": {
                "cn": "微型乌兹",
                "kr": "마이크로 우지",
                "jp": "Micro Uzi",
                "en": "Micro Uzi",
                "alt": "pic_MicroUZI_D.png"
            },
            "pic_MicroUZIMod.png": {
                "cn": "微型乌兹",
                "kr": "마이크로 우지",
                "jp": "Micro Uzi",
                "en": "Micro Uzi",
                "icon": "mod",
                "alt": "pic_MicroUZIMod_D.png"
            },
            "pic_MicroUZI_101.png": {
                "cn": "微型乌兹-睡醒的笨蛋",
                "icon": "Icon_MicroUZI_101.png",
                "alt": "pic_MicroUZI_101_D.png",
                "kr": "마이크로 우지 - 잠에서 깬 바보",
                "jp": "寝起きのおバカさん",
                "en": "Dorky Sleepyhead"
            }
        },
        "kr": "마이크로 우지",
        "jp": "Micro Uzi",
        "en": "Micro Uzi",
        "moddedIcon": "Icon_MicroUZIMod.png",
        "modRarity": 4
    },
    "33": {
        "type": "SMG",
        "id": "33",
        "cn": "m45",
        "code": "m45",
        "icon": "Icon_m45.png",
        "modded": false,
        "rarity": 2,
        "skins": {
            "pic_m45.png": {
                "cn": "m45",
                "kr": "m45",
                "jp": "m45",
                "en": "m45",
                "alt": "pic_m45_D.png"
            },
            "pic_m45_4.png": {
                "cn": "M45-糖果快递",
                "icon": "Icon_m45_4.png",
                "alt": "pic_m45_4_D.png",
                "kr": "M45 - 과자 배달부",
                "jp": "キャンディ・エクスプレス",
                "en": "Candy Express"
            }
        },
        "kr": "m45",
        "jp": "m45",
        "en": "m45"
    },
    "34": {
        "type": "RF",
        "id": "34",
        "cn": "M1加兰德",
        "code": "M1",
        "icon": "Icon_M1.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_M1.png": {
                "cn": "M1加兰德",
                "kr": "M1 개런드",
                "jp": "M1ガーランド",
                "en": "M1 Garand",
                "alt": "pic_M1_D.png"
            },
            "pic_M1_1106.png": {
                "cn": "M1加兰德-沙滩公主",
                "icon": "Icon_M1_1106.png",
                "alt": "pic_M1_1106_D.png",
                "kr": "M1개런드 - 해변의 공주",
                "jp": "ビーチプリンセス",
                "en": "Beach Princess"
            },
            "pic_M1_6907.png": {
                "cn": "M1加兰德-冬柏来信",
                "icon": "Icon_M1_6907.png",
                "alt": "pic_M1_6907_D.png",
                "kr": "M1 개런드 - 동백의 편지",
                "jp": "",
                "en": ""
            }
        },
        "kr": "M1 개런드",
        "jp": "M1ガーランド",
        "en": "M1 Garand"
    },
    "35": {
        "type": "RF",
        "id": "35",
        "cn": "M1A1",
        "code": "M1A1",
        "icon": "Icon_M1A1.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_M1A1.png": {
                "cn": "M1A1",
                "kr": "M1A1",
                "jp": "M1A1",
                "en": "M1A1",
                "alt": "pic_M1A1_D.png"
            },
            "pic_M1A1_4106.png": {
                "cn": "M1A1-红梅照雪",
                "icon": "Icon_M1A1_4106.png",
                "alt": "pic_M1A1_4106_D.png",
                "kr": "M1A1 - 백설 홍매화",
                "jp": "紅梅白雪",
                "en": "Red Plum and White Snow"
            }
        },
        "kr": "M1A1",
        "jp": "M1A1",
        "en": "M1A1"
    },
    "36": {
        "type": "RF",
        "id": "36",
        "cn": "春田",
        "code": "M1903",
        "icon": "Icon_M1903.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_M1903.png": {
                "cn": "春田",
                "kr": "스프링필드",
                "jp": "スプリングフィールド",
                "en": "Springfield",
                "alt": "pic_M1903_D.png"
            },
            "pic_M1903_5.png": {
                "cn": "春田-古典派女巫",
                "icon": "Icon_M1903_5.png",
                "alt": "pic_M1903_5_D.png",
                "kr": "스프링필드 - 정통파 마녀",
                "jp": "古典派魔女",
                "en": "Classic Witch"
            },
            "pic_M1903_302.png": {
                "cn": "春田-圣善夜的祝福",
                "icon": "Icon_M1903_302.png",
                "alt": "pic_M1903_302_D.png",
                "kr": "스프링필드 - 성스러운 밤의 축복",
                "jp": "ホーリーナイトの祝福",
                "en": "O Holy Night"
            },
            "pic_M1903_802.png": {
                "cn": "春田-灯火下的女王",
                "icon": "Icon_M1903_802.png",
                "alt": "pic_M1903_802_D.png",
                "kr": "스프링필드 - 등불 아래의 여왕",
                "jp": "灯下のクイーン",
                "en": "Queen in Radiance"
            },
            "pic_M1903_1107.png": {
                "cn": "春田-睡醒的人鱼",
                "icon": "Icon_M1903_1107.png",
                "alt": "pic_M1903_1107_D.png",
                "kr": "스프링필드 - 잠에서 깬 인어",
                "jp": "目覚めたマーメイド",
                "en": "Stirring Mermaid"
            }
        },
        "kr": "스프링필드",
        "jp": "スプリングフィールド",
        "en": "Springfield"
    },
    "37": {
        "type": "RF",
        "id": "37",
        "cn": "M14",
        "code": "M14",
        "icon": "Icon_M14.png",
        "modded": true,
        "rarity": 3,
        "skins": {
            "pic_M14.png": {
                "cn": "M14",
                "kr": "M14",
                "jp": "M14",
                "en": "M14",
                "alt": "pic_M14_D.png"
            },
            "pic_M14Mod.png": {
                "cn": "M14",
                "kr": "M14",
                "jp": "M14",
                "en": "M14",
                "icon": "mod",
                "alt": "pic_M14Mod_D.png"
            },
            "pic_M14_303.png": {
                "cn": "M14-圣诞巡游礼服",
                "icon": "Icon_M14_303.png",
                "alt": "pic_M14_303_D.png",
                "kr": "M14 - 성탄절 퍼레이드 의상",
                "jp": "クリスマス・ドレス",
                "en": "Xmas Parade"
            },
            "pic_M14_6707.png": {
                "cn": "M14-幼虎祈丰年",
                "icon": "Icon_M14_6707.png",
                "alt": "pic_M14_6707_D.png",
                "kr": "M14 - 풍년을 부르는 아기 범",
                "jp": "豊年祈る幼虎",
                "en": ""
            }
        },
        "kr": "M14",
        "jp": "M14",
        "en": "M14",
        "moddedIcon": "Icon_M14Mod.png",
        "modRarity": 4
    },
    "38": {
        "type": "RF",
        "id": "38",
        "cn": "M21",
        "code": "M21",
        "icon": "Icon_M21.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_M21.png": {
                "cn": "M21",
                "kr": "M21",
                "jp": "M21",
                "en": "M21",
                "alt": "pic_M21_D.png"
            },
            "pic_M21_304.png": {
                "cn": "M21-圣诞居家礼服",
                "icon": "Icon_M21_304.png",
                "alt": "pic_M21_304_D.png",
                "kr": "M21 - 성탄절 실내복",
                "jp": "聖夜のルームウェア",
                "en": "Xmas At Home"
            },
            "pic_M21_5107.png": {
                "cn": "M21-魇域守门人",
                "icon": "Icon_M21_5107.png",
                "alt": "pic_M21_5107_D.png",
                "kr": "M21 - 마경 문지기",
                "jp": "",
                "en": ""
            }
        },
        "kr": "M21",
        "jp": "M21",
        "en": "M21"
    },
    "39": {
        "type": "RF",
        "id": "39",
        "cn": "莫辛-纳甘",
        "code": "M1891",
        "icon": "Icon_M1891.png",
        "modded": true,
        "rarity": 4,
        "skins": {
            "pic_M1891.png": {
                "cn": "莫辛-纳甘",
                "kr": "모신나강",
                "jp": "モシン・ナガン",
                "en": "Mosin-Nagant",
                "alt": "pic_M1891_D.png"
            },
            "pic_M1891Mod.png": {
                "cn": "莫辛-纳甘",
                "kr": "모신나강",
                "jp": "モシン・ナガン",
                "en": "Mosin-Nagant",
                "icon": "mod",
                "alt": "pic_M1891Mod_D.png"
            },
            "pic_M1891_803.png": {
                "cn": "莫辛-纳甘-月之海",
                "icon": "Icon_M1891_803.png",
                "alt": "pic_M1891_803_D.png",
                "kr": "모신-나강 - 달빛 바다",
                "jp": "月の海",
                "en": "Moonlit Ocean"
            },
            "pic_M1891_4803.png": {
                "cn": "莫辛-纳甘-白钢锐刃",
                "icon": "Icon_M1891_4803.png",
                "alt": "pic_M1891_4803_D.png",
                "kr": "모신나강 - 무쇠 칼날",
                "jp": "白銀の刃",
                "en": "Blade of White Steel"
            }
        },
        "kr": "모신나강",
        "jp": "モシン・ナガン",
        "en": "Mosin-Nagant",
        "moddedIcon": "Icon_M1891Mod.png",
        "modRarity": 5
    },
    "40": {
        "type": "RF",
        "id": "40",
        "cn": "SVT-38",
        "code": "SVT38",
        "icon": "Icon_SVT38.png",
        "modded": false,
        "rarity": 2,
        "skins": {
            "pic_SVT38.png": {
                "cn": "SVT-38",
                "kr": "SVT-38",
                "jp": "SVT-38",
                "en": "SVT-38",
                "alt": "pic_SVT38_D.png"
            }
        },
        "kr": "SVT-38",
        "jp": "SVT-38",
        "en": "SVT-38"
    },
    "41": {
        "type": "RF",
        "id": "41",
        "cn": "西蒙诺夫",
        "code": "SKS",
        "icon": "Icon_SKS.png",
        "modded": false,
        "rarity": 2,
        "skins": {
            "pic_SKS.png": {
                "cn": "西蒙诺夫",
                "kr": "시모노프",
                "jp": "SKS",
                "en": "SKS",
                "alt": "pic_SKS_D.png"
            }
        },
        "kr": "시모노프",
        "jp": "SKS",
        "en": "SKS"
    },
    "42": {
        "type": "RF",
        "id": "42",
        "cn": "PTRD",
        "code": "PTRD",
        "icon": "Icon_PTRD.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_PTRD.png": {
                "cn": "PTRD",
                "kr": "PTRD",
                "jp": "PTRD",
                "en": "PTRD",
                "alt": "pic_PTRD_D.png"
            },
            "pic_PTRD_408.png": {
                "cn": "PTRD-浪漫任务",
                "icon": "Icon_PTRD_408.png",
                "alt": "pic_PTRD_408_D.png",
                "kr": "PTRD - 로맨틱한 임무",
                "jp": "ロマンチックな任務",
                "en": "Romantic Mission"
            }
        },
        "kr": "PTRD",
        "jp": "PTRD",
        "en": "PTRD"
    },
    "43": {
        "type": "RF",
        "id": "43",
        "cn": "SVD",
        "code": "SVD",
        "icon": "Icon_SVD.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_SVD.png": {
                "cn": "SVD",
                "kr": "SVD",
                "jp": "SVD",
                "en": "SVD",
                "alt": "pic_SVD_D.png"
            },
            "pic_SVD_305.png": {
                "cn": "SVD-冬日仙女",
                "icon": "Icon_SVD_305.png",
                "alt": "pic_SVD_305_D.png",
                "kr": "SVD - 겨울 선녀",
                "jp": "冬の妖精",
                "en": "Winter Fairy"
            },
            "pic_SVD_5506.png": {
                "cn": "SVD-待月丹",
                "icon": "Icon_SVD_5506.png",
                "alt": "pic_SVD_5506_D.png",
                "kr": "SVD - 달맞이 단홍",
                "jp": "",
                "en": "Camellia's Vigil"
            }
        },
        "kr": "SVD",
        "jp": "SVD",
        "en": "SVD"
    },
    "44": {
        "type": "RF",
        "id": "44",
        "cn": "SV-98",
        "code": "SV98",
        "icon": "Icon_SV98.png",
        "modded": true,
        "rarity": 3,
        "skins": {
            "pic_SV98.png": {
                "cn": "SV-98",
                "kr": "SV-98",
                "jp": "SV-98",
                "en": "SV-98",
                "alt": "pic_SV98_D.png"
            },
            "pic_SV98Mod.png": {
                "cn": "SV-98",
                "kr": "SV-98",
                "jp": "SV-98",
                "en": "SV-98",
                "icon": "mod",
                "alt": "pic_SV98Mod_D.png"
            },
            "pic_SV98_502.png": {
                "cn": "SV-98-女服务生",
                "icon": "Icon_SV98_502.png",
                "alt": "pic_SV98_502_D.png",
                "kr": "SV-98 - 웨이트리스",
                "jp": "ウェイトレス",
                "en": "At Your Service"
            },
            "pic_SV98_1906.png": {
                "cn": "SV-98-命中红心！",
                "icon": "Icon_SV98_1906.png",
                "alt": "pic_SV98_1906_D.png",
                "kr": "SV-98 - 하트를 꿰뚫어주지! ",
                "jp": "ハートに命中！",
                "en": "Pierce Your Heart!"
            }
        },
        "kr": "SV-98",
        "jp": "SV-98",
        "en": "SV-98",
        "moddedIcon": "Icon_SV98Mod.png",
        "modRarity": 4
    },
    "46": {
        "type": "RF",
        "id": "46",
        "cn": "Kar98k",
        "code": "98K",
        "icon": "Icon_98K.png",
        "modded": true,
        "rarity": 5,
        "skins": {
            "pic_98K.png": {
                "cn": "Kar98k",
                "kr": "Kar98k",
                "jp": "Kar98k",
                "en": "Kar98k",
                "alt": "pic_98K_D.png"
            },
            "pic_98KMod.png": {
                "cn": "Kar98k",
                "kr": "Kar98k",
                "jp": "Kar98k",
                "en": "Kar98k",
                "icon": "mod",
                "alt": "pic_98KMod_D.png"
            },
            "pic_98K_4301.png": {
                "cn": "Kar98k-手心的朱砂痣",
                "icon": "Icon_98K_4301.png",
                "alt": "pic_98K_4301_D.png",
                "kr": "Kar98k - 손안에 홍장미",
                "jp": "掌のスカーレッド",
                "en": "Purity in Vermilion"
            }
        },
        "kr": "Kar98k",
        "jp": "Kar98k",
        "en": "Kar98k",
        "moddedIcon": "Icon_98KMod.png",
        "modRarity": 6
    },
    "47": {
        "type": "RF",
        "id": "47",
        "cn": "G43",
        "code": "G43",
        "icon": "Icon_G43.png",
        "modded": false,
        "rarity": 2,
        "skins": {
            "pic_G43.png": {
                "cn": "G43",
                "kr": "G43",
                "jp": "G43",
                "en": "G43",
                "alt": "pic_G43_D.png"
            }
        },
        "kr": "G43",
        "jp": "G43",
        "en": "G43"
    },
    "48": {
        "type": "RF",
        "id": "48",
        "cn": "WA2000",
        "code": "WA2000",
        "icon": "Icon_WA2000.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_WA2000.png": {
                "cn": "WA2000",
                "kr": "WA2000",
                "jp": "WA2000",
                "en": "WA2000",
                "alt": "pic_WA2000_D.png"
            },
            "pic_WA2000_6.png": {
                "cn": "WA2000-古堡历险",
                "icon": "Icon_WA2000_6.png",
                "alt": "pic_WA2000_6_D.png",
                "kr": "WA2000 - 고성에서의 모험",
                "jp": "古城探検",
                "en": "Haunted Castle"
            },
            "pic_WA2000_306.png": {
                "cn": "WA2000-雪下赴约者",
                "icon": "Icon_WA2000_306.png",
                "alt": "pic_WA2000_306_D.png",
                "kr": "WA2000 - 겨울날 그대를 기다리며",
                "jp": "雪の日の約束",
                "en": "Date in the Snow"
            },
            "pic_WA2000_804.png": {
                "cn": "WA2000-舞会休止符",
                "icon": "Icon_WA2000_804.png",
                "alt": "pic_WA2000_804_D.png",
                "kr": "WA2000 - 무도회의 쉼표",
                "jp": "舞踏会の休止符",
                "en": "Ballroom Interlude"
            },
            "pic_WA2000_1108.png": {
                "cn": "WA2000-魔鬼鱼行动",
                "icon": "Icon_WA2000_1108.png",
                "alt": "pic_WA2000_1108_D.png",
                "kr": "WA2000 - 모불라 작전",
                "jp": "熱帯魚のいたずら",
                "en": "Op. Manta Ray"
            }
        },
        "kr": "WA2000",
        "jp": "WA2000",
        "en": "WA2000"
    },
    "49": {
        "type": "RF",
        "id": "49",
        "cn": "56式半",
        "code": "56typeR",
        "icon": "Icon_56typeR.png",
        "modded": true,
        "rarity": 3,
        "skins": {
            "pic_56typeR.png": {
                "cn": "56式半",
                "kr": "56식 반",
                "jp": "56式半",
                "en": "Type56R",
                "alt": "pic_56typeR_D.png"
            },
            "pic_56typeRMod.png": {
                "cn": "56式半",
                "kr": "56식 반",
                "jp": "56式半",
                "en": "Type56R",
                "icon": "mod",
                "alt": "pic_56typeRMod_D.png"
            },
            "pic_56typeR_5508.png": {
                "cn": "56式半-扶绛梨",
                "icon": "Icon_56typeR_5508.png",
                "alt": "pic_56typeR_5508_D.png",
                "kr": "56식 반 - 재운 신선",
                "jp": "",
                "en": "Pink Pear Blossom"
            },
            "pic_56typeR_7206.png": {
                "cn": "56式半-熊耳剪裁师",
                "icon": "Icon_56typeR_7206.png",
                "alt": "pic_56typeR_7206_D.png",
                "kr": "56식반 - 팬더귀 오리기",
                "en": ""
            }
        },
        "kr": "56식 반",
        "jp": "56式半",
        "en": "Type56R",
        "moddedIcon": "Icon_56typeRMod.png",
        "modRarity": 4
    },
    "50": {
        "type": "RF",
        "id": "50",
        "cn": "李-恩菲尔德",
        "code": "MLEMK1",
        "icon": "Icon_MLEMK1.png",
        "modded": true,
        "rarity": 5,
        "skins": {
            "pic_MLEMK1.png": {
                "cn": "李-恩菲尔德",
                "kr": "리엔필드",
                "jp": "リー・エンフィールド",
                "en": "Lee Enfield",
                "alt": "pic_MLEMK1_D.png"
            },
            "pic_MLEMK1Mod.png": {
                "cn": "李-恩菲尔德",
                "kr": "리엔필드",
                "jp": "リー・エンフィールド",
                "en": "Lee Enfield",
                "icon": "mod",
                "alt": "pic_MLEMK1Mod_D.png"
            },
            "pic_MLEMK1_10.png": {
                "cn": "李-恩菲尔德-狩猎者礼服",
                "icon": "Icon_MLEMK1_10.png",
                "alt": "pic_MLEMK1_10_D.png",
                "kr": "리-엔필드 - 제복 사냥꾼",
                "jp": "フォーマルハンター",
                "en": "Huntress' Frock "
            },
            "pic_MLEMK1_604.png": {
                "cn": "李-恩菲尔德-毕生守护",
                "icon": "Icon_MLEMK1_604.png",
                "alt": "pic_MLEMK1_604_D.png",
                "kr": "리-엔필드 - 평생의 수호자",
                "jp": "一生守り抜く",
                "en": "Lifelong Protector"
            },
            "pic_MLEMK1_901.png": {
                "cn": "李-恩菲尔德-洋葱枪手",
                "icon": "Icon_MLEMK1_901.png",
                "alt": "pic_MLEMK1_901_D.png",
                "kr": "리-엔필드 - 양파 저격수",
                "jp": "ちびガンナー",
                "en": "Onion Shooter"
            }
        },
        "kr": "리엔필드",
        "jp": "リー・エンフィールド",
        "en": "Lee Enfield",
        "moddedIcon": "Icon_MLEMK1Mod.png",
        "modRarity": 6
    },
    "51": {
        "type": "RF",
        "id": "51",
        "cn": "FN-49",
        "code": "FN49",
        "icon": "Icon_FN49.png",
        "modded": true,
        "rarity": 2,
        "skins": {
            "pic_FN49.png": {
                "cn": "FN-49",
                "kr": "FN-49",
                "jp": "FF FN49",
                "en": "FF FN49",
                "alt": "pic_FN49_D.png"
            },
            "pic_FN49Mod.png": {
                "cn": "FN-49",
                "kr": "FN-49",
                "jp": "FF FN49",
                "en": "FF FN49",
                "icon": "mod",
                "alt": "pic_FN49Mod_D.png"
            },
            "pic_FN49_4709.png": {
                "cn": "FN-49-伞中之梦",
                "icon": "Icon_FN49_4709.png",
                "alt": "pic_FN49_4709_D.png",
                "kr": "FN-49 - 파라솔 밑의 꿈",
                "jp": "傘の中の夢",
                "en": "Daydream Under the Parasol"
            },
            "pic_FN49_6809.png": {
                "cn": "FN-49-蜀锦羞",
                "icon": "Icon_FN49_6809.png",
                "alt": "pic_FN49_6809_D.png",
                "kr": "FN-49 - 수줍은 해당",
                "jp": "蜀錦羞",
                "en": ""
            }
        },
        "kr": "FN-49",
        "jp": "FF FN49",
        "en": "FF FN49",
        "moddedIcon": "Icon_FN49Mod.png",
        "modRarity": 4
    },
    "52": {
        "type": "RF",
        "id": "52",
        "cn": "BM59",
        "code": "BM59",
        "icon": "Icon_BM59.png",
        "modded": false,
        "rarity": 2,
        "skins": {
            "pic_BM59.png": {
                "cn": "BM59",
                "kr": "BM59",
                "jp": "It BM59",
                "en": "VM59",
                "alt": "pic_BM59_D.png"
            }
        },
        "kr": "BM59",
        "jp": "It BM59",
        "en": "VM59"
    },
    "53": {
        "type": "RF",
        "id": "53",
        "cn": "NTW-20",
        "code": "NTW20",
        "icon": "Icon_NTW20.png",
        "modded": true,
        "rarity": 5,
        "skins": {
            "pic_NTW20.png": {
                "cn": "NTW-20",
                "kr": "NTW-20",
                "jp": "NTW-20",
                "en": "NTW-20",
                "alt": "pic_NTW20_D.png"
            },
            "pic_NTW20Mod.png": {
                "cn": "NTW-20",
                "kr": "NTW-20",
                "jp": "NTW-20",
                "en": "NTW-20",
                "icon": "mod",
                "alt": "pic_NTW20Mod_D.png"
            },
            "pic_NTW20_307.png": {
                "cn": "NTW-20-圣诞鹿",
                "icon": "Icon_NTW20_307.png",
                "alt": "pic_NTW20_307_D.png",
                "kr": "NTW-20 - 루돌프",
                "jp": "聖夜のトナカイ",
                "en": "Xmas Reindeer"
            },
            "pic_NTW20_1101.png": {
                "cn": "NTW-20-骄阳任务",
                "icon": "Icon_NTW20_1101.png",
                "alt": "pic_NTW20_1101_D.png",
                "kr": "NTW-20 - 무더위 속 임무",
                "jp": "炎天下の任務",
                "en": "Op. Blazing Sun"
            },
            "pic_NTW20_2301.png": {
                "cn": "NTW-20-贵族体验馆",
                "icon": "Icon_NTW20_2301.png",
                "alt": "pic_NTW20_2301_D.png",
                "kr": "NTW-20 - VIP 체험관",
                "jp": "貴族体験館",
                "en": "The Aristocrat Experience"
            },
            "pic_NTW20_4801.png": {
                "cn": "NTW-20-黑铁之心",
                "icon": "Icon_NTW20_4801.png",
                "alt": "pic_NTW20_4801_D.png",
                "kr": "NTW-20 - 아이언 하트",
                "jp": "黒鉄の心",
                "en": "Heart of Dark Iron"
            }
        },
        "kr": "NTW-20",
        "jp": "NTW-20",
        "en": "NTW-20",
        "moddedIcon": "Icon_NTW20Mod.png",
        "modRarity": 6
    },
    "54": {
        "type": "AR",
        "id": "54",
        "cn": "M16A1",
        "code": "M16A1",
        "icon": "Icon_M16A1.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_M16A1.png": {
                "cn": "M16A1",
                "kr": "M16A1",
                "jp": "M16A1",
                "en": "M16A1",
                "alt": "pic_M16A1_D.png"
            },
            "pic_M16A1_533.png": {
                "cn": "M16A1-独眼的白兔骑士",
                "icon": "Icon_M16A1_533.png",
                "alt": "pic_M16A1_533_D.png",
                "kr": "M16A1 - 애꾸 백토기사",
                "jp": "隻眼の兎騎士",
                "en": "The One-Eyed Rabbit Knight"
            },
            "pic_M16A1_553.png": {
                "cn": "M16A1-墟上烈阳",
                "icon": "Icon_M16A1_553.png",
                "alt": "pic_M16A1_553_D.png",
                "kr": "M16A1 - 폐허 위의 태양",
                "jp": "墟上の烈日",
                "en": "Blazing Sun on the Ruins"
            },
            "pic_M16A1_4506.png": {
                "cn": "M16A1-道路的指引者",
                "icon": "Icon_M16A1_4506.png",
                "alt": "pic_M16A1_4506_D.png",
                "kr": "M16A1 - 앞길의 인도자",
                "jp": "行先を導く者",
                "en": "Blazer of the Trail"
            }
        },
        "kr": "M16A1",
        "jp": "M16A1",
        "en": "M16A1"
    },
    "55": {
        "type": "AR",
        "id": "55",
        "cn": "M4A1",
        "code": "M4A1",
        "icon": "Icon_M4A1.png",
        "modded": true,
        "rarity": 4,
        "skins": {
            "pic_M4A1.png": {
                "cn": "M4A1",
                "kr": "M4A1",
                "jp": "M4A1",
                "en": "M4A1",
                "alt": "pic_M4A1_D.png"
            },
            "pic_M4A1Mod.png": {
                "cn": "M4A1",
                "kr": "M4A1",
                "jp": "M4A1",
                "en": "M4A1",
                "icon": "mod",
                "alt": "pic_M4A1Mod_D.png"
            },
            "pic_M4A1_530.png": {
                "cn": "M4A1-少女的气球漫游记",
                "icon": "Icon_M4A1_530.png",
                "alt": "pic_M4A1_530_D.png",
                "kr": "M4A1 - 소녀세계일주",
                "jp": "少女の風船旅行",
                "en": "A Girl's Hot Air Balloon Adventure"
            },
            "pic_M4A1_550.png": {
                "cn": "M4A1-松间曦光",
                "icon": "Icon_M4A1_550.png",
                "alt": "pic_M4A1_550_D.png",
                "kr": "M4A1 - 소나무 사이 햇볕",
                "jp": "樹間の朝日",
                "en": "Sunshine through the Pines"
            },
            "pic_M4A1_4505.png": {
                "cn": "M4A1-时光的定格者",
                "icon": "Icon_M4A1_4505.png",
                "alt": "pic_M4A1_4505_D.png",
                "kr": "M4A1 - 세월의 정착자",
                "jp": "時空の凍結者",
                "en": "Suspender of Time"
            }
        },
        "kr": "M4A1",
        "jp": "M4A1",
        "en": "M4A1",
        "moddedIcon": "Icon_M4A1Mod.png",
        "modRarity": 5
    },
    "56": {
        "type": "AR",
        "id": "56",
        "cn": "M4 SOPMODII",
        "code": "M4 SOPMOD II",
        "icon": "Icon_M4 SOPMOD II.png",
        "modded": true,
        "rarity": 4,
        "skins": {
            "pic_M4 SOPMOD II.png": {
                "cn": "M4 SOPMODII",
                "kr": "M4 SOPMODII",
                "jp": "M4 SOPMOD II",
                "en": "M4 SOPMOD II",
                "alt": "pic_M4 SOPMOD II_D.png"
            },
            "pic_M4 SOPMOD IIMod.png": {
                "cn": "M4 SOPMODII",
                "kr": "M4 SOPMODII",
                "jp": "M4 SOPMOD II",
                "en": "M4 SOPMOD II",
                "icon": "mod",
                "alt": "pic_M4 SOPMOD IIMod_D.png"
            },
            "pic_M4 SOPMOD II_531.png": {
                "cn": "M4 SOPMODII-被守护的宠爱者",
                "icon": "Icon_M4 SOPMOD II_531.png",
                "alt": "pic_M4 SOPMOD II_531_D.png",
                "kr": "M4 SOPMODII - 모두의 귀염둥이",
                "jp": "護られし愛し子",
                "en": "The Guarded Beloved"
            },
            "pic_M4 SOPMOD II_551.png": {
                "cn": "M4 SOPMODII-深林鸣音",
                "icon": "Icon_M4 SOPMOD II_551.png",
                "alt": "pic_M4 SOPMOD II_551_D.png",
                "kr": "M4 SOPMODII - 숲의 울림",
                "jp": "森の鳴き声",
                "en": "Birdsong in the Woods"
            },
            "pic_M4 SOPMOD II_574.png": {
                "cn": "M4 SOPMODII-回魂修理师Jr",
                "icon": "Icon_M4 SOPMOD II_574.png",
                "alt": "pic_M4 SOPMOD II_574_D.png",
                "kr": "M4 SOPMODII - 황천의 정비사 Jr",
                "jp": "ソウル・リペアラーJr.",
                "en": "Resurrection Repairer Jr."
            },
            "pic_M4 SOPMOD II_4507.png": {
                "cn": "M4 SOPMODII-酒席的扫荡者",
                "icon": "Icon_M4 SOPMOD II_4507.png",
                "alt": "pic_M4 SOPMOD II_4507_D.png",
                "kr": "M4 SOPMODII - 연석의 약탈자",
                "jp": "酒席の掃討者",
                "en": "Devourer of the Feast"
            }
        },
        "kr": "M4 SOPMODII",
        "jp": "M4 SOPMOD II",
        "en": "M4 SOPMOD II",
        "moddedIcon": "Icon_M4 SOPMOD IIMod.png",
        "modRarity": 5
    },
    "57": {
        "type": "AR",
        "id": "57",
        "cn": "ST AR-15",
        "code": "AR15",
        "icon": "Icon_AR15.png",
        "modded": true,
        "rarity": 4,
        "skins": {
            "pic_AR15.png": {
                "cn": "ST AR-15",
                "kr": "ST AR-15",
                "jp": "ST AR-15",
                "en": "ST AR-15",
                "alt": "pic_AR15_D.png"
            },
            "pic_AR15Mod.png": {
                "cn": "ST AR-15",
                "kr": "ST AR-15",
                "jp": "ST AR-15",
                "en": "ST AR-15",
                "icon": "mod",
                "alt": "pic_AR15Mod_D.png"
            },
            "pic_AR15_532.png": {
                "cn": "ST AR-15-飘向花海的礼帽",
                "icon": "Icon_AR15_532.png",
                "alt": "pic_AR15_532_D.png",
                "kr": "ST AR-15 - 꽃밭의 실크햇",
                "jp": "花畑を舞うシルクハット",
                "en": "Top Hat Drifting to the Flowers"
            },
            "pic_AR15_552.png": {
                "cn": "ST AR-15-春日幻风",
                "icon": "Icon_AR15_552.png",
                "alt": "pic_AR15_552_D.png",
                "kr": "ST AR-15 - 환상의 봄바람",
                "jp": "春日の幻風",
                "en": "Breeze on a Spring Day"
            },
            "pic_AR15_701.png": {
                "cn": "ST AR-15-返校季",
                "icon": "Icon_AR15_701.png",
                "alt": "pic_AR15_701_D.png",
                "kr": "ST AR-15 - 계절학교에 가다",
                "jp": "新学期",
                "en": "Literary Girl"
            },
            "pic_AR15_4508.png": {
                "cn": "ST AR-15-梦境的囚困者",
                "icon": "Icon_AR15_4508.png",
                "alt": "pic_AR15_4508_D.png",
                "kr": "ST AR-15 - 꿈속의 수감자",
                "jp": "夢に囚われし者",
                "en": "Prisoner of the Dream"
            },
            "pic_AR15_30001.png": {
                "cn": "ST AR-15-午夏憩风",
                "icon": "Icon_AR15_30001.png",
                "alt": "pic_AR15_30001_D.png",
                "kr": "ST AR-15 - 여름의 솔솔 바람",
                "en": ""
            }
        },
        "kr": "ST AR-15",
        "jp": "ST AR-15",
        "en": "ST AR-15",
        "moddedIcon": "Icon_AR15Mod.png",
        "modRarity": 5
    },
    "58": {
        "type": "AR",
        "id": "58",
        "cn": "AK-47",
        "code": "AK47",
        "icon": "Icon_AK47.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_AK47.png": {
                "cn": "AK-47",
                "kr": "AK-47",
                "jp": "AK-47",
                "en": "AK-47",
                "alt": "pic_AK47_D.png"
            },
            "pic_AK47_501.png": {
                "cn": "AK-47-战争之王",
                "icon": "Icon_AK47_501.png",
                "alt": "pic_AK47_501_D.png",
                "kr": "AK-47 - 전쟁의 왕",
                "jp": "ロードオブウォー",
                "en": "Lord of War"
            }
        },
        "kr": "AK-47",
        "jp": "AK-47",
        "en": "AK-47"
    },
    "59": {
        "type": "SMG",
        "id": "59",
        "cn": "AK-74U",
        "code": "AK74U",
        "icon": "Icon_AK74U.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_AK74U.png": {
                "cn": "AK-74U",
                "kr": "AK-74U",
                "jp": "AK-74U",
                "en": "AK-74U",
                "alt": "pic_AK74U_D.png"
            },
            "pic_AK74U_3002.png": {
                "cn": "AK-74U-君影草",
                "icon": "Icon_AK74U_3002.png",
                "alt": "pic_AK74U_3002_D.png",
                "kr": "AK-74U - 은방울",
                "jp": "君影草",
                "en": "Lily of the Valley"
            }
        },
        "kr": "AK-74U",
        "jp": "AK-74U",
        "en": "AK-74U"
    },
    "60": {
        "type": "AR",
        "id": "60",
        "cn": "AS Val",
        "code": "ASVAL",
        "icon": "Icon_ASVAL.png",
        "modded": true,
        "rarity": 4,
        "skins": {
            "pic_ASVAL.png": {
                "cn": "AS Val",
                "kr": "AS Val",
                "jp": "AS Val",
                "en": "AS Val",
                "alt": "pic_ASVAL_D.png"
            },
            "pic_ASVALMod.png": {
                "cn": "AS Val",
                "kr": "AS Val",
                "jp": "AS Val",
                "en": "AS Val",
                "icon": "mod",
                "alt": "pic_ASVALMod_D.png"
            },
            "pic_ASVAL_2907.png": {
                "cn": "AS Val-梦花火",
                "icon": "Icon_ASVAL_2907.png",
                "alt": "pic_ASVAL_2907_D.png",
                "kr": "AS Val - 꿈의 불꽃놀이",
                "jp": "夢花火",
                "en": "Fireworks of Dreams"
            }
        },
        "kr": "AS Val",
        "jp": "AS Val",
        "en": "AS Val",
        "moddedIcon": "Icon_ASVALMod.png",
        "modRarity": 5
    },
    "61": {
        "type": "AR",
        "id": "61",
        "cn": "StG44",
        "code": "STG44",
        "icon": "Icon_STG44.png",
        "modded": true,
        "rarity": 3,
        "skins": {
            "pic_STG44.png": {
                "cn": "StG44",
                "kr": "StG44",
                "jp": "StG44",
                "en": "StG44",
                "alt": "pic_STG44_D.png"
            },
            "pic_STG44Mod.png": {
                "cn": "StG44",
                "kr": "StG44",
                "jp": "StG44",
                "en": "StG44",
                "icon": "mod",
                "alt": "pic_STG44Mod_D.png"
            }
        },
        "kr": "StG44",
        "jp": "StG44",
        "en": "StG44",
        "moddedIcon": "Icon_STG44Mod.png",
        "modRarity": 4
    },
    "62": {
        "type": "AR",
        "id": "62",
        "cn": "G41",
        "code": "G41",
        "icon": "Icon_G41.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_G41.png": {
                "cn": "G41",
                "kr": "G41",
                "jp": "Gr G41",
                "en": "Gr G41",
                "alt": "pic_G41_D.png"
            },
            "pic_G41_2401.png": {
                "cn": "G41-沙滩朋克2064",
                "icon": "Icon_G41_2401.png",
                "alt": "pic_G41_2401_D.png",
                "kr": "G41 - 비치펑크2064",
                "jp": "ビーチパンク2064",
                "en": "Beach Punk 2064"
            },
            "pic_G41_7406.png": {
                "cn": "G41-寰宇特急",
                "icon": "Icon_G41_7406.png",
                "alt": "pic_G41_7406_D.png",
                "kr": "G41 - 천상특급",
                "en": "Universal Express"
            }
        },
        "kr": "G41",
        "jp": "Gr G41",
        "en": "Gr G41"
    },
    "63": {
        "type": "AR",
        "id": "63",
        "cn": "G3",
        "code": "G3",
        "icon": "Icon_G3.png",
        "modded": true,
        "rarity": 2,
        "skins": {
            "pic_G3.png": {
                "cn": "G3",
                "kr": "G3",
                "jp": "Gr G3",
                "en": "Gr G3",
                "alt": "pic_G3_D.png"
            },
            "pic_G3Mod.png": {
                "cn": "G3",
                "kr": "G3",
                "jp": "Gr G3",
                "en": "Gr G3",
                "icon": "mod",
                "alt": "pic_G3Mod_D.png"
            },
            "pic_G3_1303.png": {
                "cn": "G3-战地糕点师",
                "icon": "Icon_G3_1303.png",
                "alt": "pic_G3_1303_D.png",
                "kr": "G3 - 전쟁터의 제빵사",
                "jp": "戦場のパティシエ",
                "en": "Battlefield Baker"
            }
        },
        "kr": "G3",
        "jp": "Gr G3",
        "en": "Gr G3",
        "moddedIcon": "Icon_G3Mod.png",
        "modRarity": 4
    },
    "64": {
        "type": "AR",
        "id": "64",
        "cn": "G36",
        "code": "G36",
        "icon": "Icon_G36.png",
        "modded": true,
        "rarity": 4,
        "skins": {
            "pic_G36.png": {
                "cn": "G36",
                "kr": "G36",
                "jp": "Gr G36",
                "en": "Gr G36",
                "alt": "pic_G36_D.png"
            },
            "pic_G36Mod.png": {
                "cn": "G36",
                "kr": "G36",
                "jp": "Gr G36",
                "en": "Gr G36",
                "icon": "mod",
                "alt": "pic_G36Mod_D.png"
            },
            "pic_G36_565.png": {
                "cn": "G36-光辉守望者",
                "icon": "Icon_G36_565.png",
                "alt": "pic_G36_565_D.png",
                "kr": "G36 - 광휘의 파수꾼",
                "jp": "輝きの観測者",
                "en": "Watcher of the Light"
            },
            "pic_G36_905.png": {
                "cn": "G36-小小招待员",
                "icon": "Icon_G36_905.png",
                "alt": "pic_G36_905_D.png",
                "kr": "G36 - 꼬마 메이드",
                "jp": "ちびっ子メイド",
                "en": "Mini Maid"
            },
            "pic_G36_1507.png": {
                "cn": "G36-“调酒师”",
                "icon": "Icon_G36_1507.png",
                "alt": "pic_G36_1507_D.png",
                "kr": "G36 - “바텐더”",
                "jp": "バーテンダー",
                "en": "\"Sommelier\""
            },
            "pic_G36_1904.png": {
                "cn": "G36-纯白矢车菊",
                "icon": "Icon_G36_1904.png",
                "alt": "pic_G36_1904_D.png",
                "kr": "G36 - 순백의 수레국화 ",
                "jp": "純白の矢車菊",
                "en": "Pure White Cornflower"
            },
            "pic_G36_2407.png": {
                "cn": "G36-和G36的五十天",
                "icon": "Icon_G36_2407.png",
                "alt": "pic_G36_2407_D.png",
                "kr": "G36 - 50일의 메이드",
                "jp": "G36との50日間",
                "en": "50 Days with Gr G36"
            },
            "pic_G36_2806.png": {
                "cn": "G36-每个孩子的圣诞梦",
                "icon": "Icon_G36_2806.png",
                "alt": "pic_G36_2806_D.png",
                "kr": "G36 - 아이들의 성탄절",
                "jp": "子供たちのクリスマス",
                "en": "Every Child's X'mas Dream"
            },
            "pic_G36_3603.png": {
                "cn": "G36-月下祈愿",
                "icon": "Icon_G36_3603.png",
                "alt": "pic_G36_3603_D.png",
                "kr": "G36 - 달밑에서 소원을",
                "jp": "月下の祈り",
                "en": "Moonlit Prayer"
            },
            "pic_G36_6807.png": {
                "cn": "G36-玉瓯立",
                "icon": "Icon_G36_6807.png",
                "alt": "pic_G36_6807_D.png",
                "kr": "G36 - 우뚝 선 치자꽃",
                "jp": "玉瓯立",
                "en": ""
            }
        },
        "kr": "G36",
        "jp": "Gr G36",
        "en": "Gr G36",
        "moddedIcon": "Icon_G36Mod.png",
        "modRarity": 5
    },
    "65": {
        "type": "AR",
        "id": "65",
        "cn": "HK416",
        "code": "HK416",
        "icon": "Icon_HK416.png",
        "modded": true,
        "rarity": 5,
        "skins": {
            "pic_HK416.png": {
                "cn": "HK416",
                "kr": "HK416",
                "jp": "416",
                "en": "416",
                "alt": "pic_HK416_D.png"
            },
            "pic_HK416Mod.png": {
                "cn": "HK416",
                "kr": "HK416",
                "jp": "416",
                "en": "416",
                "icon": "mod",
                "alt": "pic_HK416Mod_D.png"
            },
            "pic_HK416_537.png": {
                "cn": "HK416-千宵草味的锡纸糖",
                "icon": "Icon_HK416_537.png",
                "alt": "pic_HK416_537_D.png",
                "kr": "HK416 - 천소초맛 알사탕",
                "jp": "アキツナデシコのキャンディ",
                "en": "Herbal-Flavored Hard Candy"
            },
            "pic_HK416_548.png": {
                "cn": "HK416-獠牙",
                "icon": "Icon_HK416_548.png",
                "alt": "pic_HK416_548_D.png",
                "kr": "HK416 - 터스크",
                "jp": "ファング",
                "en": "Fang"
            },
            "pic_HK416_557.png": {
                "cn": "HK416-敲击波丽露",
                "icon": "Icon_HK416_557.png",
                "alt": "pic_HK416_557_D.png",
                "kr": "HK416 - 볼레로 스냅",
                "jp": "打奏のアフロレーロ",
                "en": "Percussive Bolero"
            },
            "pic_HK416_805.png": {
                "cn": "HK416-星之茧",
                "icon": "Icon_HK416_805.png",
                "alt": "pic_HK416_805_D.png",
                "kr": "HK416 - 별에 감싸이다",
                "jp": "星の繭",
                "en": "Starry Cocoon"
            },
            "pic_HK416_3401.png": {
                "cn": "HK416-黑猫的赠礼",
                "icon": "Icon_HK416_3401.png",
                "alt": "pic_HK416_3401_D.png",
                "kr": "HK416 - 고양이의 선물",
                "jp": "くろねこの贈りもの",
                "en": "Black Kitty's Gift"
            },
            "pic_HK416_6505.png": {
                "cn": "HK416-子夜福音",
                "icon": "Icon_HK416_6505.png",
                "alt": "pic_HK416_6505_D.png",
                "kr": "HK416 - 흑야의 복음",
                "jp": "真夜中の福音",
                "en": ""
            }
        },
        "kr": "HK416",
        "jp": "416",
        "en": "416",
        "moddedIcon": "Icon_HK416Mod.png",
        "modRarity": 6
    },
    "66": {
        "type": "AR",
        "id": "66",
        "cn": "56-1式",
        "code": "56-1type",
        "icon": "Icon_56-1type.png",
        "modded": true,
        "rarity": 4,
        "skins": {
            "pic_56-1type.png": {
                "cn": "56-1式",
                "kr": "56-1식",
                "jp": "56-1式",
                "en": "Type56-1",
                "alt": "pic_56-1type_D.png"
            },
            "pic_56-1typeMod.png": {
                "cn": "56-1式",
                "kr": "56-1식",
                "jp": "56-1式",
                "en": "Type56-1",
                "icon": "mod",
                "alt": "pic_56-1typeMod_D.png"
            },
            "pic_56-1type_401.png": {
                "cn": "56-1式-爆竹红",
                "icon": "Icon_56-1type_401.png",
                "alt": "pic_56-1type_401_D.png",
                "kr": "56-1 - 샐비어",
                "jp": "サルビア",
                "en": "Scarlet Sage"
            },
            "pic_56-1type_1905.png": {
                "cn": "56-1式-同心千千结",
                "icon": "Icon_56-1type_1905.png",
                "alt": "pic_56-1type_1905_D.png",
                "kr": "56-1식 - 마음을 엮는 매듭",
                "jp": "いつまでも心を一つに",
                "en": "'Til Death Do Us Part"
            }
        },
        "kr": "56-1식",
        "jp": "56-1式",
        "en": "Type56-1",
        "moddedIcon": "Icon_56-1typeMod.png",
        "modRarity": 5
    },
    "68": {
        "type": "AR",
        "id": "68",
        "cn": "L85A1",
        "code": "L85A1",
        "icon": "Icon_L85A1.png",
        "modded": false,
        "rarity": 2,
        "skins": {
            "pic_L85A1.png": {
                "cn": "L85A1",
                "kr": "L85A1",
                "jp": "L85A1",
                "en": "L85A1",
                "alt": "pic_L85A1_D.png"
            }
        },
        "kr": "L85A1",
        "jp": "L85A1",
        "en": "L85A1"
    },
    "69": {
        "type": "AR",
        "id": "69",
        "cn": "FAMAS",
        "code": "FAMAS",
        "icon": "Icon_FAMAS.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_FAMAS.png": {
                "cn": "FAMAS",
                "kr": "FAMAS",
                "jp": "Fr FAMAS",
                "en": "Fr FAMAS",
                "alt": "pic_FAMAS_D.png"
            },
            "pic_FAMAS_2604.png": {
                "cn": "FAMAS-枪炮与边箱",
                "icon": "Icon_FAMAS_2604.png",
                "alt": "pic_FAMAS_2604_D.png",
                "kr": "FAMAS - 총포와 사이드박스",
                "jp": "ガン・アンド・ザ・バガー",
                "en": "Guns N' Side Boxes"
            },
            "pic_FAMAS_4604.png": {
                "cn": "FAMAS-鸟与森语者",
                "icon": "Icon_FAMAS_4604.png",
                "alt": "pic_FAMAS_4604_D.png",
                "kr": "FAMAS - 새와 숲지기",
                "jp": "鳥と森の語り人",
                "en": "Forest Whisperer and Birds"
            }
        },
        "kr": "FAMAS",
        "jp": "Fr FAMAS",
        "en": "Fr FAMAS"
    },
    "70": {
        "type": "AR",
        "id": "70",
        "cn": "FNC",
        "code": "FNFNC",
        "icon": "Icon_FNFNC.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_FNFNC.png": {
                "cn": "FNC",
                "kr": "FNC",
                "jp": "FF FNC",
                "en": "FF FNC",
                "alt": "pic_FNFNC_D.png"
            },
            "pic_FNFNC_1406.png": {
                "cn": "FNC-偷走重要的糖果",
                "icon": "Icon_FNFNC_1406.png",
                "alt": "pic_FNFNC_1406_D.png",
                "kr": "FNC - 이 사탕은 이제 내 거!",
                "jp": "大事なお菓子を盗んでいきました",
                "en": "Candy Thief"
            },
            "pic_FNFNC_4308.png": {
                "cn": "FNC-草莓蛋糕与波斯花",
                "icon": "Icon_FNFNC_4308.png",
                "alt": "pic_FNFNC_4308_D.png",
                "kr": "FNC - 딸기 케익과 코스모스",
                "jp": "いちごケーキとハルシャギク",
                "en": "Strawberry Cake & Garden Cosmos"
            },
            "pic_FNFNC_6608.png": {
                "cn": "FNC-圣夜精灵高高挂",
                "icon": "Icon_FNFNC_6608.png",
                "alt": "pic_FNFNC_6608_D.png",
                "kr": "FNC - 성야의 정령 높이높이",
                "jp": "妖精のクリスマスリース",
                "en": "Raise the Christmas Elf"
            }
        },
        "kr": "FNC",
        "jp": "FF FNC",
        "en": "FF FNC"
    },
    "71": {
        "type": "AR",
        "id": "71",
        "cn": "加利尔",
        "code": "AR",
        "icon": "Icon_AR.png",
        "modded": true,
        "rarity": 2,
        "skins": {
            "pic_AR.png": {
                "cn": "加利尔",
                "kr": "갈릴",
                "jp": "ガリル",
                "en": "Galil",
                "alt": "pic_AR_D.png"
            },
            "pic_ARMod.png": {
                "cn": "加利尔",
                "kr": "갈릴",
                "jp": "ガリル",
                "en": "Galil",
                "icon": "mod",
                "alt": "pic_ARMod_D.png"
            }
        },
        "kr": "갈릴",
        "jp": "ガリル",
        "en": "Galil",
        "moddedIcon": "Icon_ARMod.png",
        "modRarity": 4
    },
    "72": {
        "type": "AR",
        "id": "72",
        "cn": "TAR-21",
        "code": "TAR21",
        "icon": "Icon_TAR21.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_TAR21.png": {
                "cn": "TAR-21",
                "kr": "TAR-21",
                "jp": "TAR-21",
                "en": "TAR-21",
                "alt": "pic_TAR21_D.png"
            },
            "pic_TAR21_1305.png": {
                "cn": "TAR-21-酒吧之夜",
                "icon": "Icon_TAR21_1305.png",
                "alt": "pic_TAR21_1305_D.png",
                "kr": "TAR-21 - 야간 주점",
                "jp": "夜更けのバー",
                "en": "Night at the Bar"
            }
        },
        "kr": "TAR-21",
        "jp": "TAR-21",
        "en": "TAR-21"
    },
    "73": {
        "type": "AR",
        "id": "73",
        "cn": "AUG",
        "code": "AUG",
        "icon": "Icon_AUG.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_AUG.png": {
                "cn": "AUG",
                "kr": "AUG",
                "jp": "AUG",
                "en": "AUG",
                "alt": "pic_AUG_D.png"
            },
            "pic_AUG_4802.png": {
                "cn": "AUG-葬仪阵列",
                "icon": "Icon_AUG_4802.png",
                "alt": "pic_AUG_4802_D.png",
                "kr": "AUG - 전선 장의사",
                "jp": "葬儀の隊列",
                "en": "Requiem Array"
            }
        },
        "kr": "AUG",
        "jp": "AUG",
        "en": "AUG"
    },
    "74": {
        "type": "AR",
        "id": "74",
        "cn": "SIG-510",
        "code": "SIG510",
        "icon": "Icon_SIG510.png",
        "modded": false,
        "rarity": 2,
        "skins": {
            "pic_SIG510.png": {
                "cn": "SIG-510",
                "kr": "SIG-510",
                "jp": "SIG-510",
                "en": "SIG-510",
                "alt": "pic_SIG510_D.png"
            }
        },
        "kr": "SIG-510",
        "jp": "SIG-510",
        "en": "SIG-510"
    },
    "75": {
        "type": "MG",
        "id": "75",
        "cn": "M1918",
        "code": "M1918",
        "icon": "Icon_M1918.png",
        "modded": true,
        "rarity": 4,
        "skins": {
            "pic_M1918.png": {
                "cn": "M1918",
                "kr": "M1918",
                "jp": "M1918",
                "en": "M1918",
                "alt": "pic_M1918_D.png"
            },
            "pic_M1918Mod.png": {
                "cn": "M1918",
                "kr": "M1918",
                "jp": "M1918",
                "en": "M1918",
                "icon": "mod",
                "alt": "pic_M1918Mod_D.png"
            },
            "pic_M1918_102.png": {
                "cn": "M1918-兔女郎",
                "icon": "Icon_M1918_102.png",
                "alt": "pic_M1918_102_D.png",
                "kr": "M1918 - 바니 걸",
                "jp": "バニーガール",
                "en": "Bunny Girl"
            },
            "pic_M1918_806.png": {
                "cn": "M1918-绸缪夜曲",
                "icon": "Icon_M1918_806.png",
                "alt": "pic_M1918_806_D.png",
                "kr": "M1918 - 준비된 세레나데",
                "jp": "ノクターン",
                "en": "Tender Nocturne"
            },
            "pic_M1918_1606.png": {
                "cn": "M1918-如你所愿的圣诞",
                "icon": "Icon_M1918_1606.png",
                "alt": "pic_M1918_1606_D.png",
                "kr": "M1918 - 꿈꿔왔던 크리스마스",
                "jp": "お望み通りのクリスマス",
                "en": "War Is Over"
            }
        },
        "kr": "M1918",
        "jp": "M1918",
        "en": "M1918",
        "moddedIcon": "Icon_M1918Mod.png",
        "modRarity": 5
    },
    "77": {
        "type": "MG",
        "id": "77",
        "cn": "M2HB",
        "code": "M2HB",
        "icon": "Icon_M2HB.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_M2HB.png": {
                "cn": "M2HB",
                "kr": "M2HB",
                "jp": "M2HB ",
                "en": "M2HB ",
                "alt": "pic_M2HB_D.png"
            },
            "pic_M2HB_3904.png": {
                "cn": "M2HB-热砂声援",
                "icon": "Icon_M2HB_3904.png",
                "alt": "pic_M2HB_3904_D.png",
                "kr": "M2HB - 데저트 크로스",
                "jp": "熱砂上の声援",
                "en": "Cheers on the Blazing Tarmac"
            }
        },
        "kr": "M2HB",
        "jp": "M2HB ",
        "en": "M2HB "
    },
    "78": {
        "type": "MG",
        "id": "78",
        "cn": "M60",
        "code": "M60",
        "icon": "Icon_M60.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_M60.png": {
                "cn": "M60",
                "kr": "M60",
                "jp": "M60",
                "en": "M60",
                "alt": "pic_M60_D.png"
            }
        },
        "kr": "M60",
        "jp": "M60",
        "en": "M60"
    },
    "79": {
        "type": "MG",
        "id": "79",
        "cn": "M249 SAW",
        "code": "M249SAW",
        "icon": "Icon_M249SAW.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_M249SAW.png": {
                "cn": "M249 SAW",
                "kr": "M249 SAW",
                "jp": "FF M249SAW",
                "en": "FF M249SAW",
                "alt": "pic_M249SAW_D.png"
            },
            "pic_M249SAW_1301.png": {
                "cn": "M249 SAW-北极狐",
                "icon": "Icon_M249SAW_1301.png",
                "alt": "pic_M249SAW_1301_D.png",
                "kr": "M249 SAW - 북극 여우",
                "jp": "北極ギツネ",
                "en": "Arctic Fox"
            },
            "pic_M249SAW_3604.png": {
                "cn": "M249 SAW-胧月夜",
                "icon": "Icon_M249SAW_3604.png",
                "alt": "pic_M249SAW_3604_D.png",
                "kr": "M249 SAW - 달무리의 밤",
                "jp": "朧月夜",
                "en": "Oborozukiyo"
            }
        },
        "kr": "M249 SAW",
        "jp": "FF M249SAW",
        "en": "FF M249SAW"
    },
    "80": {
        "type": "MG",
        "id": "80",
        "cn": "M1919A4",
        "code": "M1919A4",
        "icon": "Icon_M1919A4.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_M1919A4.png": {
                "cn": "M1919A4",
                "kr": "M1919A4",
                "jp": "M1919A4",
                "en": "M1919A4",
                "alt": "pic_M1919A4_D.png"
            },
            "pic_M1919A4_7.png": {
                "cn": "M1919A4-卡蜜拉",
                "icon": "Icon_M1919A4_7.png",
                "alt": "pic_M1919A4_7_D.png",
                "kr": "M1919A4 - 카밀라",
                "jp": "カーミラ",
                "en": "Carmilla"
            },
            "pic_M1919A4_106.png": {
                "cn": "M1919A4-派对甜心",
                "icon": "Icon_M1919A4_106.png",
                "alt": "pic_M1919A4_106_D.png",
                "kr": "M1919A4 - 파티의 연인",
                "jp": "パーティーハニー",
                "en": "Party Sweetheart"
            }
        },
        "kr": "M1919A4",
        "jp": "M1919A4",
        "en": "M1919A4"
    },
    "81": {
        "type": "MG",
        "id": "81",
        "cn": "LWMMG",
        "code": "LWMMG",
        "icon": "Icon_LWMMG.png",
        "modded": true,
        "rarity": 2,
        "skins": {
            "pic_LWMMG.png": {
                "cn": "LWMMG",
                "kr": "LWMMG",
                "jp": "LWMMG",
                "en": "LWMMG",
                "alt": "pic_LWMMG_D.png"
            },
            "pic_LWMMGMod.png": {
                "cn": "LWMMG",
                "kr": "LWMMG",
                "jp": "LWMMG",
                "en": "LWMMG",
                "icon": "mod",
                "alt": "pic_LWMMGMod_D.png"
            },
            "pic_LWMMG_1808.png": {
                "cn": "LWMMG-黄星蓟",
                "icon": "Icon_LWMMG_1808.png",
                "alt": "pic_LWMMG_1808_D.png",
                "kr": "LWMMG - 센토레아",
                "jp": "矢車草",
                "en": "Golden Starthistle"
            },
            "pic_LWMMG_4007.png": {
                "cn": "LWMMG-12月是我的谎言",
                "icon": "Icon_LWMMG_4007.png",
                "alt": "pic_LWMMG_4007_D.png",
                "kr": "LWMMG - 12월은 나의 거짓말",
                "jp": "12月は私の嘘",
                "en": "My Lie in December"
            },
            "pic_LWMMG_6406.png": {
                "cn": "LWMMG-拼凑者的独白",
                "icon": "Icon_LWMMG_6406.png",
                "alt": "pic_LWMMG_6406_D.png",
                "kr": "LWMMG - 누더기의 독백",
                "jp": "ツギハギの怪物の独白",
                "en": "Patchworker's Soliloquy"
            },
            "pic_LWMMG_6909.png": {
                "cn": "LWMMG-骑士与守护者",
                "icon": "Icon_LWMMG_6909.png",
                "alt": "pic_LWMMG_6909_D.png",
                "kr": "LWMMG - 기사와 수호자",
                "jp": "",
                "en": ""
            }
        },
        "kr": "LWMMG",
        "jp": "LWMMG",
        "en": "LWMMG",
        "moddedIcon": "Icon_LWMMGMod.png",
        "modRarity": 4
    },
    "82": {
        "type": "MG",
        "id": "82",
        "cn": "DP28",
        "code": "DP28",
        "icon": "Icon_DP28.png",
        "modded": false,
        "rarity": 2,
        "skins": {
            "pic_DP28.png": {
                "cn": "DP28",
                "kr": "DP28",
                "jp": "DP28",
                "en": "DP28",
                "alt": "pic_DP28_D.png"
            }
        },
        "kr": "DP28",
        "jp": "DP28",
        "en": "DP28"
    },
    "84": {
        "type": "MG",
        "id": "84",
        "cn": "RPD",
        "code": "RPD",
        "icon": "Icon_RPD.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_RPD.png": {
                "cn": "RPD",
                "kr": "RPD",
                "jp": "RPD",
                "en": "RPD",
                "alt": "pic_RPD_D.png"
            }
        },
        "kr": "RPD",
        "jp": "RPD",
        "en": "RPD"
    },
    "85": {
        "type": "MG",
        "id": "85",
        "cn": "PK",
        "code": "PK",
        "icon": "Icon_PK.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_PK.png": {
                "cn": "PK",
                "kr": "PK",
                "jp": "PK",
                "en": "PK",
                "alt": "pic_PK_D.png"
            },
            "pic_PK_605.png": {
                "cn": "PK-与您同在",
                "icon": "Icon_PK_605.png",
                "alt": "pic_PK_605_D.png",
                "kr": "PK - 당신과 함께",
                "jp": "あなたと共に",
                "en": "By Your Side"
            }
        },
        "kr": "PK",
        "jp": "PK",
        "en": "PK"
    },
    "86": {
        "type": "MG",
        "id": "86",
        "cn": "MG42",
        "code": "MG42",
        "icon": "Icon_MG42.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_MG42.png": {
                "cn": "MG42",
                "kr": "MG42",
                "jp": "MG42",
                "en": "MG42",
                "alt": "pic_MG42_D.png"
            }
        },
        "kr": "MG42",
        "jp": "MG42",
        "en": "MG42"
    },
    "87": {
        "type": "MG",
        "id": "87",
        "cn": "MG34",
        "code": "MG34",
        "icon": "Icon_MG34.png",
        "modded": false,
        "rarity": 2,
        "skins": {
            "pic_MG34.png": {
                "cn": "MG34",
                "kr": "MG34",
                "jp": "MG34",
                "en": "MG34",
                "alt": "pic_MG34_D.png"
            },
            "pic_MG34_4210.png": {
                "cn": "MG34-碧桃仙",
                "icon": "Icon_MG34_4210.png",
                "alt": "pic_MG34_4210_D.png",
                "kr": "MG34 - 복숭아 선녀",
                "jp": "碧桃仙",
                "en": "Divine Peach Blossom"
            }
        },
        "kr": "MG34",
        "jp": "MG34",
        "en": "MG34"
    },
    "88": {
        "type": "MG",
        "id": "88",
        "cn": "MG3",
        "code": "MG3",
        "icon": "Icon_MG3.png",
        "modded": true,
        "rarity": 4,
        "skins": {
            "pic_MG3.png": {
                "cn": "MG3",
                "kr": "MG3",
                "jp": "MG3",
                "en": "MG3",
                "alt": "pic_MG3_D.png"
            },
            "pic_MG3Mod.png": {
                "cn": "MG3",
                "kr": "MG3",
                "jp": "MG3",
                "en": "MG3",
                "icon": "mod",
                "alt": "pic_MG3Mod_D.png"
            },
            "pic_MG3_1304.png": {
                "cn": "MG3-假日街景",
                "icon": "Icon_MG3_1304.png",
                "alt": "pic_MG3_1304_D.png",
                "kr": "MG3 - 휴일의 거리 풍경",
                "jp": "休日の街角",
                "en": "Urban Holiday"
            },
            "pic_MG3_3806.png": {
                "cn": "MG3-满月请睁眼",
                "icon": "Icon_MG3_3806.png",
                "alt": "pic_MG3_3806_D.png",
                "kr": "MG3 - 밤이 되었습니다",
                "jp": "ほら、満月だ",
                "en": "Open Your Eyes, It's Full Moon."
            },
            "pic_MG3_4105.png": {
                "cn": "MG3-贺岁狮舞",
                "icon": "Icon_MG3_4105.png",
                "alt": "pic_MG3_4105_D.png",
                "kr": "MG3 - 사자탈춤",
                "jp": "迎春の獅子舞",
                "en": "New Year Lion Dance"
            },
            "pic_MG3_7205.png": {
                "cn": "MG3-未来构想家",
                "icon": "Icon_MG3_7205.png",
                "alt": "pic_MG3_7205_D.png",
                "kr": "MG3 - 미래 구상가",
                "en": ""
            }
        },
        "kr": "MG3",
        "jp": "MG3",
        "en": "MG3",
        "moddedIcon": "Icon_MG3Mod.png",
        "modRarity": 5
    },
    "89": {
        "type": "MG",
        "id": "89",
        "cn": "布伦",
        "code": "BrenMK",
        "icon": "Icon_BrenMK.png",
        "modded": true,
        "rarity": 3,
        "skins": {
            "pic_BrenMK.png": {
                "cn": "布伦",
                "kr": "브렌",
                "jp": "ブレン",
                "en": "Bren",
                "alt": "pic_BrenMK_D.png"
            },
            "pic_BrenMKMod.png": {
                "cn": "布伦",
                "kr": "브렌",
                "jp": "ブレン",
                "en": "Bren",
                "icon": "mod",
                "alt": "pic_BrenMKMod_D.png"
            },
            "pic_BrenMK_2605.png": {
                "cn": "布伦-杰克的三分相",
                "icon": "Icon_BrenMK_2605.png",
                "alt": "pic_BrenMK_2605_D.png",
                "kr": "브렌 - 잭 트리니티",
                "jp": "ジャック・ザ・トライン",
                "en": "Jack the Trine"
            }
        },
        "kr": "브렌",
        "jp": "ブレン",
        "en": "Bren",
        "moddedIcon": "Icon_BrenMKMod.png",
        "modRarity": 4
    },
    "90": {
        "type": "HG",
        "id": "90",
        "cn": "FNP-9",
        "code": "FNP9",
        "icon": "Icon_FNP9.png",
        "modded": false,
        "rarity": 2,
        "skins": {
            "pic_FNP9.png": {
                "cn": "FNP-9",
                "kr": "FNP-9",
                "jp": "FF FNP9",
                "en": "FF FNP9",
                "alt": "pic_FNP9_D.png"
            }
        },
        "kr": "FNP-9",
        "jp": "FF FNP9",
        "en": "FF FNP9"
    },
    "91": {
        "type": "HG",
        "id": "91",
        "cn": "MP-446",
        "code": "MP446",
        "icon": "Icon_MP446.png",
        "modded": true,
        "rarity": 2,
        "skins": {
            "pic_MP446.png": {
                "cn": "MP-446",
                "kr": "MP-446",
                "jp": "MP-446",
                "en": "MP-446",
                "alt": "pic_MP446_D.png"
            },
            "pic_MP446Mod.png": {
                "cn": "MP-446",
                "kr": "MP-446",
                "jp": "MP-446",
                "en": "MP-446",
                "icon": "mod",
                "alt": "pic_MP446Mod_D.png"
            },
            "pic_MP446_103.png": {
                "cn": "MP-446-顽劣噪音",
                "icon": "Icon_MP446_103.png",
                "alt": "pic_MP446_103_D.png",
                "kr": "MP-446 - 고집 센 악동",
                "jp": "やんちゃノイジー",
                "en": "Boisterous Rogue"
            },
            "pic_MP446_402.png": {
                "cn": "MP-446-向阳葵",
                "icon": "Icon_MP446_402.png",
                "alt": "pic_MP446_402_D.png",
                "kr": "MP-446 - 해바라기",
                "jp": "ヒマワリ",
                "en": "Sunflower"
            }
        },
        "kr": "MP-446",
        "jp": "MP-446",
        "en": "MP-446",
        "moddedIcon": "Icon_MP446Mod.png",
        "modRarity": 4
    },
    "92": {
        "type": "SMG",
        "id": "92",
        "cn": "幽灵M4",
        "code": "SpectreM4",
        "icon": "Icon_SpectreM4.png",
        "modded": false,
        "rarity": 2,
        "skins": {
            "pic_SpectreM4.png": {
                "cn": "幽灵M4",
                "kr": "Spectre M4",
                "jp": "スペクトラM4",
                "en": "Spectre M4",
                "alt": "pic_SpectreM4_D.png"
            }
        },
        "kr": "Spectre M4",
        "jp": "スペクトラM4",
        "en": "Spectre M4"
    },
    "93": {
        "type": "SMG",
        "id": "93",
        "cn": "IDW",
        "code": "IDW",
        "icon": "Icon_IDW.png",
        "modded": true,
        "rarity": 2,
        "skins": {
            "pic_IDW.png": {
                "cn": "IDW",
                "kr": "IDW",
                "jp": "IDW",
                "en": "IDW",
                "alt": "pic_IDW_D.png"
            },
            "pic_IDWMod.png": {
                "cn": "IDW",
                "kr": "IDW",
                "jp": "IDW",
                "en": "IDW",
                "icon": "mod",
                "alt": "pic_IDWMod_D.png"
            },
            "pic_IDW_2108.png": {
                "cn": "IDW-箱中之猫",
                "icon": "Icon_IDW_2108.png",
                "alt": "pic_IDW_2108_D.png",
                "kr": "IDW -  상자 속 고양이",
                "jp": "箱の中の猫",
                "en": "Cat in the Box"
            },
            "pic_IDW_3205.png": {
                "cn": "IDW-斗篷与猫耳",
                "icon": "Icon_IDW_3205.png",
                "alt": "pic_IDW_3205_D.png",
                "kr": "IDW - 망토 두른 고양이",
                "jp": "マントと猫耳",
                "en": "Cloak and Cat Ears"
            },
            "pic_IDW_4908.png": {
                "cn": "IDW-不倒猫侍",
                "icon": "Icon_IDW_4908.png",
                "alt": "pic_IDW_4908_D.png",
                "kr": "IDW - 오뚝이 고양이 무사",
                "jp": "猫侍は転ばない",
                "en": "Roly-Poly Ninja Cat"
            }
        },
        "kr": "IDW",
        "jp": "IDW",
        "en": "IDW",
        "moddedIcon": "Icon_IDWMod.png",
        "modRarity": 4
    },
    "94": {
        "type": "SMG",
        "id": "94",
        "cn": "64式",
        "code": "64type",
        "icon": "Icon_64type.png",
        "modded": true,
        "rarity": 2,
        "skins": {
            "pic_64type.png": {
                "cn": "64式",
                "kr": "64식",
                "jp": "64式",
                "en": "Type64",
                "alt": "pic_64type_D.png"
            },
            "pic_64typeMod.png": {
                "cn": "64式",
                "kr": "64식",
                "jp": "64式",
                "en": "Type64",
                "icon": "mod",
                "alt": "pic_64typeMod_D.png"
            },
            "pic_64type_11.png": {
                "cn": "64式-异邦魔女",
                "icon": "Icon_64type_11.png",
                "alt": "pic_64type_11_D.png",
                "kr": "64식 - 떠돌이 마녀",
                "jp": "異国の魔女",
                "en": "Witch from Afar"
            },
            "pic_64type_104.png": {
                "cn": "64式-水襦裙",
                "icon": "Icon_64type_104.png",
                "alt": "pic_64type_104_D.png",
                "kr": "64식 - 물 선녀복",
                "jp": "水辺のキャミソール",
                "en": "Water Gown"
            },
            "pic_64type_5608.png": {
                "cn": "64式-雀闻弦歌",
                "icon": "Icon_64type_5608.png",
                "alt": "pic_64type_5608_D.png",
                "kr": "64식 - 현악에 지저귀다",
                "jp": "フェニックス・メロディ",
                "en": "Phoenix Melody"
            },
            "pic_64type_7108.png": {
                "cn": "64式-啜风吟",
                "icon": "Icon_64type_7108.png",
                "alt": "pic_64type_7108_D.png",
                "kr": "64식 - 바람을 홀짝이며",
                "en": ""
            }
        },
        "kr": "64식",
        "jp": "64式",
        "en": "Type64",
        "moddedIcon": "Icon_64typeMod.png",
        "modRarity": 4
    },
    "95": {
        "type": "RF",
        "id": "95",
        "cn": "汉阳造88式",
        "code": "88type",
        "icon": "Icon_88type.png",
        "modded": true,
        "rarity": 3,
        "skins": {
            "pic_88type.png": {
                "cn": "汉阳造88式",
                "kr": "한양조 88식",
                "jp": "漢陽88式",
                "en": "Type88",
                "alt": "pic_88type_D.png"
            },
            "pic_88typeMod.png": {
                "cn": "汉阳造88式",
                "kr": "한양조 88식",
                "jp": "漢陽88式",
                "en": "Type88",
                "icon": "mod",
                "alt": "pic_88typeMod_D.png"
            },
            "pic_88type_1809.png": {
                "cn": "汉阳造88式-东湖莲",
                "icon": "Icon_88type_1809.png",
                "alt": "pic_88type_1809_D.png",
                "kr": "한양조 88식 - 동호의 연꽃",
                "jp": "東湖蓮",
                "en": "East Lake Lotus"
            },
            "pic_88type_5308.png": {
                "cn": "汉阳造88式-女仆团的狂飙午夜",
                "icon": "Icon_88type_5308.png",
                "alt": "pic_88type_5308_D.png",
                "kr": "한양조 88식 - 메이드단의 광란질주",
                "jp": "メイド隊怒涛の真夜中",
                "en": "The Maids' Midnight Rally"
            },
            "pic_88type_6503.png": {
                "cn": "汉阳造88式-纯白流星负愿而行",
                "icon": "Icon_88type_6503.png",
                "alt": "pic_88type_6503_D.png",
                "kr": "한양조 88식 - 하얀 유성은 소망을 품고",
                "jp": "純白の流星は願いを乗せて",
                "en": ""
            },
            "pic_88type_7106.png": {
                "cn": "汉阳造88式-爱神降临夜",
                "icon": "Icon_88type_7106.png",
                "alt": "pic_88type_7106_D.png",
                "kr": "한양조 88식 - 비너스 강림",
                "en": ""
            },
            "pic_88type_7407.png": {
                "cn": "汉阳造88式-超新星之魂",
                "icon": "Icon_88type_7407.png",
                "alt": "pic_88type_7407_D.png",
                "kr": "한양조 88식 - 슈퍼 노바 소울",
                "en": "Supernova Spirit"
            }
        },
        "kr": "한양조 88식",
        "jp": "漢陽88式",
        "en": "Type88",
        "moddedIcon": "Icon_88typeMod.png",
        "modRarity": 4
    },
    "96": {
        "type": "HG",
        "id": "96",
        "cn": "灰熊MkⅤ",
        "code": "Grizzly",
        "icon": "Icon_Grizzly.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_Grizzly.png": {
                "cn": "灰熊MkⅤ",
                "kr": "그리즐리MkⅤ",
                "jp": "グリズリー",
                "en": "Grizzly",
                "alt": "pic_Grizzly_D.png"
            },
            "pic_Grizzly_105.png": {
                "cn": "灰熊MkⅤ-周末警卫",
                "icon": "Icon_Grizzly_105.png",
                "alt": "pic_Grizzly_105_D.png",
                "kr": "그리즐리 MkⅤ - 주말 경비원",
                "jp": "週末SP",
                "en": "Weekend Cop"
            },
            "pic_Grizzly_903.png": {
                "cn": "灰熊MkⅤ-变身！泰迪熊！",
                "icon": "Icon_Grizzly_903.png",
                "alt": "pic_Grizzly_903_D.png",
                "kr": "그리즐리 MkⅤ - 변신! 테디베어!",
                "jp": "変身！テディベア！",
                "en": "Teddy, Transform!"
            },
            "pic_Grizzly_2102.png": {
                "cn": "灰熊MkⅤ-星夜舞会",
                "icon": "Icon_Grizzly_2102.png",
                "alt": "pic_Grizzly_2102_D.png",
                "kr": "그리즐리 - 별이 빛나는 밤의 무도회",
                "jp": "星夜の舞踏会",
                "en": "Starry Night Ball"
            },
            "pic_Grizzly_4303.png": {
                "cn": "灰熊MkⅤ-星夜落雨之时",
                "icon": "Icon_Grizzly_4303.png",
                "alt": "pic_Grizzly_4303_D.png",
                "kr": "그리즐리 MkV - 유성우가 내리는 밤",
                "jp": "星降る夜に",
                "en": "Rain on a Starry Night"
            }
        },
        "kr": "그리즐리MkⅤ",
        "jp": "グリズリー",
        "en": "Grizzly"
    },
    "97": {
        "type": "HG",
        "id": "97",
        "cn": "M950A",
        "code": "M950A",
        "icon": "Icon_M950A.png",
        "modded": true,
        "rarity": 5,
        "skins": {
            "pic_M950A.png": {
                "cn": "M950A",
                "kr": "M950A",
                "jp": "M950A",
                "en": "M950A",
                "alt": "pic_M950A_D.png"
            },
            "pic_M950AMod.png": {
                "cn": "M950A",
                "kr": "M950A",
                "jp": "M950A",
                "en": "M950A",
                "icon": "mod",
                "alt": "pic_M950AMod_D.png"
            },
            "pic_M950A_702.png": {
                "cn": "M950A-王牌值日生",
                "icon": "Icon_M950A_702.png",
                "alt": "pic_M950A_702_D.png",
                "kr": "M950A - 당번 대표",
                "jp": "横柄な日直",
                "en": "Ace on Duty"
            },
            "pic_M950A_808.png": {
                "cn": "M950A-祭典强音！",
                "icon": "Icon_M950A_808.png",
                "alt": "pic_M950A_808_D.png",
                "kr": "M950A - \"축제 시작이야!\"",
                "jp": "祭典のフォルテ",
                "en": "Concert Diva!"
            },
            "pic_M950A_2303.png": {
                "cn": "M950A-家政试炼",
                "icon": "Icon_M950A_2303.png",
                "alt": "pic_M950A_2303_D.png",
                "kr": "M950A - 집안일 테스트",
                "jp": "家政訓練",
                "en": "Home Ec Training"
            },
            "pic_M950A_4302.png": {
                "cn": "M950A-柳莺与蔷薇",
                "icon": "Icon_M950A_4302.png",
                "alt": "pic_M950A_4302_D.png",
                "kr": "M950A - 솔새와 장미",
                "jp": "鶯と薔薇",
                "en": "The Warbler and the Rose"
            },
            "pic_M950A_5403.png": {
                "cn": "M950A-傲雪隽茶",
                "icon": "Icon_M950A_5403.png",
                "alt": "pic_M950A_5403_D.png",
                "kr": "M950A - 눈꽃에 안 지는 모란",
                "jp": "雅ナ茶ハ雪ニモ負ケズ",
                "en": "The Elegance of Tea is Undefeated by the Snow"
            }
        },
        "kr": "M950A",
        "jp": "M950A",
        "en": "M950A",
        "moddedIcon": "Icon_M950AMod.png",
        "modRarity": 6
    },
    "98": {
        "type": "HG",
        "id": "98",
        "cn": "SPP-1",
        "code": "SPP1",
        "icon": "Icon_SPP1.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_SPP1.png": {
                "cn": "SPP-1",
                "kr": "SPP-1",
                "jp": "SPP-1",
                "en": "SPP-1",
                "alt": "pic_SPP1_D.png"
            },
            "pic_SPP1_1703.png": {
                "cn": "SPP-1-拥抱粉雪",
                "icon": "Icon_SPP1_1703.png",
                "alt": "pic_SPP1_1703_D.png",
                "kr": "SPP-1 - 가랑눈에 감싸여",
                "jp": "粉雪につつまれて",
                "en": "Snowflakes in Arms"
            },
            "pic_SPP1_4207.png": {
                "cn": "SPP-1-蓝莲夜",
                "icon": "Icon_SPP1_4207.png",
                "alt": "pic_SPP1_4207_D.png",
                "kr": "SPP-1 - 파란 연꽃",
                "jp": "藍蓮夜",
                "en": "Night of Blue Lotus"
            }
        },
        "kr": "SPP-1",
        "jp": "SPP-1",
        "en": "SPP-1"
    },
    "99": {
        "type": "HG",
        "id": "99",
        "cn": "Mk23",
        "code": "Mk23",
        "icon": "Icon_Mk23.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_Mk23.png": {
                "cn": "Mk23",
                "kr": "Mk23",
                "jp": "Gr Mk23",
                "en": "Gr Mk23",
                "alt": "pic_Mk23_D.png"
            },
            "pic_Mk23_8.png": {
                "cn": "MK23-甜心小恶魔",
                "icon": "Icon_Mk23_8.png",
                "alt": "pic_Mk23_8_D.png",
                "kr": "MK23 - 스위트 데빌",
                "jp": "スイートな小悪魔",
                "en": "Impish Sweetheart"
            },
            "pic_Mk23_1805.png": {
                "cn": "Mk23-蜂糖花",
                "icon": "Icon_Mk23_1805.png",
                "alt": "pic_Mk23_1805_D.png",
                "kr": "Mk23 - 브랜디시아",
                "jp": "蜂蜜花",
                "en": "Honey Flower"
            },
            "pic_Mk23_3105.png": {
                "cn": "Mk23-传达到的心意",
                "icon": "Icon_Mk23_3105.png",
                "alt": "pic_Mk23_3105_D.png",
                "kr": "Mk23 - 전해진 마음",
                "jp": "届いた気持ち",
                "en": "Conveyed Feelings"
            },
            "pic_Mk23_3705.png": {
                "cn": "Mk23-宣告开学的猫之歌",
                "icon": "Icon_Mk23_3705.png",
                "alt": "pic_Mk23_3705_D.png",
                "kr": "Mk23 - 개학을 알리는 고양이 노래",
                "jp": "始業を告げる猫の歌",
                "en": "New Term Begins with a Meow"
            }
        },
        "kr": "Mk23",
        "jp": "Gr Mk23",
        "en": "Gr Mk23"
    },
    "100": {
        "type": "HG",
        "id": "100",
        "cn": "P7",
        "code": "P7",
        "icon": "Icon_P7.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_P7.png": {
                "cn": "P7",
                "kr": "P7",
                "jp": "P7",
                "en": "P7",
                "alt": "pic_P7_D.png"
            },
            "pic_P7_606.png": {
                "cn": "P7-掌心约定",
                "icon": "Icon_P7_606.png",
                "alt": "pic_P7_606_D.png",
                "kr": "P7 - 손 도장",
                "jp": "掌の約束",
                "en": "Pinky Swear"
            },
            "pic_P7_1404.png": {
                "cn": "P7-魔枪修女",
                "icon": "Icon_P7_1404.png",
                "alt": "pic_P7_1404_D.png",
                "kr": "P7 - 마총의 수녀",
                "jp": "魔銃シスター",
                "en": "Sister Gunslinger"
            }
        },
        "kr": "P7",
        "jp": "P7",
        "en": "P7"
    },
    "101": {
        "type": "SMG",
        "id": "101",
        "cn": "UMP9",
        "code": "UMP9",
        "icon": "Icon_UMP9.png",
        "modded": true,
        "rarity": 4,
        "skins": {
            "pic_UMP9.png": {
                "cn": "UMP9",
                "kr": "UMP9",
                "jp": "UMP9",
                "en": "UMP9",
                "alt": "pic_UMP9_D.png"
            },
            "pic_UMP9Mod.png": {
                "cn": "UMP9",
                "kr": "UMP9",
                "jp": "UMP9",
                "en": "UMP9",
                "icon": "mod",
                "alt": "pic_UMP9Mod_D.png"
            },
            "pic_UMP9_409.png": {
                "cn": "UMP9-\"我来晚了?\"",
                "icon": "Icon_UMP9_409.png",
                "alt": "pic_UMP9_409_D.png",
                "kr": "UMP9 - \"내가 좀 늦었지?\"",
                "jp": "「待った？」",
                "en": "\"Am I Late?\""
            },
            "pic_UMP9_536.png": {
                "cn": "UMP9-偿愿的礼花魔法师",
                "icon": "Icon_UMP9_536.png",
                "alt": "pic_UMP9_536_D.png",
                "kr": "UMP9 - 소원을 이룬 마술사",
                "jp": "願いを叶える花の魔術師",
                "en": "The Wish-Granting Sorceress of Fireworks"
            },
            "pic_UMP9_556.png": {
                "cn": "UMP9-波莱罗舞雀",
                "icon": "Icon_UMP9_556.png",
                "alt": "pic_UMP9_556_D.png",
                "kr": "UMP9 - 볼레로 댄스",
                "jp": "ボレロを舞う雀",
                "en": "Bolero Dance Bird"
            },
            "pic_UMP9_2106.png": {
                "cn": "UMP9-世界之歌",
                "icon": "Icon_UMP9_2106.png",
                "alt": "pic_UMP9_2106_D.png",
                "kr": "UMP9 - 세계의 노래",
                "jp": "世界の歌",
                "en": "The World's Melody"
            },
            "pic_UMP9_3404.png": {
                "cn": "UMP9-柴犬侦查员",
                "icon": "Icon_UMP9_3404.png",
                "alt": "pic_UMP9_3404_D.png",
                "kr": "UMP9 - 킁킁 수사관",
                "jp": "柴犬すかうたー",
                "en": "Shiba Investigator"
            },
            "pic_UMP9_6704.png": {
                "cn": "UMP9-幽玄旅人",
                "icon": "Icon_UMP9_6704.png",
                "alt": "pic_UMP9_6704_D.png",
                "kr": "UMP9 - 유현의 여행객",
                "jp": "幽玄の旅人",
                "en": ""
            }
        },
        "kr": "UMP9",
        "jp": "UMP9",
        "en": "UMP9",
        "moddedIcon": "Icon_UMP9Mod.png",
        "modRarity": 5
    },
    "102": {
        "type": "SMG",
        "id": "102",
        "cn": "UMP40",
        "code": "UMP40",
        "icon": "Icon_UMP40.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_UMP40.png": {
                "cn": "UMP40",
                "kr": "UMP40",
                "jp": "UMP40",
                "en": "UMP40",
                "alt": "pic_UMP40_D.png"
            },
            "pic_UMP40_539.png": {
                "cn": "UMP40-守望心愿的暗影女巫",
                "icon": "Icon_UMP40_539.png",
                "alt": "pic_UMP40_539_D.png",
                "kr": "UMP40 - 소원을 지키는 마녀",
                "jp": "願いを見守る影の魔女",
                "en": "The Wish-Preserving Witch of Shadows"
            },
            "pic_UMP40_559.png": {
                "cn": "UMP40-克莱因间奏",
                "icon": "Icon_UMP40_559.png",
                "alt": "pic_UMP40_559_D.png",
                "kr": "UMP40 - 클라인 인터루드",
                "jp": "クラインの間奏曲",
                "en": "Kleines Ritornello"
            }
        },
        "kr": "UMP40",
        "jp": "UMP40",
        "en": "UMP40"
    },
    "103": {
        "type": "SMG",
        "id": "103",
        "cn": "UMP45",
        "code": "UMP45",
        "icon": "Icon_UMP45.png",
        "modded": true,
        "rarity": 4,
        "skins": {
            "pic_UMP45.png": {
                "cn": "UMP45",
                "kr": "UMP45",
                "jp": "UMP45",
                "en": "UMP45",
                "alt": "pic_UMP45_D.png"
            },
            "pic_UMP45Mod.png": {
                "cn": "UMP45",
                "kr": "UMP45",
                "jp": "UMP45",
                "en": "UMP45",
                "icon": "mod",
                "alt": "pic_UMP45Mod_D.png"
            },
            "pic_UMP45_410.png": {
                "cn": "UMP45-\"下不为例。\"",
                "icon": "Icon_UMP45_410.png",
                "alt": "pic_UMP45_410_D.png",
                "kr": "UMP45 - \"이번만이야\"",
                "jp": "「今回だけだから」",
                "en": "\"Just This Time.\""
            },
            "pic_UMP45_521.png": {
                "cn": "UMP45-冬之旅",
                "icon": "Icon_UMP45_521.png",
                "alt": "pic_UMP45_521_D.png",
                "kr": "UMP45 - 겨울 여행",
                "jp": "冬の旅",
                "en": "Winter Trip"
            },
            "pic_UMP45_535.png": {
                "cn": "UMP45-逐愿的礼花魔法师",
                "icon": "Icon_UMP45_535.png",
                "alt": "pic_UMP45_535_D.png",
                "kr": "UMP45 - 소원을 좇는 마술사",
                "jp": "願いを追う花の魔術師",
                "en": "The Wish-Making Sorceress of Fireworks"
            },
            "pic_UMP45_555.png": {
                "cn": "UMP45-旋转彭罗斯",
                "icon": "Icon_UMP45_555.png",
                "alt": "pic_UMP45_555_D.png",
                "kr": "UMP45 - 펜로즈 스핀",
                "jp": "回るペンローズ",
                "en": "Penrose Spiral"
            },
            "pic_UMP45_2107.png": {
                "cn": "UMP45-钻石之花",
                "icon": "Icon_UMP45_2107.png",
                "alt": "pic_UMP45_2107_D.png",
                "kr": "UMP45 - 다이아몬드의 꽃",
                "jp": "ダイヤの花びら",
                "en": "Diamond Flower"
            },
            "pic_UMP45_3403.png": {
                "cn": "UMP45-特工垂耳兔",
                "icon": "Icon_UMP45_3403.png",
                "alt": "pic_UMP45_3403_D.png",
                "kr": "UMP45 - 깡총 요원",
                "jp": "たれうさSS",
                "en": "Agent Lop Rabbit"
            },
            "pic_UMP45_5405.png": {
                "cn": "UMP45-侘寂旅人",
                "icon": "Icon_UMP45_5405.png",
                "alt": "pic_UMP45_5405_D.png",
                "kr": "UMP45 - 고독한 여행인",
                "jp": "寂びの過客にして",
                "en": "Lonely Traveler of Eternity"
            }
        },
        "kr": "UMP45",
        "jp": "UMP45",
        "en": "UMP45",
        "moddedIcon": "Icon_UMP45Mod.png",
        "modRarity": 5
    },
    "104": {
        "type": "SMG",
        "id": "104",
        "cn": "G36C",
        "code": "G36C",
        "icon": "Icon_G36C.png",
        "modded": true,
        "rarity": 5,
        "skins": {
            "pic_G36C.png": {
                "cn": "G36C",
                "kr": "G36C",
                "jp": "Gr G36c",
                "en": "Gr G36c",
                "alt": "pic_G36C_D.png"
            },
            "pic_G36CMod.png": {
                "cn": "G36C",
                "kr": "G36C",
                "jp": "Gr G36c",
                "en": "Gr G36c",
                "icon": "mod",
                "alt": "pic_G36CMod_D.png"
            },
            "pic_G36C_1202.png": {
                "cn": "G36C-夏天·烟火·向阳之诗",
                "icon": "Icon_G36C_1202.png",
                "alt": "pic_G36C_1202_D.png",
                "kr": "G36C - 여름·불꽃놀이·양지의 시",
                "jp": "夏・花火・朝顔",
                "en": "Ode to Summer"
            },
            "pic_G36C_3103.png": {
                "cn": "G36C-迈出步伐的你",
                "icon": "Icon_G36C_3103.png",
                "alt": "pic_G36C_3103_D.png",
                "kr": "G36C - 행복을 향해서",
                "jp": "歩き出すあなた",
                "en": "You Who Steps Up"
            },
            "pic_G36C_3802.png": {
                "cn": "G36C-灼眼的G36C",
                "icon": "Icon_G36C_3802.png",
                "alt": "pic_G36C_3802_D.png",
                "kr": "G36C - 적안의 G36C",
                "jp": "灼眼のG36c",
                "en": "Burning-Eyed Gr G36c"
            },
            "pic_G36C_5201.png": {
                "cn": "G36C-红色贝雷帽",
                "icon": "Icon_G36C_5201.png",
                "alt": "pic_G36C_5201_D.png",
                "kr": "G36C - 붉은 베레모",
                "jp": "レッドベレー",
                "en": "Red Beret"
            }
        },
        "kr": "G36C",
        "jp": "Gr G36c",
        "en": "Gr G36c",
        "moddedIcon": "Icon_G36CMod.png",
        "modRarity": 6
    },
    "105": {
        "type": "AR",
        "id": "105",
        "cn": "OTs-12",
        "code": "OTs12",
        "icon": "Icon_OTs12.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_OTs12.png": {
                "cn": "OTs-12",
                "kr": "OTs-12",
                "jp": "OTs-12",
                "en": "OTs-12",
                "alt": "pic_OTs12_D.png"
            },
            "pic_OTs12_3605.png": {
                "cn": "OTs-12-百花缭乱",
                "icon": "Icon_OTs12_3605.png",
                "alt": "pic_OTs12_3605_D.png",
                "kr": "OTs-12 - 백화요란",
                "jp": "百花繚乱",
                "en": "Efflorescence"
            }
        },
        "kr": "OTs-12",
        "jp": "OTs-12",
        "en": "OTs-12"
    },
    "106": {
        "type": "AR",
        "id": "106",
        "cn": "FAL",
        "code": "FNFAL",
        "icon": "Icon_FNFAL.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_FNFAL.png": {
                "cn": "FAL",
                "kr": "FAL",
                "jp": "FAL",
                "en": "FAL",
                "alt": "pic_FNFAL_D.png"
            },
            "pic_FNFAL_308.png": {
                "cn": "FAL-冬幕补给行动",
                "icon": "Icon_FNFAL_308.png",
                "alt": "pic_FNFAL_308_D.png",
                "kr": "FAL - 겨울 보급 작전",
                "jp": "ウィンターヴェール補給作戦",
                "en": "Winter Supply"
            },
            "pic_FNFAL_607.png": {
                "cn": "FAL-最重要的日子",
                "icon": "Icon_FNFAL_607.png",
                "alt": "pic_FNFAL_607_D.png",
                "kr": "FAL - 최고로 중요한 날",
                "jp": "一番大事な日",
                "en": "The Big Day"
            },
            "pic_FNFAL_2406.png": {
                "cn": "FAL-FAL的夏天",
                "icon": "Icon_FNFAL_2406.png",
                "alt": "pic_FNFAL_2406_D.png",
                "kr": "FAL - FAL의 여름",
                "jp": "FALの夏",
                "en": "FAL's Summer"
            }
        },
        "kr": "FAL",
        "jp": "FAL",
        "en": "FAL"
    },
    "107": {
        "type": "AR",
        "id": "107",
        "cn": "F2000",
        "code": "F2000",
        "icon": "Icon_F2000.png",
        "modded": false,
        "rarity": 2,
        "skins": {
            "pic_F2000.png": {
                "cn": "F2000",
                "kr": "F2000",
                "jp": "FF F2000",
                "en": "FF F2000",
                "alt": "pic_F2000_D.png"
            }
        },
        "kr": "F2000",
        "jp": "FF F2000",
        "en": "FF F2000"
    },
    "108": {
        "type": "AR",
        "id": "108",
        "cn": "CZ-805",
        "code": "CZ805",
        "icon": "Icon_CZ805.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_CZ805.png": {
                "cn": "CZ-805",
                "kr": "CZ-805",
                "jp": "CZ-805",
                "en": "CZ-805",
                "alt": "pic_CZ805_D.png"
            },
            "pic_CZ805_5807.png": {
                "cn": "CZ-805-金色回忆",
                "icon": "Icon_CZ805_5807.png",
                "alt": "pic_CZ805_5807_D.png",
                "kr": "CZ-805 - 황금빛 메모리얼",
                "jp": "金色の思い出",
                "en": "Golden Memories"
            }
        },
        "kr": "CZ-805",
        "jp": "CZ-805",
        "en": "CZ-805"
    },
    "109": {
        "type": "MG",
        "id": "109",
        "cn": "MG5",
        "code": "MG5",
        "icon": "Icon_MG5.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_MG5.png": {
                "cn": "MG5",
                "kr": "MG5",
                "jp": "Gr MG5",
                "en": "Gr MG5",
                "alt": "pic_MG5_D.png"
            },
            "pic_MG5_309.png": {
                "cn": "MG5-绯红守夜人",
                "icon": "Icon_MG5_309.png",
                "alt": "pic_MG5_309_D.png",
                "kr": "MG5 - 새빨간 야간경비원",
                "jp": "緋色のナイトウォッチ",
                "en": "Crimson Guardian"
            },
            "pic_MG5_1504.png": {
                "cn": "MG5-荒野猎人",
                "icon": "Icon_MG5_1504.png",
                "alt": "pic_MG5_1504_D.png",
                "kr": "MG5 - 황야의 사냥꾼",
                "jp": "荒野のハンター",
                "en": "Call of the Hunter"
            },
            "pic_MG5_2501.png": {
                "cn": "MG5-黑疫骑士",
                "icon": "Icon_MG5_2501.png",
                "alt": "pic_MG5_2501_D.png",
                "kr": "MG5 - 플레이그 나이트",
                "jp": "Plague　Knight",
                "en": "Knight of Calamity"
            },
            "pic_MG5_4902.png": {
                "cn": "MG5-暗闇荼蘼",
                "icon": "Icon_MG5_4902.png",
                "alt": "pic_MG5_4902_D.png",
                "kr": "MG5 - 어둠에 우린 차",
                "jp": "闇夜に浮かぶ頭巾薔薇",
                "en": "Dark Blossom of the End"
            }
        },
        "kr": "MG5",
        "jp": "Gr MG5",
        "en": "Gr MG5"
    },
    "110": {
        "type": "MG",
        "id": "110",
        "cn": "FG42",
        "code": "FG42",
        "icon": "Icon_FG42.png",
        "modded": false,
        "rarity": 2,
        "skins": {
            "pic_FG42.png": {
                "cn": "FG42",
                "kr": "FG42",
                "jp": "FG42",
                "en": "FG42",
                "alt": "pic_FG42_D.png"
            }
        },
        "kr": "FG42",
        "jp": "FG42",
        "en": "FG42"
    },
    "111": {
        "type": "MG",
        "id": "111",
        "cn": "AAT-52",
        "code": "AAT52",
        "icon": "Icon_AAT52.png",
        "modded": false,
        "rarity": 2,
        "skins": {
            "pic_AAT52.png": {
                "cn": "AAT-52",
                "kr": "AAT-52",
                "jp": "AAT-52",
                "en": "AAT-52",
                "alt": "pic_AAT52_D.png"
            }
        },
        "kr": "AAT-52",
        "jp": "AAT-52",
        "en": "AAT-52"
    },
    "112": {
        "type": "MG",
        "id": "112",
        "cn": "内格夫",
        "code": "NEGEV",
        "icon": "Icon_NEGEV.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_NEGEV.png": {
                "cn": "内格夫",
                "kr": "네게브",
                "jp": "ネゲヴ",
                "en": "Negev",
                "alt": "pic_NEGEV_D.png"
            },
            "pic_NEGEV_904.png": {
                "cn": "内格夫-小流浪家",
                "icon": "Icon_NEGEV_904.png",
                "alt": "pic_NEGEV_904_D.png",
                "kr": "네게브 - 조그만 방랑자",
                "jp": "幼き流離人",
                "en": "Little Drifter"
            },
            "pic_NEGEV_3202.png": {
                "cn": "内格夫-黑石姬",
                "icon": "Icon_NEGEV_3202.png",
                "alt": "pic_NEGEV_3202_D.png",
                "kr": "네게브 - 프린세스 다크스톤",
                "jp": "黒石姫",
                "en": "Obsidian Princess"
            }
        },
        "kr": "네게브",
        "jp": "ネゲヴ",
        "en": "Negev"
    },
    "113": {
        "type": "HG",
        "id": "113",
        "cn": "谢尔久科夫",
        "code": "SPS",
        "icon": "Icon_SPS.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_SPS.png": {
                "cn": "谢尔久科夫",
                "kr": "세르듀코프",
                "jp": "セルジュコフ",
                "en": "Serdyukov",
                "alt": "pic_SPS_D.png"
            },
            "pic_SPS_3506.png": {
                "cn": "谢尔久科夫-黑鸦救生员",
                "icon": "Icon_SPS_3506.png",
                "alt": "pic_SPS_3506_D.png",
                "kr": "세르듀코프 - 까마귀 구조대원",
                "jp": "カラスの救命員",
                "en": "Crow Lifeguard"
            }
        },
        "kr": "세르듀코프",
        "jp": "セルジュコフ",
        "en": "Serdyukov"
    },
    "114": {
        "type": "HG",
        "id": "114",
        "cn": "维尔德MkⅡ",
        "code": "Welrod",
        "icon": "Icon_Welrod.png",
        "modded": true,
        "rarity": 5,
        "skins": {
            "pic_Welrod.png": {
                "cn": "维尔德MkⅡ",
                "kr": "웰로드MkⅡ",
                "jp": "ウェルロッドMkⅡ",
                "en": "Welrod MkⅡ",
                "alt": "pic_Welrod_D.png"
            },
            "pic_WelrodMod.png": {
                "cn": "维尔德MkⅡ",
                "kr": "웰로드MkⅡ",
                "jp": "ウェルロッドMkⅡ",
                "en": "Welrod MkⅡ",
                "icon": "mod",
                "alt": "pic_WelrodMod_D.png"
            },
            "pic_Welrod_411.png": {
                "cn": "维尔德MkⅡ-英国恋人",
                "icon": "Icon_Welrod_411.png",
                "alt": "pic_Welrod_411_D.png",
                "kr": "웰로드MkⅡ - 영국 연인",
                "jp": "英国の恋人",
                "en": "English in Love"
            },
            "pic_Welrod_1401.png": {
                "cn": "维尔德MkⅡ-暗影之王",
                "icon": "Icon_Welrod_1401.png",
                "alt": "pic_Welrod_1401_D.png",
                "kr": "웰로드MkⅡ - 그림자의 왕",
                "jp": "闇の王",
                "en": "Lord of Shadow"
            },
            "pic_Welrod_2103.png": {
                "cn": "维尔德MkⅡ-夜幕危机",
                "icon": "Icon_Welrod_2103.png",
                "alt": "pic_Welrod_2103_D.png",
                "kr": "웰로드 MkⅡ - 해 질 무렵의 위기",
                "jp": "ナイトフォール",
                "en": "Nightfall Crisis"
            }
        },
        "kr": "웰로드MkⅡ",
        "jp": "ウェルロッドMkⅡ",
        "en": "Welrod MkⅡ",
        "moddedIcon": "Icon_WelrodMod.png",
        "modRarity": 6
    },
    "115": {
        "type": "SMG",
        "id": "115",
        "cn": "索米",
        "code": "KP31",
        "icon": "Icon_KP31.png",
        "modded": true,
        "rarity": 5,
        "skins": {
            "pic_KP31.png": {
                "cn": "索米",
                "kr": "수오미",
                "jp": "スオミ",
                "en": "Suomi",
                "alt": "pic_KP31_D.png"
            },
            "pic_KP31Mod.png": {
                "cn": "索米",
                "kr": "수오미",
                "jp": "スオミ",
                "en": "Suomi",
                "icon": "mod",
                "alt": "pic_KP31Mod_D.png"
            },
            "pic_KP31_310.png": {
                "cn": "索米-耳朵山的雪妖精",
                "icon": "Icon_KP31_310.png",
                "alt": "pic_KP31_310_D.png",
                "kr": "수오미 - 코르바툰투리의 눈 요정",
                "jp": "スノウエルフ",
                "en": "Korvatunturi Pixie"
            },
            "pic_KP31_1103.png": {
                "cn": "索米-仲夏夜的精灵",
                "icon": "Icon_KP31_1103.png",
                "alt": "pic_KP31_1103_D.png",
                "kr": "수오미 - 한여름 밤의 요정",
                "jp": "仲夏のエルフ",
                "en": "Midsummer Pixie"
            },
            "pic_KP31_3101.png": {
                "cn": "索米-幸福使命",
                "icon": "Icon_KP31_3101.png",
                "alt": "pic_KP31_3101_D.png",
                "kr": "수오미 - 행복한 사명",
                "jp": "幸せの使命",
                "en": "Blissful Mission"
            }
        },
        "kr": "수오미",
        "jp": "スオミ",
        "en": "Suomi",
        "moddedIcon": "Icon_KP31Mod.png",
        "modRarity": 6
    },
    "116": {
        "type": "SMG",
        "id": "116",
        "cn": "Z-62",
        "code": "Z62",
        "icon": "Icon_Z62.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_Z62.png": {
                "cn": "Z-62",
                "kr": "Z-62",
                "jp": "Z-62",
                "en": "Z-62",
                "alt": "pic_Z62_D.png"
            },
            "pic_Z62_573.png": {
                "cn": "Z-62-午后闲弈",
                "icon": "Icon_Z62_573.png",
                "alt": "pic_Z62_573_D.png",
                "kr": "Z-62 - 오후 느긋하게 한 판",
                "jp": "午後の一局",
                "en": "Casual Afternoon Game"
            },
            "pic_Z62_3507.png": {
                "cn": "Z-62-游泳课题",
                "icon": "Icon_Z62_3507.png",
                "alt": "pic_Z62_3507_D.png",
                "kr": "Z-62 - 수영 수업",
                "jp": "水泳課題",
                "en": "Swimming Lesson"
            }
        },
        "kr": "Z-62",
        "jp": "Z-62",
        "en": "Z-62"
    },
    "117": {
        "type": "RF",
        "id": "117",
        "cn": "PSG-1",
        "code": "PSG1",
        "icon": "Icon_PSG1.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_PSG1.png": {
                "cn": "PSG-1",
                "kr": "PSG-1",
                "jp": "Gr PSG-1",
                "en": "Gr PSG-1",
                "alt": "pic_PSG1_D.png"
            },
            "pic_PSG1_3808.png": {
                "cn": "PSG-1-魅影突击",
                "icon": "Icon_PSG1_3808.png",
                "alt": "pic_PSG1_3808_D.png",
                "kr": "PSG-1 - 한밤중의 습격",
                "jp": "とつげきお化け",
                "en": "Phantom Assault"
            }
        },
        "kr": "PSG-1",
        "jp": "Gr PSG-1",
        "en": "Gr PSG-1"
    },
    "118": {
        "type": "AR",
        "id": "118",
        "cn": "9A-91",
        "code": "9A91",
        "icon": "Icon_9A91.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_9A91.png": {
                "cn": "9A-91",
                "kr": "9A-91",
                "jp": "9A-91",
                "en": "9A-91",
                "alt": "pic_9A91_D.png"
            },
            "pic_9A91_1302.png": {
                "cn": "9A-91-子弹咖啡馆",
                "icon": "Icon_9A91_1302.png",
                "alt": "pic_9A91_1302_D.png",
                "kr": "9A-91 - 총알 카페",
                "jp": "弾丸カフェ",
                "en": "Bullets Cafe"
            },
            "pic_9A91_4104.png": {
                "cn": "9A-91-蕊梦矢",
                "icon": "Icon_9A91_4104.png",
                "alt": "pic_9A91_4104_D.png",
                "kr": "9A-91 - 꿈을 담은 화살",
                "jp": "花と夢の破魔矢",
                "en": "Purifying Arrow, Flowers and Dreams"
            },
            "pic_9A91_6204.png": {
                "cn": "9A-91-忠友同游",
                "icon": "Icon_9A91_6204.png",
                "alt": "pic_9A91_6204_D.png",
                "kr": "9A-91 - 충성스러운 길동무",
                "jp": "忠愛なる友とともに",
                "en": "A Loyal Friend's Company"
            }
        },
        "kr": "9A-91",
        "jp": "9A-91",
        "en": "9A-91"
    },
    "119": {
        "type": "AR",
        "id": "119",
        "cn": "OTs-14",
        "code": "OTs14",
        "icon": "Icon_OTs14.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_OTs14.png": {
                "cn": "OTs-14",
                "kr": "OTs-14",
                "jp": "OTs-14",
                "en": "OTs-14",
                "alt": "pic_OTs14_D.png"
            },
            "pic_OTs14_1203.png": {
                "cn": "OTs-14-樱吹雪",
                "icon": "Icon_OTs14_1203.png",
                "alt": "pic_OTs14_1203_D.png",
                "kr": "OTs-14 - 흩날리는 벚꽃눈",
                "jp": "桜吹雪",
                "en": "Flurry of Petals"
            },
            "pic_OTs14_3001.png": {
                "cn": "OTs-14-紫雨心",
                "icon": "Icon_OTs14_3001.png",
                "alt": "pic_OTs14_3001_D.png",
                "kr": "OTs-14 - 크라슐라",
                "jp": "紫雨心",
                "en": "Sangria Succulent"
            },
            "pic_OTs14_4501.png": {
                "cn": "OTs-14-晚宴的统治者",
                "icon": "Icon_OTs14_4501.png",
                "alt": "pic_OTs14_4501_D.png",
                "kr": "OTs-14 - 연회의 지배자",
                "jp": "宴会を統べる者",
                "en": "Ruler of the Banquet"
            },
            "pic_OTs14_5602.png": {
                "cn": "OTs-14-天意佳人",
                "icon": "Icon_OTs14_5602.png",
                "alt": "pic_OTs14_5602_D.png",
                "kr": "OTs-14 - 하늘이 점쳐준 인연",
                "jp": "運命の佳人",
                "en": "Destined Love"
            }
        },
        "kr": "OTs-14",
        "jp": "OTs-14",
        "en": "OTs-14"
    },
    "120": {
        "type": "AR",
        "id": "120",
        "cn": "ARX-160",
        "code": "ARX160",
        "icon": "Icon_ARX160.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_ARX160.png": {
                "cn": "ARX-160",
                "kr": "ARX-160",
                "jp": "ARX-160",
                "en": "ARX-160",
                "alt": "pic_ARX160_D.png"
            }
        },
        "kr": "ARX-160",
        "jp": "ARX-160",
        "en": "ARX-160"
    },
    "121": {
        "type": "MG",
        "id": "121",
        "cn": "Mk48",
        "code": "Mk48",
        "icon": "Icon_Mk48.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_Mk48.png": {
                "cn": "Mk48",
                "kr": "Mk48",
                "jp": "Mk48",
                "en": "Mk48",
                "alt": "pic_Mk48_D.png"
            },
            "pic_Mk48_4804.png": {
                "cn": "Mk48-硝烟号令",
                "icon": "Icon_Mk48_4804.png",
                "alt": "pic_Mk48_4804_D.png",
                "kr": "Mk48 - 초연의 호령",
                "jp": "硝煙の号令",
                "en": "Gunsmoke Decree"
            }
        },
        "kr": "Mk48",
        "jp": "Mk48",
        "en": "Mk48"
    },
    "122": {
        "type": "AR",
        "id": "122",
        "cn": "G11",
        "code": "G11",
        "icon": "Icon_G11.png",
        "modded": true,
        "rarity": 5,
        "skins": {
            "pic_G11.png": {
                "cn": "G11",
                "kr": "G11",
                "jp": "Gr G11",
                "en": "Gr G11",
                "alt": "pic_G11_D.png"
            },
            "pic_G11Mod.png": {
                "cn": "G11",
                "kr": "G11",
                "jp": "Gr G11",
                "en": "Gr G11",
                "icon": "mod",
                "alt": "pic_G11Mod_D.png"
            },
            "pic_G11_9.png": {
                "cn": "G11-僵尸家里蹲",
                "icon": "Icon_G11_9.png",
                "alt": "pic_G11_9_D.png",
                "kr": "G11 - 은톨이 좀비",
                "jp": "引きこもりゾンビ",
                "en": "Neet Zombie"
            },
            "pic_G11_538.png": {
                "cn": "G11-寻找勇气的雷克斯兔",
                "icon": "Icon_G11_538.png",
                "alt": "pic_G11_538_D.png",
                "kr": "G11 - 용기를 원하는 토끼",
                "jp": "勇気を求めるレッキスラビット",
                "en": "The Rex Rabbit In Search of Courage"
            },
            "pic_G11_558.png": {
                "cn": "G11-混乱交响曲",
                "icon": "Icon_G11_558.png",
                "alt": "pic_G11_558_D.png",
                "kr": "G11 - 카오스 심포니",
                "jp": "混迷のシンフォニー",
                "en": "Chaotic Symphony"
            },
            "pic_G11_572.png": {
                "cn": "G11-秋眠·随想Ⅺ",
                "icon": "Icon_G11_572.png",
                "alt": "pic_G11_572_D.png",
                "kr": "G11 - 가을 잠·프리스타일Ⅺ",
                "jp": "秋眠·随想Ⅺ",
                "en": ""
            },
            "pic_G11_1602.png": {
                "cn": "G11-我最美丽的礼物",
                "icon": "Icon_G11_1602.png",
                "alt": "pic_G11_1602_D.png",
                "kr": "G11 - 가장 아름다운 선물",
                "jp": "一番素敵な贈り物",
                "en": "Schoenstes Geschenk"
            },
            "pic_G11_2502.png": {
                "cn": "G11-朵拉贡 Jr.",
                "icon": "Icon_G11_2502.png",
                "alt": "pic_G11_2502_D.png",
                "kr": "G11 - 용가리 주니어",
                "jp": "Dragon　Jr.",
                "en": "Dragon Jr."
            },
            "pic_G11_4102.png": {
                "cn": "G11-福鼠懒春",
                "icon": "Icon_G11_4102.png",
                "alt": "pic_G11_4102_D.png",
                "kr": "G11 - 봄잠 자는 쥐",
                "jp": "福ねずみの寝正月",
                "en": "Lucky Rat's Lazy Spring"
            }
        },
        "kr": "G11",
        "jp": "Gr G11",
        "en": "Gr G11",
        "moddedIcon": "Icon_G11Mod.png",
        "modRarity": 6
    },
    "123": {
        "type": "HG",
        "id": "123",
        "cn": "P99",
        "code": "P99",
        "icon": "Icon_P99.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_P99.png": {
                "cn": "P99",
                "kr": "P99",
                "jp": "P99",
                "en": "P99",
                "alt": "pic_P99_D.png"
            }
        },
        "kr": "P99",
        "jp": "P99",
        "en": "P99"
    },
    "124": {
        "type": "RF",
        "id": "124",
        "cn": "S-SASS",
        "code": "SuperSASS",
        "icon": "Icon_SuperSASS.png",
        "modded": true,
        "rarity": 3,
        "skins": {
            "pic_SuperSASS.png": {
                "cn": "S-SASS",
                "kr": "Super SASS",
                "jp": "Super SASS",
                "en": "Super SASS",
                "alt": "pic_SuperSASS_D.png"
            },
            "pic_SuperSASSMod.png": {
                "cn": "S-SASS",
                "kr": "Super SASS",
                "jp": "Super SASS",
                "en": "Super SASS",
                "icon": "mod",
                "alt": "pic_SuperSASSMod_D.png"
            },
            "pic_SuperSASS_1407.png": {
                "cn": "S-SASS-狼行者",
                "icon": "Icon_SuperSASS_1407.png",
                "alt": "pic_SuperSASS_1407_D.png",
                "kr": "Super SASS - 늑대 소녀",
                "jp": "ウルフ・ウォーカー",
                "en": "Wolf Walker"
            }
        },
        "kr": "Super SASS",
        "jp": "Super SASS",
        "en": "Super SASS",
        "moddedIcon": "Icon_SuperSASSMod.png",
        "modRarity": 4
    },
    "125": {
        "type": "MG",
        "id": "125",
        "cn": "MG4",
        "code": "MG4",
        "icon": "Icon_MG4.png",
        "modded": true,
        "rarity": 5,
        "skins": {
            "pic_MG4.png": {
                "cn": "MG4",
                "kr": "MG4",
                "jp": "Gr MG4",
                "en": "Gr MG4",
                "alt": "pic_MG4_D.png"
            },
            "pic_MG4Mod.png": {
                "cn": "MG4",
                "kr": "MG4",
                "jp": "Gr MG4",
                "en": "Gr MG4",
                "icon": "mod",
                "alt": "pic_MG4Mod_D.png"
            },
            "pic_MG4_703.png": {
                "cn": "MG4-生存社员",
                "icon": "Icon_MG4_703.png",
                "alt": "pic_MG4_703_D.png",
                "kr": "MG4 - 생존멤버",
                "jp": "サバイバル社員",
                "en": "Survival Club"
            }
        },
        "kr": "MG4",
        "jp": "Gr MG4",
        "en": "Gr MG4",
        "moddedIcon": "Icon_MG4Mod.png",
        "modRarity": 6
    },
    "126": {
        "type": "HG",
        "id": "126",
        "cn": "NZ75",
        "code": "NZ75",
        "icon": "Icon_NZ75.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_NZ75.png": {
                "cn": "NZ75",
                "kr": "NZ75",
                "jp": "NZ75",
                "en": "NZ75",
                "alt": "pic_NZ75_D.png"
            },
            "pic_NZ75_403.png": {
                "cn": "NZ75-金姬菊",
                "icon": "Icon_NZ75_403.png",
                "alt": "pic_NZ75_403_D.png",
                "kr": "NZ75 - 국화꽃 소녀",
                "jp": "ゴールドデイジー",
                "en": "Chrysanthemum"
            },
            "pic_NZ75_1702.png": {
                "cn": "NZ75-ThanX！&Go2Hell！",
                "icon": "Icon_NZ75_1702.png",
                "alt": "pic_NZ75_1702_D.png",
                "kr": "NZ75 - ThanX!&Go2Hell!",
                "jp": "ThanX！&Go2Hell！",
                "en": "ThanX! & Go2Hell!"
            }
        },
        "kr": "NZ75",
        "jp": "NZ75",
        "en": "NZ75"
    },
    "127": {
        "type": "SMG",
        "id": "127",
        "cn": "79式",
        "code": "79type",
        "icon": "Icon_79type.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_79type.png": {
                "cn": "79式",
                "kr": "79식",
                "jp": "79式",
                "en": "Type79",
                "alt": "pic_79type_D.png"
            },
            "pic_79type_1402.png": {
                "cn": "79式-青丘狐",
                "icon": "Icon_79type_1402.png",
                "alt": "pic_79type_1402_D.png",
                "kr": "79식 - 구미호",
                "jp": "青丘狐",
                "en": "Nine-Tail Fox"
            },
            "pic_79type_3306.png": {
                "cn": "79式-星夜狐步",
                "icon": "Icon_79type_3306.png",
                "alt": "pic_79type_3306_D.png",
                "kr": "79식 - 별빛의 폭스트롯",
                "jp": "星空フォックストロット",
                "en": "Fox Steps Under Star Night"
            },
            "pic_79type_6904.png": {
                "cn": "79式-于尘埃间仰望",
                "icon": "Icon_79type_6904.png",
                "alt": "pic_79type_6904_D.png",
                "kr": "79식 - 티끌 사이에서 고개 들기",
                "jp": "",
                "en": ""
            }
        },
        "kr": "79식",
        "jp": "79式",
        "en": "Type79"
    },
    "128": {
        "type": "RF",
        "id": "128",
        "cn": "M99",
        "code": "M99",
        "icon": "Icon_M99.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_M99.png": {
                "cn": "M99",
                "kr": "M99",
                "jp": "M99",
                "en": "M99",
                "alt": "pic_M99_D.png"
            },
            "pic_M99_404.png": {
                "cn": "M99-仙客来",
                "icon": "Icon_M99_404.png",
                "alt": "pic_M99_404_D.png",
                "kr": "M99 - 시클라멘",
                "jp": "シクラメン",
                "en": "Cyclamen"
            },
            "pic_M99_1701.png": {
                "cn": "M99-兔子班",
                "icon": "Icon_M99_1701.png",
                "alt": "pic_M99_1701_D.png",
                "kr": "M99 - 토끼반",
                "jp": "うさぎ班",
                "en": "Rabbit Squad"
            },
            "pic_M99_3304.png": {
                "cn": "M99-白兔夏宴",
                "icon": "Icon_M99_3304.png",
                "alt": "pic_M99_3304_D.png",
                "kr": "M99 - 흰토끼 축제",
                "jp": "白うさぎのサマーパーティ",
                "en": "White Rabbit Summer Banquet"
            }
        },
        "kr": "M99",
        "jp": "M99",
        "en": "M99"
    },
    "129": {
        "type": "AR",
        "id": "129",
        "cn": "95式",
        "code": "95type",
        "icon": "Icon_95type.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_95type.png": {
                "cn": "95式",
                "kr": "95식",
                "jp": "95式",
                "en": "Type95",
                "alt": "pic_95type_D.png"
            },
            "pic_95type_405.png": {
                "cn": "95式-玉玲珑",
                "icon": "Icon_95type_405.png",
                "alt": "pic_95type_405_D.png",
                "kr": "95식 - 영롱한 옥",
                "jp": "グレース",
                "en": "Narcissus"
            },
            "pic_95type_1102.png": {
                "cn": "95式-夏鸣蝉",
                "icon": "Icon_95type_1102.png",
                "alt": "pic_95type_1102_D.png",
                "kr": "95식 - 여름의 풍류",
                "jp": "夏の蝉の声",
                "en": "Summer Cicada"
            },
            "pic_95type_3702.png": {
                "cn": "95式-纯白毕业祭",
                "icon": "Icon_95type_3702.png",
                "alt": "pic_95type_3702_D.png",
                "kr": "95식 - 순백의 졸업식",
                "jp": "純白の卒業式",
                "en": "Pure White Graduation"
            },
            "pic_95type_5604.png": {
                "cn": "95式-洋桔梗与她的季节",
                "icon": "Icon_95type_5604.png",
                "alt": "pic_95type_5604_D.png",
                "kr": "95식 - 리시안셔스의 계절",
                "jp": "ユーストマと彼女の季節",
                "en": "Prairie Gentian and Her Season"
            },
            "pic_95type_6401.png": {
                "cn": "95式-素白濯清涟",
                "icon": "Icon_95type_6401.png",
                "alt": "pic_95type_6401_D.png",
                "kr": "95식 - 티끌 없는 물결",
                "jp": "純白、清漣に濯はれて",
                "en": "White Lotus in Limpid Waters"
            },
            "pic_95type_7202.png": {
                "cn": "95式-春杪梦鸢人",
                "icon": "Icon_95type_7202.png",
                "alt": "pic_95type_7202_D.png",
                "kr": "95식 - 늦봄 연놀이",
                "en": ""
            }
        },
        "kr": "95식",
        "jp": "95式",
        "en": "Type95"
    },
    "130": {
        "type": "AR",
        "id": "130",
        "cn": "97式",
        "code": "97type",
        "icon": "Icon_97type.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_97type.png": {
                "cn": "97式",
                "kr": "97식",
                "jp": "97式",
                "en": "Type97",
                "alt": "pic_97type_D.png"
            },
            "pic_97type_406.png": {
                "cn": "97式-牡丹魁",
                "icon": "Icon_97type_406.png",
                "alt": "pic_97type_406_D.png",
                "kr": "97식 - 화려한 모란",
                "jp": "牡丹",
                "en": "Peony"
            },
            "pic_97type_3703.png": {
                "cn": "97式-迟到戏码",
                "icon": "Icon_97type_3703.png",
                "alt": "pic_97type_3703_D.png",
                "kr": "97식 - 지각 시츄에이션",
                "jp": "ちこくちこくー！",
                "en": "Late for School"
            },
            "pic_97type_5103.png": {
                "cn": "97式-魔女格莱特",
                "icon": "Icon_97type_5103.png",
                "alt": "pic_97type_5103_D.png",
                "kr": "97식 - 마녀 그레텔",
                "jp": "",
                "en": ""
            },
            "pic_97type_6902.png": {
                "cn": "97式-风中祝祷",
                "icon": "Icon_97type_6902.png",
                "alt": "pic_97type_6902_D.png",
                "kr": "97식 - 바람을 맞으며 기도",
                "jp": "",
                "en": ""
            }
        },
        "kr": "97식",
        "jp": "97式",
        "en": "Type97"
    },
    "131": {
        "type": "SMG",
        "id": "131",
        "cn": "EVO 3",
        "code": "EVO3",
        "icon": "Icon_EVO3.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_EVO3.png": {
                "cn": "EVO 3",
                "kr": "EVO 3",
                "jp": "EVO 3",
                "en": "EVO 3",
                "alt": "pic_EVO3_D.png"
            },
            "pic_EVO3_2109.png": {
                "cn": "EVO 3-白夜星语",
                "icon": "Icon_EVO3_2109.png",
                "alt": "pic_EVO3_2109_D.png",
                "kr": "EVO - 백야의 별 이야기",
                "jp": "白夜の星言葉",
                "en": "White Night Star"
            },
            "pic_EVO3_4607.png": {
                "cn": "EVO 3-EVO 3的早晨",
                "icon": "Icon_EVO3_4607.png",
                "alt": "pic_EVO3_4607_D.png",
                "kr": "EVO 3 - EVO3의 아침",
                "jp": "EVO 3の朝",
                "en": "EVO 3's Morning"
            },
            "pic_EVO3_5408.png": {
                "cn": "EVO 3-红花头筹",
                "icon": "Icon_EVO3_5408.png",
                "alt": "pic_EVO3_5408_D.png",
                "kr": "EVO 3 - 첫 붉은 꽃",
                "jp": "紅一番花",
                "en": "Scarlet First Bloom"
            },
            "pic_EVO3_7307.png": {
                "cn": "EVO 3-杏红之夏",
                "icon": "Icon_EVO3_7307.png",
                "alt": "pic_EVO3_7307_D.png",
                "kr": "EVO 3 - 진홍색 여름",
                "en": ""
            }
        },
        "kr": "EVO 3",
        "jp": "EVO 3",
        "en": "EVO 3"
    },
    "132": {
        "type": "HG",
        "id": "132",
        "cn": "59式",
        "code": "59type",
        "icon": "Icon_59type.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_59type.png": {
                "cn": "59式",
                "kr": "59식",
                "jp": "59式",
                "en": "Type59",
                "alt": "pic_59type_D.png"
            },
            "pic_59type_407.png": {
                "cn": "59式-报春花",
                "icon": "Icon_59type_407.png",
                "alt": "pic_59type_407_D.png",
                "kr": "59식 - 앵초",
                "jp": "サクラソウ",
                "en": "Fairy Primrose"
            }
        },
        "kr": "59식",
        "jp": "59式",
        "en": "Type59"
    },
    "133": {
        "type": "AR",
        "id": "133",
        "cn": "63式",
        "code": "63type",
        "icon": "Icon_63type.png",
        "modded": false,
        "rarity": 2,
        "skins": {
            "pic_63type.png": {
                "cn": "63式",
                "kr": "63식",
                "jp": "63式",
                "en": "Type63",
                "alt": "pic_63type_D.png"
            },
            "pic_63type_2004.png": {
                "cn": "63式-玄黄之鸑鷟",
                "icon": "Icon_63type_2004.png",
                "alt": "pic_63type_2004_D.png",
                "kr": "63식 - 현황의 봉황",
                "jp": "玄黄ノ鳳凰",
                "en": "Dusk Phoenix"
            }
        },
        "kr": "63식",
        "jp": "63式",
        "en": "Type63"
    },
    "134": {
        "type": "AR",
        "id": "134",
        "cn": "AR70",
        "code": "AR70",
        "icon": "Icon_AR70.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_AR70.png": {
                "cn": "AR70",
                "kr": "AR70",
                "jp": "AR70",
                "en": "AR70",
                "alt": "pic_AR70_D.png"
            }
        },
        "kr": "AR70",
        "jp": "AR70",
        "en": "AR70"
    },
    "135": {
        "type": "SMG",
        "id": "135",
        "cn": "SR-3MP",
        "code": "SR3MP",
        "icon": "Icon_SR3MP.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_SR3MP.png": {
                "cn": "SR-3MP",
                "kr": "SR-3MP",
                "jp": "SR-3MP",
                "en": "SR-3MP",
                "alt": "pic_SR3MP_D.png"
            },
            "pic_SR3MP_807.png": {
                "cn": "SR-3MP-黑兔玛奇朵",
                "icon": "Icon_SR3MP_807.png",
                "alt": "pic_SR3MP_807_D.png",
                "kr": "SR-3MP - 검은토끼 마키아또",
                "jp": "黒兎マキアート",
                "en": "Bunny Macchiato"
            },
            "pic_SR3MP_3704.png": {
                "cn": "SR-3MP-特攻队长兔",
                "icon": "Icon_SR3MP_3704.png",
                "alt": "pic_SR3MP_3704_D.png",
                "kr": "SR-3MP - 토끼 특공대장",
                "jp": "兎攻隊長",
                "en": "Commando Bunny"
            },
            "pic_SR3MP_4101.png": {
                "cn": "SR-3MP-神子上上签",
                "icon": "Icon_SR3MP_4101.png",
                "alt": "pic_SR3MP_4101_D.png",
                "kr": "SR-3MP - 무녀의 운수대통 부적",
                "jp": "巫女の大吉おみくじ",
                "en": "Shrine Maiden's Blessed Draw"
            }
        },
        "kr": "SR-3MP",
        "jp": "SR-3MP",
        "en": "SR-3MP"
    },
    "136": {
        "type": "SMG",
        "id": "136",
        "cn": "PP-19",
        "code": "PP19",
        "icon": "Icon_PP19.png",
        "modded": true,
        "rarity": 4,
        "skins": {
            "pic_PP19.png": {
                "cn": "PP-19",
                "kr": "PP-19",
                "jp": "PP-19",
                "en": "PP-19",
                "alt": "pic_PP19_D.png"
            },
            "pic_PP19Mod.png": {
                "cn": "PP-19",
                "kr": "PP-19",
                "jp": "PP-19",
                "en": "PP-19",
                "icon": "mod",
                "alt": "pic_PP19Mod_D.png"
            },
            "pic_PP19_2204.png": {
                "cn": "PP-19-青蛙小公主",
                "icon": "Icon_PP19_2204.png",
                "alt": "pic_PP19_2204_D.png",
                "kr": "PP-19 - 개구리 공주",
                "jp": "かえるの姫さま",
                "en": "Frog Princess"
            },
            "pic_PP19_4705.png": {
                "cn": "PP-19-冰冻之夏",
                "icon": "Icon_PP19_4705.png",
                "alt": "pic_PP19_4705_D.png",
                "kr": "PP-19 - 여름 얼리기",
                "jp": "凍りの夏",
                "en": "Icy Summer"
            }
        },
        "kr": "PP-19",
        "jp": "PP-19",
        "en": "PP-19",
        "moddedIcon": "Icon_PP19Mod.png",
        "modRarity": 5
    },
    "137": {
        "type": "SMG",
        "id": "137",
        "cn": "PP-19-01",
        "code": "PP1901",
        "icon": "Icon_PP1901.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_PP1901.png": {
                "cn": "PP-19-01",
                "kr": "PP-19-01",
                "jp": "PP-19-01",
                "en": "PP-19-01",
                "alt": "pic_PP1901_D.png"
            },
            "pic_PP1901_4405.png": {
                "cn": "PP-19-01-碳酸跳跳糖",
                "icon": "Icon_PP1901_4405.png",
                "alt": "pic_PP1901_4405_D.png",
                "kr": "PP-19-01 - 톡톡 팝캔디",
                "jp": "しゅわしゅわポッピング",
                "en": "Carbonated Fizzers"
            }
        },
        "kr": "PP-19-01",
        "jp": "PP-19-01",
        "en": "PP-19-01"
    },
    "138": {
        "type": "AR",
        "id": "138",
        "cn": "6P62",
        "code": "6P62",
        "icon": "Icon_6P62.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_6P62.png": {
                "cn": "6P62",
                "kr": "6P62",
                "jp": "6P62",
                "en": "6P62",
                "alt": "pic_6P62_D.png"
            },
            "pic_6P62_704.png": {
                "cn": "6P62-战斗水手",
                "icon": "Icon_6P62_704.png",
                "alt": "pic_6P62_704_D.png",
                "kr": "6P62 - 전투선원",
                "jp": "戦うセーラー",
                "en": "Battle Sailor"
            }
        },
        "kr": "6P62",
        "jp": "6P62",
        "en": "6P62"
    },
    "139": {
        "type": "HG",
        "id": "139",
        "cn": "布伦·坦",
        "code": "BrenTen",
        "icon": "Icon_BrenTen.png",
        "modded": false,
        "rarity": 2,
        "skins": {
            "pic_BrenTen.png": {
                "cn": "布伦·坦",
                "kr": "Bren Ten",
                "jp": "ブレン・テン",
                "en": "Bren Ten",
                "alt": "pic_BrenTen_D.png"
            }
        },
        "kr": "Bren Ten",
        "jp": "ブレン・テン",
        "en": "Bren Ten"
    },
    "140": {
        "type": "HG",
        "id": "140",
        "cn": "PSM",
        "code": "PSM",
        "icon": "Icon_PSM.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_PSM.png": {
                "cn": "PSM",
                "kr": "PSM",
                "jp": "PSM",
                "en": "PSM",
                "alt": "pic_PSM_D.png"
            }
        },
        "kr": "PSM",
        "jp": "PSM",
        "en": "PSM"
    },
    "141": {
        "type": "HG",
        "id": "141",
        "cn": "USP-C",
        "code": "USPCompact",
        "icon": "Icon_USPCompact.png",
        "modded": false,
        "rarity": 2,
        "skins": {
            "pic_USPCompact.png": {
                "cn": "USP-C",
                "kr": "USP Compact",
                "jp": "Gr USPコンパクト",
                "en": "Gr USPCompact",
                "alt": "pic_USPCompact_D.png"
            }
        },
        "kr": "USP Compact",
        "jp": "Gr USPコンパクト",
        "en": "Gr USPCompact"
    },
    "142": {
        "type": "HG",
        "id": "142",
        "cn": "FN-57",
        "code": "FN57",
        "icon": "Icon_FN57.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_FN57.png": {
                "cn": "FN-57",
                "kr": "Five-seveN",
                "jp": "Five-seven",
                "en": "Five-seven",
                "alt": "pic_FN57_D.png"
            },
            "pic_FN57_1109.png": {
                "cn": "FN-57-游轮女王",
                "icon": "Icon_FN57_1109.png",
                "alt": "pic_FN57_1109_D.png",
                "kr": "Five-seveN - 크루즈의 여왕님",
                "jp": "クルーズクイーン",
                "en": "Cruise Queen"
            },
            "pic_FN57_1902.png": {
                "cn": "FN-57-被接纳的笑容",
                "icon": "Icon_FN57_1902.png",
                "alt": "pic_FN57_1902_D.png",
                "kr": "Five-seveN - 꿈꿔왔던 미소",
                "jp": "幸せの微笑み",
                "en": "Smile of Acceptance"
            },
            "pic_FN57_2203.png": {
                "cn": "FN-57-芬芬历险记",
                "icon": "Icon_FN57_2203.png",
                "alt": "pic_FN57_2203_D.png",
                "kr": "Five-seveN - 행복한 세상의 담비",
                "jp": "ファイファイの冒険",
                "en": "Adventures of Fenfen"
            },
            "pic_FN57_2805.png": {
                "cn": "FN-57-蓝色的圣诞",
                "icon": "Icon_FN57_2805.png",
                "alt": "pic_FN57_2805_D.png",
                "kr": "Five-seveN - 푸르고 푸른 성탄절",
                "jp": "ブルークリスマス",
                "en": "Blue Christmas"
            }
        },
        "kr": "Five-seveN",
        "jp": "Five-seven",
        "en": "Five-seven"
    },
    "143": {
        "type": "SMG",
        "id": "143",
        "cn": "RO635",
        "code": "RO635",
        "icon": "Icon_RO635.png",
        "modded": true,
        "rarity": 5,
        "skins": {
            "pic_RO635.png": {
                "cn": "RO635",
                "kr": "RO635",
                "jp": "RO635",
                "en": "RO635",
                "alt": "pic_RO635_D.png"
            },
            "pic_RO635Mod.png": {
                "cn": "RO635",
                "kr": "RO635",
                "jp": "RO635",
                "en": "RO635",
                "icon": "mod",
                "alt": "pic_RO635Mod_D.png"
            },
            "pic_RO635_534.png": {
                "cn": "RO635-稻田里的守护者",
                "icon": "Icon_RO635_534.png",
                "alt": "pic_RO635_534_D.png",
                "kr": "RO635 - 논밭의 수호자",
                "jp": "稲田の守護者",
                "en": "Guardian in the Rye"
            },
            "pic_RO635_554.png": {
                "cn": "RO635-水中融月",
                "icon": "Icon_RO635_554.png",
                "alt": "pic_RO635_554_D.png",
                "kr": "RO635 - 물에 잠긴 달",
                "jp": "水中に融ける月",
                "en": "Molten Moon in the Water"
            },
            "pic_RO635_4504.png": {
                "cn": "RO635-规则的实行者",
                "icon": "Icon_RO635_4504.png",
                "alt": "pic_RO635_4504_D.png",
                "kr": "RO635 - 규율의 집행인",
                "jp": "規則の実行者",
                "en": "Enforcer of the Law"
            }
        },
        "kr": "RO635",
        "jp": "RO635",
        "en": "RO635",
        "moddedIcon": "Icon_RO635Mod.png",
        "modRarity": 6
    },
    "144": {
        "type": "SMG",
        "id": "144",
        "cn": "MT-9",
        "code": "MT9",
        "icon": "Icon_MT9.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_MT9.png": {
                "cn": "MT-9",
                "kr": "MT-9",
                "jp": "MT-9",
                "en": "MT-9",
                "alt": "pic_MT9_D.png"
            }
        },
        "kr": "MT-9",
        "jp": "MT-9",
        "en": "MT-9"
    },
    "145": {
        "type": "RF",
        "id": "145",
        "cn": "OTs-44",
        "code": "OC44",
        "icon": "Icon_OC44.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_OC44.png": {
                "cn": "OTs-44",
                "kr": "OTs-44",
                "jp": "OTs-44",
                "en": "OTs-44",
                "alt": "pic_OC44_D.png"
            },
            "pic_OC44_1608.png": {
                "cn": "OTs-44-森林里的小驯鹿//n",
                "icon": "Icon_OC44_1608.png",
                "alt": "pic_OC44_1608_D.png",
                "kr": "OTs-44 - 숲속의 어린 순록\n",
                "jp": "森のトナカイさん",
                "en": "Forest Reindeer"
            },
            "pic_OC44_3406.png": {
                "cn": "OTs-44-超能少女猪",
                "icon": "Icon_OC44_3406.png",
                "alt": "pic_OC44_3406_D.png",
                "kr": "OTs-44 - 맑음 때때로 꿀꿀",
                "jp": "異能少女ぶうりん",
                "en": "Super Piggy"
            },
            "pic_OC44_6207.png": {
                "cn": "OTs-44-深郊遇白兔",
                "icon": "Icon_OC44_6207.png",
                "alt": "pic_OC44_6207_D.png",
                "kr": "OTs-44 - 깊은 숲속 흰토끼",
                "jp": "街の奥、白兎に遇う",
                "en": "White Rabbit in the Wild"
            }
        },
        "kr": "OTs-44",
        "jp": "OTs-44",
        "en": "OTs-44"
    },
    "146": {
        "type": "RF",
        "id": "146",
        "cn": "G28",
        "code": "G28",
        "icon": "Icon_G28.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_G28.png": {
                "cn": "G28",
                "kr": "G28",
                "jp": "Gr G28",
                "en": "Gr G28",
                "alt": "pic_G28_D.png"
            },
            "pic_G28_1104.png": {
                "cn": "G28-热带风暴",
                "icon": "Icon_G28_1104.png",
                "alt": "pic_G28_1104_D.png",
                "kr": "G28 - 트로피컬 스톰",
                "jp": "トロピカルストーム",
                "en": "Tropical Storm"
            },
            "pic_G28_2304.png": {
                "cn": "G28-啤酒牧场",
                "icon": "Icon_G28_2304.png",
                "alt": "pic_G28_2304_D.png",
                "kr": "G28 - 맥주목장",
                "jp": "ビール牧場",
                "en": "Beer Ranch"
            },
            "pic_G28_3307.png": {
                "cn": "G28-月光与祖母绿",
                "icon": "Icon_G28_3307.png",
                "alt": "pic_G28_3307_D.png",
                "kr": "G28 - 달빛과 에메랄드",
                "jp": "月光とエメラルド",
                "en": "Moonlight and Emerald"
            }
        },
        "kr": "G28",
        "jp": "Gr G28",
        "en": "Gr G28"
    },
    "147": {
        "type": "RF",
        "id": "147",
        "cn": "SSG 69",
        "code": "SSG69",
        "icon": "Icon_SSG69.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_SSG69.png": {
                "cn": "SSG 69",
                "kr": "SSG 69",
                "jp": "SSG 69",
                "en": "SSG 69",
                "alt": "pic_SSG69_D.png"
            }
        },
        "kr": "SSG 69",
        "jp": "SSG 69",
        "en": "SSG 69"
    },
    "148": {
        "type": "RF",
        "id": "148",
        "cn": "IWS 2000",
        "code": "IWS2000",
        "icon": "Icon_IWS2000.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_IWS2000.png": {
                "cn": "IWS 2000",
                "kr": "IWS 2000",
                "jp": "IWS 2000",
                "en": "IWS 2000",
                "alt": "pic_IWS2000_D.png"
            },
            "pic_IWS2000_1403.png": {
                "cn": "IWS 2000-第七封印者",
                "icon": "Icon_IWS2000_1403.png",
                "alt": "pic_IWS2000_1403_D.png",
                "kr": "IWS 2000 - 일곱 번째 봉인자",
                "jp": "七番目の封印者",
                "en": "The Seventh Sealer"
            },
            "pic_IWS2000_3004.png": {
                "cn": "IWS 2000-薄雪绒",
                "icon": "Icon_IWS2000_3004.png",
                "alt": "pic_IWS2000_3004_D.png",
                "kr": "IWS 2000 - 에델바이스",
                "jp": "薄雪草",
                "en": "Edelweiss"
            },
            "pic_IWS2000_7308.png": {
                "cn": "IWS 2000-沙堡终结者",
                "icon": "Icon_IWS2000_7308.png",
                "alt": "pic_IWS2000_7308_D.png",
                "kr": "IWS 2000 - 모래성 파괴자",
                "en": ""
            }
        },
        "kr": "IWS 2000",
        "jp": "IWS 2000",
        "en": "IWS 2000"
    },
    "149": {
        "type": "MG",
        "id": "149",
        "cn": "AEK-999",
        "code": "AEK999",
        "icon": "Icon_AEK999.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_AEK999.png": {
                "cn": "AEK-999",
                "kr": "AEK-999",
                "jp": "AEK-999",
                "en": "AEK-999",
                "alt": "pic_AEK999_D.png"
            },
            "pic_AEK999_1505.png": {
                "cn": "AEK-999-极道车神",
                "icon": "Icon_AEK999_1505.png",
                "alt": "pic_AEK999_1505_D.png",
                "kr": "AEK-999 - 광란의 질주",
                "jp": "ベイビー・ライダー",
                "en": "Babe Driver"
            }
        },
        "kr": "AEK-999",
        "jp": "AEK-999",
        "en": "AEK-999"
    },
    "150": {
        "type": "SMG",
        "id": "150",
        "cn": "希普卡",
        "code": "Shipka",
        "icon": "Icon_Shipka.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_Shipka.png": {
                "cn": "希普卡",
                "kr": "시프카",
                "jp": "シプカ",
                "en": "Shipka",
                "alt": "pic_Shipka_D.png"
            },
            "pic_Shipka_5404.png": {
                "cn": "希普卡-新诗谱写时",
                "icon": "Icon_Shipka_5404.png",
                "alt": "pic_Shipka_5404_D.png",
                "kr": "시프카 - 새 시를 지을 때",
                "jp": "新しい詩をかくとき",
                "en": "When Writing A New Poem"
            }
        },
        "kr": "시프카",
        "jp": "シプカ",
        "en": "Shipka"
    },
    "151": {
        "type": "SG",
        "id": "151",
        "cn": "M1887",
        "code": "M1887",
        "icon": "Icon_M1887.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_M1887.png": {
                "cn": "M1887",
                "kr": "M1887",
                "jp": "M1887",
                "en": "M1887",
                "alt": "pic_M1887_D.png"
            },
            "pic_M1887_2503.png": {
                "cn": "M1887-猎魔法则",
                "icon": "Icon_M1887_2503.png",
                "alt": "pic_M1887_2503_D.png",
                "kr": "M1887 - 위쳐 제너럴",
                "jp": "Witcher　General",
                "en": "Law of Exorcism"
            }
        },
        "kr": "M1887",
        "jp": "M1887",
        "en": "M1887"
    },
    "152": {
        "type": "SG",
        "id": "152",
        "cn": "M1897",
        "code": "M1897",
        "icon": "Icon_M1897.png",
        "modded": true,
        "rarity": 3,
        "skins": {
            "pic_M1897.png": {
                "cn": "M1897",
                "kr": "M1897",
                "jp": "M1897",
                "en": "M1897",
                "alt": "pic_M1897_D.png"
            },
            "pic_M1897Mod.png": {
                "cn": "M1897",
                "kr": "M1897",
                "jp": "M1897",
                "en": "M1897",
                "icon": "mod",
                "alt": "pic_M1897Mod_D.png"
            },
            "pic_M1897_2505.png": {
                "cn": "M1897-电子女巫",
                "icon": "Icon_M1897_2505.png",
                "alt": "pic_M1897_2505_D.png",
                "kr": "M1897 - 일렉트릭 위치",
                "jp": "Electric　Witch",
                "en": "Electric Witch"
            },
            "pic_M1897_4805.png": {
                "cn": "M1897-碧空巡逻人",
                "icon": "Icon_M1897_4805.png",
                "alt": "pic_M1897_4805_D.png",
                "kr": "M1897 - 창공 순찰자",
                "jp": "碧空の巡回者",
                "en": "Sentinel of the Sky"
            }
        },
        "kr": "M1897",
        "jp": "M1897",
        "en": "M1897",
        "moddedIcon": "Icon_M1897Mod.png",
        "modRarity": 4
    },
    "153": {
        "type": "SG",
        "id": "153",
        "cn": "M37",
        "code": "Ithaca37",
        "icon": "Icon_Ithaca37.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_Ithaca37.png": {
                "cn": "M37",
                "kr": "M37",
                "jp": "M37",
                "en": "M37",
                "alt": "pic_Ithaca37_D.png"
            },
            "pic_Ithaca37_1105.png": {
                "cn": "M37-盛夏巡礼者",
                "icon": "Icon_Ithaca37_1105.png",
                "alt": "pic_Ithaca37_1105_D.png",
                "kr": "M37 - 한여름의 순례자",
                "jp": "盛夏の巡礼者",
                "en": "Summer Parader"
            },
            "pic_Ithaca37_5605.png": {
                "cn": "M37-和伊萨卡的漫长假日",
                "icon": "Icon_Ithaca37_5605.png",
                "alt": "pic_Ithaca37_5605_D.png",
                "kr": "M37 - 이사카와 기나긴 휴일",
                "jp": "イサカとの長い休日",
                "en": "A Long Vacation with Ithaca"
            }
        },
        "kr": "M37",
        "jp": "M37",
        "en": "M37"
    },
    "154": {
        "type": "SG",
        "id": "154",
        "cn": "M500",
        "code": "M500",
        "icon": "Icon_M500.png",
        "modded": true,
        "rarity": 3,
        "skins": {
            "pic_M500.png": {
                "cn": "M500",
                "kr": "M500",
                "jp": "M500",
                "en": "M500",
                "alt": "pic_M500_D.png"
            },
            "pic_M500Mod.png": {
                "cn": "M500",
                "kr": "M500",
                "jp": "M500",
                "en": "M500",
                "icon": "mod",
                "alt": "pic_M500Mod_D.png"
            },
            "pic_M500_3707.png": {
                "cn": "M500-课间白日梦",
                "icon": "Icon_M500_3707.png",
                "alt": "pic_M500_3707_D.png",
                "kr": "M500 - 수업 중 낮잠",
                "jp": "休み時間の白昼夢",
                "en": "Daydreaming in Class"
            }
        },
        "kr": "M500",
        "jp": "M500",
        "en": "M500",
        "moddedIcon": "Icon_M500Mod.png",
        "modRarity": 4
    },
    "155": {
        "type": "SG",
        "id": "155",
        "cn": "M590",
        "code": "M590",
        "icon": "Icon_M590.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_M590.png": {
                "cn": "M590",
                "kr": "M590",
                "jp": "M590",
                "en": "M590",
                "alt": "pic_M590_D.png"
            },
            "pic_M590_1806.png": {
                "cn": "M590-雪朝颜",
                "icon": "Icon_M590_1806.png",
                "alt": "pic_M590_1806_D.png",
                "kr": "M590 - 흰나팔꽃",
                "jp": "雪朝顔",
                "en": "Angel's Trumpet"
            },
            "pic_M590_3706.png": {
                "cn": "M590-放课后的消遣",
                "icon": "Icon_M590_3706.png",
                "alt": "pic_M590_3706_D.png",
                "kr": "M590 - 방과 후 심심풀이",
                "jp": "放課後の寄り道",
                "en": "Recreation after School"
            }
        },
        "kr": "M590",
        "jp": "M590",
        "en": "M590"
    },
    "156": {
        "type": "SG",
        "id": "156",
        "cn": "超级肖蒂",
        "code": "SuperShorty",
        "icon": "Icon_SuperShorty.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_SuperShorty.png": {
                "cn": "超级肖蒂",
                "kr": "Super-Shorty",
                "jp": "Super-Shorty",
                "en": "Super-Shorty",
                "alt": "pic_SuperShorty_D.png"
            },
            "pic_SuperShorty_1704.png": {
                "cn": "超级肖蒂-异乡的十字路口",
                "icon": "Icon_SuperShorty_1704.png",
                "alt": "pic_SuperShorty_1704_D.png",
                "kr": "Super-Shorty - 타향의 갈림길에서",
                "jp": "異国迷路のクロスロード",
                "en": "Crossing in Labyrinth"
            },
            "pic_SuperShorty_5204.png": {
                "cn": "超级肖蒂-绝地战警SS",
                "icon": "Icon_SuperShorty_5204.png",
                "alt": "pic_SuperShorty_5204_D.png",
                "kr": "Super-Shorty - 나쁜 녀석 SS",
                "jp": "武装警察SS",
                "en": "Bad Cop for Life"
            }
        },
        "kr": "Super-Shorty",
        "jp": "Super-Shorty",
        "en": "Super-Shorty"
    },
    "157": {
        "type": "SG",
        "id": "157",
        "cn": "KSG",
        "code": "KSG",
        "icon": "Icon_KSG.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_KSG.png": {
                "cn": "KSG",
                "kr": "KSG",
                "jp": "Am KSG",
                "en": "Am KSG",
                "alt": "pic_KSG_D.png"
            }
        },
        "kr": "KSG",
        "jp": "Am KSG",
        "en": "Am KSG"
    },
    "158": {
        "type": "SG",
        "id": "158",
        "cn": "KS-23",
        "code": "KS23",
        "icon": "Icon_KS23.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_KS23.png": {
                "cn": "KS-23",
                "kr": "KS-23",
                "jp": "KS-23",
                "en": "KS-23",
                "alt": "pic_KS23_D.png"
            }
        },
        "kr": "KS-23",
        "jp": "KS-23",
        "en": "KS-23"
    },
    "159": {
        "type": "SG",
        "id": "159",
        "cn": "RMB-93",
        "code": "RMB93",
        "icon": "Icon_RMB93.png",
        "modded": true,
        "rarity": 3,
        "skins": {
            "pic_RMB93.png": {
                "cn": "RMB-93",
                "kr": "RMB-93",
                "jp": "RMB-93",
                "en": "RMB-93",
                "alt": "pic_RMB93_D.png"
            },
            "pic_RMB93Mod.png": {
                "cn": "RMB-93",
                "kr": "RMB-93",
                "jp": "RMB-93",
                "en": "RMB-93",
                "icon": "mod",
                "alt": "pic_RMB93Mod_D.png"
            },
            "pic_RMB93_1705.png": {
                "cn": "RMB-93-星之彼岸",
                "icon": "Icon_RMB93_1705.png",
                "alt": "pic_RMB93_1705_D.png",
                "kr": "RMB-93 - 별의 저편",
                "jp": "ほしのむこう",
                "en": "Cross the Milky Way"
            },
            "pic_RMB93_4309.png": {
                "cn": "RMB-93-触不到的月光情人",
                "icon": "Icon_RMB93_4309.png",
                "alt": "pic_RMB93_4309_D.png",
                "kr": "RMB93 - 닿지 않는 달빛의 사랑",
                "jp": "触れられない月の恋人",
                "en": "Moonlit Lover Beyond Reach"
            }
        },
        "kr": "RMB-93",
        "jp": "RMB-93",
        "en": "RMB-93",
        "moddedIcon": "Icon_RMB93Mod.png",
        "modRarity": 4
    },
    "160": {
        "type": "SG",
        "id": "160",
        "cn": "塞伽12型",
        "code": "Saiga12",
        "icon": "Icon_Saiga12.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_Saiga12.png": {
                "cn": "塞伽12型",
                "kr": "Saiga-12",
                "jp": "Saiga-12",
                "en": "Saiga-12",
                "alt": "pic_Saiga12_D.png"
            },
            "pic_Saiga12_3901.png": {
                "cn": "塞伽12型-茜红领航",
                "icon": "Icon_Saiga12_3901.png",
                "alt": "pic_Saiga12_3901_D.png",
                "kr": "Saiga-12 - 크림슨 코드라이버",
                "jp": "真紅のナビゲーター",
                "en": "Crimson Navigator"
            },
            "pic_Saiga12_4510.png": {
                "cn": "塞伽12型-晨昏的裁定者",
                "icon": "Icon_Saiga12_4510.png",
                "alt": "pic_Saiga12_4510_D.png",
                "kr": "Saiga-12 - 노을의 재단사",
                "jp": "黄昏の裁定者",
                "en": "Arbiter of Twilight"
            },
            "pic_Saiga12_5402.png": {
                "cn": "塞伽12型-繁花访客",
                "icon": "Icon_Saiga12_5402.png",
                "alt": "pic_Saiga12_5402_D.png",
                "kr": "Saiga-12 - 꽃무리 방문객",
                "jp": "百花の訪客",
                "en": "Visitor of Bountiful Blossoms"
            }
        },
        "kr": "Saiga-12",
        "jp": "Saiga-12",
        "en": "Saiga-12"
    },
    "161": {
        "type": "SG",
        "id": "161",
        "cn": "97式霰",
        "code": "97typeS",
        "icon": "Icon_97typeS.png",
        "modded": true,
        "rarity": 4,
        "skins": {
            "pic_97typeS.png": {
                "cn": "97式霰",
                "kr": "97식 산탄총",
                "jp": "97式散",
                "en": "Type97S",
                "alt": "pic_97typeS_D.png"
            },
            "pic_97typeSMod.png": {
                "cn": "97式霰",
                "kr": "97식 산탄총",
                "jp": "97式散",
                "en": "Type97S",
                "icon": "mod",
                "alt": "pic_97typeSMod_D.png"
            },
            "pic_97typeS_3807.png": {
                "cn": "97式霰-奇谋妙策九七计",
                "icon": "Icon_97typeS_3807.png",
                "alt": "pic_97typeS_3807_D.png",
                "kr": "97식 산탄총 - 97계 병법",
                "jp": "97式妙計奇策",
                "en": "Ingenious Stratagem No.97"
            },
            "pic_97typeS_5805.png": {
                "cn": "97式霰-花下踟躇醉",
                "icon": "Icon_97typeS_5805.png",
                "alt": "pic_97typeS_5805_D.png",
                "kr": "97식 산탄총 - 꽃향기에 흠뻑 취해",
                "jp": "酩酊の花びら",
                "en": "Drunken Petals"
            }
        },
        "kr": "97식 산탄총",
        "jp": "97式散",
        "en": "Type97S",
        "moddedIcon": "Icon_97typeSMod.png",
        "modRarity": 5
    },
    "162": {
        "type": "SG",
        "id": "162",
        "cn": "SPAS-12",
        "code": "SPAS12",
        "icon": "Icon_SPAS12.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_SPAS12.png": {
                "cn": "SPAS-12",
                "kr": "SPAS-12",
                "jp": "SPAS-12",
                "en": "SPAS-12",
                "alt": "pic_SPAS12_D.png"
            },
            "pic_SPAS12_522.png": {
                "cn": "SPAS-12-宪兵乐手",
                "icon": "Icon_SPAS12_522.png",
                "alt": "pic_SPAS12_522_D.png",
                "kr": "SPAS-12 - 헌병 군악대",
                "jp": "マーチングバンド",
                "en": "Marching Band"
            },
            "pic_SPAS12_2408.png": {
                "cn": "SPAS-12-盛夏的果实",
                "icon": "Icon_SPAS12_2408.png",
                "alt": "pic_SPAS12_2408_D.png",
                "kr": "SPAS-12 - 한여름의 열매",
                "jp": "盛夏の果実",
                "en": "Midsummer Fruit"
            },
            "pic_SPAS12_3203.png": {
                "cn": "SPAS-12-哥布林猎手",
                "icon": "Icon_SPAS12_3203.png",
                "alt": "pic_SPAS12_3203_D.png",
                "kr": "SPAS-12 - 고블린 헌터",
                "jp": "ゴブリンハンター",
                "en": "Goblin Huntress"
            }
        },
        "kr": "SPAS-12",
        "jp": "SPAS-12",
        "en": "SPAS-12"
    },
    "163": {
        "type": "SG",
        "id": "163",
        "cn": "AA-12",
        "code": "AA12",
        "icon": "Icon_AA12.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_AA12.png": {
                "cn": "AA-12",
                "kr": "AA-12",
                "jp": "AA-12",
                "en": "AA-12",
                "alt": "pic_AA12_D.png"
            },
            "pic_AA12_2403.png": {
                "cn": "AA-12-太阳永不升起",
                "icon": "Icon_AA12_2403.png",
                "alt": "pic_AA12_2403_D.png",
                "kr": "AA-12 - 태양을 피하는 방법",
                "jp": "日はまだ昇らない",
                "en": "The Sun Never Rises"
            },
            "pic_AA12_4401.png": {
                "cn": "AA-12-无烟棒棒糖",
                "icon": "Icon_AA12_4401.png",
                "alt": "pic_AA12_4401_D.png",
                "kr": "AA-12 - 뜬구름 사탕",
                "jp": "ロリポップシュガー",
                "en": "Smokeless Lollipop"
            }
        },
        "kr": "AA-12",
        "jp": "AA-12",
        "en": "AA-12"
    },
    "164": {
        "type": "SG",
        "id": "164",
        "cn": "FP-6",
        "code": "FP6",
        "icon": "Icon_FP6.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_FP6.png": {
                "cn": "FP-6",
                "kr": "FP-6",
                "jp": "FP-6",
                "en": "FP-6",
                "alt": "pic_FP6_D.png"
            },
            "pic_FP6_2804.png": {
                "cn": "FP-6-恋爱卫星",
                "icon": "Icon_FP6_2804.png",
                "alt": "pic_FP6_2804_D.png",
                "kr": "FP-6 - 사랑의 위성",
                "jp": "サテライト・オブ・ラブ",
                "en": "Satellite of Love"
            }
        },
        "kr": "FP-6",
        "jp": "FP-6",
        "en": "FP-6"
    },
    "165": {
        "type": "SG",
        "id": "165",
        "cn": "M1014",
        "code": "M1014",
        "icon": "Icon_M1014.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_M1014.png": {
                "cn": "M1014",
                "kr": "M1014",
                "jp": "M1014",
                "en": "M1014",
                "alt": "pic_M1014_D.png"
            },
            "pic_M1014_2906.png": {
                "cn": "M1014-雪月花",
                "icon": "Icon_M1014_2906.png",
                "alt": "pic_M1014_2906_D.png",
                "kr": "M1014 - 설월화",
                "jp": "雪月花",
                "en": "Snow, Moon and Flowers"
            },
            "pic_M1014_4305.png": {
                "cn": "M1014-天使像前的心跳",
                "icon": "Icon_M1014_4305.png",
                "alt": "pic_M1014_4305_D.png",
                "kr": "M1014 - 천사의 두근거림",
                "jp": "天使像前、高鳴る胸",
                "en": "Heartbeat Before the Angel Statue"
            }
        },
        "kr": "M1014",
        "jp": "M1014",
        "en": "M1014"
    },
    "166": {
        "type": "HG",
        "id": "166",
        "cn": "CZ75",
        "code": "CZ75",
        "icon": "Icon_CZ75.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_CZ75.png": {
                "cn": "CZ75",
                "kr": "CZ75",
                "jp": "CZ75",
                "en": "CZ75",
                "alt": "pic_CZ75_D.png"
            },
            "pic_CZ75_1604.png": {
                "cn": "CZ75-凛冬采集者",
                "icon": "Icon_CZ75_1604.png",
                "alt": "pic_CZ75_1604_D.png",
                "kr": "CZ75 - 겨울의 탐험가",
                "jp": "厳冬の木こり",
                "en": "Winter Forager"
            },
            "pic_CZ75_3005.png": {
                "cn": "CZ75-金莲花",
                "icon": "Icon_CZ75_3005.png",
                "alt": "pic_CZ75_3005_D.png",
                "kr": "CZ75 - 금련화",
                "jp": "金蓮花",
                "en": "Monks Cress"
            },
            "pic_CZ75_7001.png": {
                "cn": "CZ75-CZ75不加班",
                "icon": "Icon_CZ75_7001.png",
                "alt": "pic_CZ75_7001_D.png",
                "kr": "CZ75 - 야근 사절",
                "jp": "残業しないので",
                "en": "CZ75 Does Not Work Overtime"
            }
        },
        "kr": "CZ75",
        "jp": "CZ75",
        "en": "CZ75"
    },
    "167": {
        "type": "HG",
        "id": "167",
        "cn": "HK45",
        "code": "HK45",
        "icon": "Icon_HK45.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_HK45.png": {
                "cn": "HK45",
                "kr": "HK45",
                "jp": "Gr HK45",
                "en": "Gr HK45",
                "alt": "pic_HK45_D.png"
            },
            "pic_HK45_2705.png": {
                "cn": "HK45-奇迹☆开始",
                "icon": "Icon_HK45_2705.png",
                "alt": "pic_HK45_2705_D.png",
                "kr": "HK45 - 미라클☆스타트",
                "jp": "キセキ☆はじまる",
                "en": "Miracle☆Start"
            }
        },
        "kr": "HK45",
        "jp": "Gr HK45",
        "en": "Gr HK45"
    },
    "168": {
        "type": "HG",
        "id": "168",
        "cn": "喷火",
        "code": "Spitfire",
        "icon": "Icon_Spitfire.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_Spitfire.png": {
                "cn": "喷火",
                "kr": "Spitfire",
                "jp": "Spitfire",
                "en": "Spitfire",
                "alt": "pic_Spitfire_D.png"
            },
            "pic_Spitfire_1405.png": {
                "cn": "喷火-最后的爱丽丝",
                "icon": "Icon_Spitfire_1405.png",
                "alt": "pic_Spitfire_1405_D.png",
                "kr": "Spitfire - 마지막 앨리스",
                "jp": "最後のアリス",
                "en": "The Last Alice"
            }
        },
        "kr": "Spitfire",
        "jp": "Spitfire",
        "en": "Spitfire"
    },
    "169": {
        "type": "SMG",
        "id": "169",
        "cn": "SCW",
        "code": "ColtSCW",
        "icon": "Icon_ColtSCW.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_ColtSCW.png": {
                "cn": "SCW",
                "kr": "SCW",
                "jp": "SCW",
                "en": "SCW",
                "alt": "pic_ColtSCW_D.png"
            }
        },
        "kr": "SCW",
        "jp": "SCW",
        "en": "SCW"
    },
    "170": {
        "type": "AR",
        "id": "170",
        "cn": "ASh-12.7",
        "code": "Ash127",
        "icon": "Icon_Ash127.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_Ash127.png": {
                "cn": "ASh-12.7",
                "kr": "ASh-12.7",
                "jp": "ASh-12.7",
                "en": "ASh-12.7",
                "alt": "pic_Ash127_D.png"
            }
        },
        "kr": "ASh-12.7",
        "jp": "ASh-12.7",
        "en": "ASh-12.7"
    },
    "171": {
        "type": "AR",
        "id": "171",
        "cn": "利贝罗勒",
        "code": "Ribeyrolles",
        "icon": "Icon_Ribeyrolles.png",
        "modded": true,
        "rarity": 4,
        "skins": {
            "pic_Ribeyrolles.png": {
                "cn": "利贝罗勒",
                "kr": "리베롤",
                "jp": "リベロール",
                "en": "Ribeyrolles",
                "alt": "pic_Ribeyrolles_D.png"
            },
            "pic_RibeyrollesMod.png": {
                "cn": "利贝罗勒",
                "kr": "리베롤",
                "jp": "リベロール",
                "en": "Ribeyrolles",
                "icon": "mod",
                "alt": "pic_RibeyrollesMod_D.png"
            }
        },
        "kr": "리베롤",
        "jp": "リベロール",
        "en": "Ribeyrolles",
        "moddedIcon": "Icon_RibeyrollesMod.png",
        "modRarity": 5
    },
    "172": {
        "type": "AR",
        "id": "172",
        "cn": "RFB",
        "code": "RFB",
        "icon": "Icon_RFB.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_RFB.png": {
                "cn": "RFB",
                "kr": "RFB",
                "jp": "Am RFB",
                "en": "Am RFB",
                "alt": "pic_RFB_D.png"
            },
            "pic_RFB_1601.png": {
                "cn": "RFB-RFB偷走圣诞节",
                "icon": "Icon_RFB_1601.png",
                "alt": "pic_RFB_1601_D.png",
                "kr": "RFB - 크리스마스를 훔친 RFB",
                "jp": "いじわるRFBのクリスマス",
                "en": "How RFB Stole Xmas"
            },
            "pic_RFB_2902.png": {
                "cn": "RFB-正月游戏大师",
                "icon": "Icon_RFB_2902.png",
                "alt": "pic_RFB_2902_D.png",
                "kr": "RFB - 신년 최고의 플레이어",
                "jp": "正月のゲームマスター",
                "en": "New Year's MVP"
            }
        },
        "kr": "RFB",
        "jp": "Am RFB",
        "en": "Am RFB"
    },
    "173": {
        "type": "MG",
        "id": "173",
        "cn": "PKP",
        "code": "PKP",
        "icon": "Icon_PKP.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_PKP.png": {
                "cn": "PKP",
                "kr": "PKP",
                "jp": "PKP",
                "en": "PKP",
                "alt": "pic_PKP_D.png"
            },
            "pic_PKP_1201.png": {
                "cn": "PKP-花与水",
                "icon": "Icon_PKP_1201.png",
                "alt": "pic_PKP_1201_D.png",
                "kr": "PKP - 꽃과 물",
                "jp": "花と水",
                "en": "Flower and Water"
            },
            "pic_PKP_1503.png": {
                "cn": "PKP-淑女密令",
                "icon": "Icon_PKP_1503.png",
                "alt": "pic_PKP_1503_D.png",
                "kr": "PKP- 걸 프롬 UNCLE",
                "jp": "淑女の密命",
                "en": "L.A.D.Y"
            },
            "pic_PKP_3102.png": {
                "cn": "PKP-银白之星",
                "icon": "Icon_PKP_3102.png",
                "alt": "pic_PKP_3102_D.png",
                "kr": "PKP - 실버 스타",
                "jp": "スターシルヴァー",
                "en": "Silver Star"
            },
            "pic_PKP_4203.png": {
                "cn": "PKP-青竹矜",
                "icon": "Icon_PKP_4203.png",
                "alt": "pic_PKP_4203_D.png",
                "kr": "PKP - 곧은 대나무",
                "jp": "青竹は居丈高に",
                "en": "Dignified Bamboo"
            },
            "pic_PKP_5904.png": {
                "cn": "PKP-雨后冲锋队",
                "icon": "Icon_PKP_5904.png",
                "alt": "pic_PKP_5904_D.png",
                "kr": "PKP - 우후대장군",
                "jp": "",
                "en": "After-Rain Assault Squad"
            }
        },
        "kr": "PKP",
        "jp": "PKP",
        "en": "PKP"
    },
    "174": {
        "type": "RF",
        "id": "174",
        "cn": "八一式马",
        "code": "81typeR",
        "icon": "Icon_81typeR.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_81typeR.png": {
                "cn": "八一式马",
                "kr": "81식 카빈",
                "jp": "81式カービン",
                "en": "Type81R",
                "alt": "pic_81typeR_D.png"
            },
            "pic_81typeR_1807.png": {
                "cn": "八一式马-白山茶",
                "icon": "Icon_81typeR_1807.png",
                "alt": "pic_81typeR_1807_D.png",
                "kr": "81식 카빈 - 백산차",
                "jp": "白山茶",
                "en": "White Camellia"
            },
            "pic_81typeR_5607.png": {
                "cn": "八一式马-鹿韭旅伴",
                "icon": "Icon_81typeR_5607.png",
                "alt": "pic_81typeR_5607_D.png",
                "kr": "81식 카빈 - 동반자 모란",
                "jp": "牡丹と旅の友",
                "en": "Peony Companion"
            }
        },
        "kr": "81식 카빈",
        "jp": "81式カービン",
        "en": "Type81R"
    },
    "175": {
        "type": "AR",
        "id": "175",
        "cn": "ART556",
        "code": "ART556",
        "icon": "Icon_ART556.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_ART556.png": {
                "cn": "ART556",
                "kr": "ART556",
                "jp": "ART556",
                "en": "ART556",
                "alt": "pic_ART556_D.png"
            },
            "pic_ART556_1803.png": {
                "cn": "ART556-莲花白",
                "icon": "Icon_ART556_1803.png",
                "alt": "pic_ART556_1803_D.png",
                "kr": "ART556 - 양배추 소녀",
                "jp": "甘藍",
                "en": "White Cabbage"
            },
            "pic_ART556_2803.png": {
                "cn": "ART556-扫烟囱的小姑娘",
                "icon": "Icon_ART556_2803.png",
                "alt": "pic_ART556_2803_D.png",
                "kr": "ART556 - 굴뚝 청소부",
                "jp": "煙突掃除の女の子",
                "en": "Little Chimney Sweeper"
            }
        },
        "kr": "ART556",
        "jp": "ART556",
        "en": "ART556"
    },
    "176": {
        "type": "SMG",
        "id": "176",
        "cn": "TMP",
        "code": "TMP",
        "icon": "Icon_TMP.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_TMP.png": {
                "cn": "TMP",
                "kr": "TMP",
                "jp": "TMP",
                "en": "TMP",
                "alt": "pic_TMP_D.png"
            },
            "pic_TMP_2807.png": {
                "cn": "TMP-红耳朵猫TMP",
                "icon": "Icon_TMP_2807.png",
                "alt": "pic_TMP_2807_D.png",
                "kr": "TMP - 매우 반짝이는 귀",
                "jp": "赤耳のTMP",
                "en": "Red-Eared Cat"
            },
            "pic_TMP_3708.png": {
                "cn": "TMP-喵棱镜威力",
                "icon": "Icon_TMP_3708.png",
                "alt": "pic_TMP_3708_D.png",
                "kr": "TMP - 냥 프리즘 파워",
                "jp": "プリズムにゃんこパワー",
                "en": "Meow Prism Power"
            },
            "pic_TMP_4606.png": {
                "cn": "TMP-黑猫幼稚园",
                "icon": "Icon_TMP_4606.png",
                "alt": "pic_TMP_4606_D.png",
                "kr": "TMP - 흑묘 유치원",
                "jp": "黒猫幼稚園",
                "en": "Black Cat Nursery"
            }
        },
        "kr": "TMP",
        "jp": "TMP",
        "en": "TMP"
    },
    "177": {
        "type": "SMG",
        "id": "177",
        "cn": "KLIN",
        "code": "KLIN",
        "icon": "Icon_KLIN.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_KLIN.png": {
                "cn": "KLIN",
                "kr": "KLIN",
                "jp": "KLIN",
                "en": "KLIN",
                "alt": "pic_KLIN_D.png"
            },
            "pic_KLIN_1204.png": {
                "cn": "KLIN-三羽乌",
                "icon": "Icon_KLIN_1204.png",
                "alt": "pic_KLIN_1204_D.png",
                "kr": "KLIN - 세 마리의 까마귀",
                "jp": "三羽烏",
                "en": "The Three Crows"
            },
            "pic_KLIN_2003.png": {
                "cn": "KLIN-凛冬将逝",
                "icon": "Icon_KLIN_2003.png",
                "alt": "pic_KLIN_2003_D.png",
                "kr": "KLIN - 추운 겨울을 넘어",
                "jp": "一陽来復",
                "en": "Waning Winter"
            }
        },
        "kr": "KLIN",
        "jp": "KLIN",
        "en": "KLIN"
    },
    "178": {
        "type": "SMG",
        "id": "178",
        "cn": "F1",
        "code": "F1",
        "icon": "Icon_F1.png",
        "modded": true,
        "rarity": 3,
        "skins": {
            "pic_F1.png": {
                "cn": "F1",
                "kr": "F1",
                "jp": "F1",
                "en": "F1",
                "alt": "pic_F1_D.png"
            },
            "pic_F1Mod.png": {
                "cn": "F1",
                "kr": "F1",
                "jp": "F1",
                "en": "F1",
                "icon": "mod",
                "alt": "pic_F1Mod_D.png"
            },
            "pic_F1_2606.png": {
                "cn": "F1-黑魔女学院",
                "icon": "Icon_F1_2606.png",
                "alt": "pic_F1_2606_D.png",
                "kr": "F1 - 블랙 위치 아카데미",
                "jp": "ウィッチアカデミア",
                "en": "Dark Sorceress Academy"
            },
            "pic_F1_6507.png": {
                "cn": "F1-荒漠的龙与诗",
                "icon": "Icon_F1_6507.png",
                "alt": "pic_F1_6507_D.png",
                "kr": "F1 - 황야의 용의 시",
                "jp": "荒野の竜と詩",
                "en": ""
            }
        },
        "kr": "F1",
        "jp": "F1",
        "en": "F1",
        "moddedIcon": "Icon_F1Mod.png",
        "modRarity": 4
    },
    "179": {
        "type": "RF",
        "id": "179",
        "cn": "DSR-50",
        "code": "DSR50",
        "icon": "Icon_DSR50.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_DSR50.png": {
                "cn": "DSR-50",
                "kr": "DSR-50",
                "jp": "Gd DSR-50",
                "en": "Gd DSR-50",
                "alt": "pic_DSR50_D.png"
            },
            "pic_DSR50_1801.png": {
                "cn": "DSR-50-红牡丹",
                "icon": "Icon_DSR50_1801.png",
                "alt": "pic_DSR50_1801_D.png",
                "kr": "DSR-50 - 비목단",
                "jp": "春牡丹",
                "en": "Red Peony"
            },
            "pic_DSR50_2101.png": {
                "cn": "DSR-50-最高出价",
                "icon": "Icon_DSR50_2101.png",
                "alt": "pic_DSR50_2101_D.png",
                "kr": "DSR-50 - 베스트 오퍼",
                "jp": "ベストオファー",
                "en": "Highest Bid"
            }
        },
        "kr": "DSR-50",
        "jp": "Gd DSR-50",
        "en": "Gd DSR-50"
    },
    "180": {
        "type": "RF",
        "id": "180",
        "cn": "PzB39",
        "code": "PzB39",
        "icon": "Icon_PzB39.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_PzB39.png": {
                "cn": "PzB39",
                "kr": "PzB39",
                "jp": "PzB39",
                "en": "PzB39",
                "alt": "pic_PzB39_D.png"
            },
            "pic_PzB39_1506.png": {
                "cn": "PzB39-爆裂骑手",
                "icon": "Icon_PzB39_1506.png",
                "alt": "pic_PzB39_1506_D.png",
                "kr": "PzB39 - 열혈 라이더",
                "jp": "パンク・ライダー",
                "en": "Raging Rider"
            }
        },
        "kr": "PzB39",
        "jp": "PzB39",
        "en": "PzB39"
    },
    "181": {
        "type": "AR",
        "id": "181",
        "cn": "T91",
        "code": "T91",
        "icon": "Icon_T91.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_T91.png": {
                "cn": "T91",
                "kr": "T91",
                "jp": "T91",
                "en": "T91",
                "alt": "pic_T91_D.png"
            },
            "pic_T91_4206.png": {
                "cn": "T91-珠梅雪",
                "icon": "Icon_T91_4206.png",
                "alt": "pic_T91_4206_D.png",
                "kr": "T91 - 진주 매화",
                "jp": "雪梅花",
                "en": "Snowy Plum Blossom"
            }
        },
        "kr": "T91",
        "jp": "T91",
        "en": "T91"
    },
    "182": {
        "type": "RF",
        "id": "182",
        "cn": "wz.29",
        "code": "wz29",
        "icon": "Icon_wz29.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_wz29.png": {
                "cn": "wz.29",
                "kr": "wz.29",
                "jp": "wz.29",
                "en": "wz.29",
                "alt": "pic_wz29_D.png"
            },
            "pic_wz29_4907.png": {
                "cn": "wz.29-花鸟风月",
                "icon": "Icon_wz29_4907.png",
                "alt": "pic_wz29_4907_D.png",
                "kr": "wz.29 - 화조풍월",
                "jp": "花鳥風月",
                "en": "Beauties of Nature"
            },
            "pic_wz29_5908.png": {
                "cn": "wz.29-甜蜜幻梦使",
                "icon": "Icon_wz29_5908.png",
                "alt": "pic_wz29_5908_D.png",
                "kr": "wz.29 - 스윗 드림 메이커",
                "jp": "",
                "en": "Envoy of Sweet Dreams"
            }
        },
        "kr": "wz.29",
        "jp": "wz.29",
        "en": "wz.29"
    },
    "183": {
        "type": "HG",
        "id": "183",
        "cn": "竞争者",
        "code": "Contender",
        "icon": "Icon_Contender.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_Contender.png": {
                "cn": "竞争者",
                "kr": "컨텐더",
                "jp": "コンテンダー",
                "en": "Contender",
                "alt": "pic_Contender_D.png"
            },
            "pic_Contender_1502.png": {
                "cn": "竞争者-歌剧魅影",
                "icon": "Icon_Contender_1502.png",
                "alt": "pic_Contender_1502_D.png",
                "kr": "컨텐더 - 오페라의 유령",
                "jp": "オペラ座の怪人",
                "en": "Opera Ghost"
            },
            "pic_Contender_2302.png": {
                "cn": "竞争者-百花侍从",
                "icon": "Icon_Contender_2302.png",
                "alt": "pic_Contender_2302_D.png",
                "kr": "컨텐더 - 백화집사",
                "jp": "花びらの付き人",
                "en": "Flowerful Maid"
            },
            "pic_Contender_3201.png": {
                "cn": "竞争者-龙狼子",
                "icon": "Icon_Contender_3201.png",
                "alt": "pic_Contender_3201_D.png",
                "kr": "컨텐더 - 사파이어의 마총사",
                "jp": "龍狼の子",
                "en": "Dragon's Son"
            }
        },
        "kr": "컨텐더",
        "jp": "コンテンダー",
        "en": "Contender"
    },
    "184": {
        "type": "RF",
        "id": "184",
        "cn": "T-5000",
        "code": "T5000",
        "icon": "Icon_T5000.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_T5000.png": {
                "cn": "T-5000",
                "kr": "T-5000",
                "jp": "T-5000",
                "en": "T-5000",
                "alt": "pic_T5000_D.png"
            },
            "pic_T5000_3106.png": {
                "cn": "T-5000-誓约变身",
                "icon": "Icon_T5000_3106.png",
                "alt": "pic_T5000_3106_D.png",
                "kr": "T-5000 - 웨딩 레인저",
                "jp": "約束の変身",
                "en": "Oath of Transformation"
            },
            "pic_T5000_4605.png": {
                "cn": "T-5000-赤红破坏者",
                "icon": "Icon_T5000_4605.png",
                "alt": "pic_T5000_4605_D.png",
                "kr": "T-5000 - 차원의 파괴자",
                "jp": "赤き破壊者",
                "en": "Crimson Destroyer"
            }
        },
        "kr": "T-5000",
        "jp": "T-5000",
        "en": "T-5000"
    },
    "185": {
        "type": "MG",
        "id": "185",
        "cn": "阿梅利",
        "code": "Ameli",
        "icon": "Icon_Ameli.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_Ameli.png": {
                "cn": "阿梅利",
                "kr": "아멜리",
                "jp": "Ameli",
                "en": "Ameli",
                "alt": "pic_Ameli_D.png"
            },
            "pic_Ameli_1605.png": {
                "cn": "阿梅利-卖礼物的圣诞树",
                "icon": "Icon_Ameli_1605.png",
                "alt": "pic_Ameli_1605_D.png",
                "kr": "아멜리 - 선물은 성탄절 트리",
                "jp": "プレゼント売りのクリスマスツリー",
                "en": "Little Gift Tree"
            },
            "pic_Ameli_2409.png": {
                "cn": "阿梅利-阿梅利的接球",
                "icon": "Icon_Ameli_2409.png",
                "alt": "pic_Ameli_2409_D.png",
                "kr": "아멜리 - 아멜리의 리시브",
                "jp": "アメリのレシーブ",
                "en": "Ameli's Receive"
            }
        },
        "kr": "아멜리",
        "jp": "Ameli",
        "en": "Ameli"
    },
    "186": {
        "type": "HG",
        "id": "186",
        "cn": "P226",
        "code": "P226",
        "icon": "Icon_P226.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_P226.png": {
                "cn": "P226",
                "kr": "P226",
                "jp": "P226",
                "en": "P226",
                "alt": "pic_P226_D.png"
            }
        },
        "kr": "P226",
        "jp": "P226",
        "en": "P226"
    },
    "187": {
        "type": "AR",
        "id": "187",
        "cn": "Ak 5",
        "code": "Ak5",
        "icon": "Icon_Ak5.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_Ak5.png": {
                "cn": "Ak 5",
                "kr": "Ak 5",
                "jp": "Ak 5",
                "en": "Ak 5",
                "alt": "pic_Ak5_D.png"
            },
            "pic_Ak5_4707.png": {
                "cn": "Ak 5-南国之风",
                "icon": "Icon_Ak5_4707.png",
                "alt": "pic_Ak5_4707_D.png",
                "kr": "Ak 5 - 남쪽의 바람",
                "jp": "南国の風",
                "en": "Southern Wind"
            },
            "pic_Ak5_5906.png": {
                "cn": "Ak 5-接引彩虹的花仙子",
                "icon": "Icon_Ak5_5906.png",
                "alt": "pic_Ak5_5906_D.png",
                "kr": "Ak 5 - 무지개를 잇는 선녀",
                "jp": "",
                "en": "Rainbow-Weaving Flower Fairy"
            }
        },
        "kr": "Ak 5",
        "jp": "Ak 5",
        "en": "Ak 5"
    },
    "188": {
        "type": "SG",
        "id": "188",
        "cn": "S.A.T.8",
        "code": "SAT8",
        "icon": "Icon_SAT8.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_SAT8.png": {
                "cn": "S.A.T.8",
                "kr": "S.A.T.8",
                "jp": "S.A.T.8",
                "en": "S.A.T.8",
                "alt": "pic_SAT8_D.png"
            },
            "pic_SAT8_1802.png": {
                "cn": "S.A.T.8-梅花印",
                "icon": "Icon_SAT8_1802.png",
                "alt": "pic_SAT8_1802_D.png",
                "kr": "S.A.T.8 - 매화 도장",
                "jp": "梅の印",
                "en": "Wintersweet"
            },
            "pic_SAT8_2601.png": {
                "cn": "S.A.T.8-南瓜串串",
                "icon": "Icon_SAT8_2601.png",
                "alt": "pic_SAT8_2601_D.png",
                "kr": "S.A.T.8 - 호박꼬치",
                "jp": "パンプキン・スキュアー",
                "en": "Pumpkin Skewers"
            },
            "pic_SAT8_3602.png": {
                "cn": "S.A.T.8-少女密话",
                "icon": "Icon_SAT8_3602.png",
                "alt": "pic_SAT8_3602_D.png",
                "kr": "S.A.T.8 - 소녀의 비밀 이야기",
                "jp": "秘密のガールズトーク",
                "en": "Maiden's Secret"
            }
        },
        "kr": "S.A.T.8",
        "jp": "S.A.T.8",
        "en": "S.A.T.8"
    },
    "189": {
        "type": "SG",
        "id": "189",
        "cn": "USAS-12",
        "code": "USAS12",
        "icon": "Icon_USAS12.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_USAS12.png": {
                "cn": "USAS-12",
                "kr": "USAS-12",
                "jp": "USAS-12",
                "en": "USAS-12",
                "alt": "pic_USAS12_D.png"
            },
            "pic_USAS12_2704.png": {
                "cn": "USAS-12-VRAIN Power",
                "icon": "Icon_USAS12_2704.png",
                "alt": "pic_USAS12_2704_D.png",
                "kr": "USAS-12 - VRAIN Power",
                "jp": "VRAIN Power",
                "en": "VRAIN Power"
            }
        },
        "kr": "USAS-12",
        "jp": "USAS-12",
        "en": "USAS-12"
    },
    "190": {
        "type": "SG",
        "id": "190",
        "cn": "NS2000",
        "code": "NS2000",
        "icon": "Icon_NS2000.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_NS2000.png": {
                "cn": "NS2000",
                "kr": "NS2000",
                "jp": "NS2000",
                "en": "NS2000",
                "alt": "pic_NS2000_D.png"
            },
            "pic_NS2000_4406.png": {
                "cn": "NS2000-百味咖喱兔",
                "icon": "Icon_NS2000_4406.png",
                "alt": "pic_NS2000_4406_D.png",
                "kr": "NS2000 - 믹스카레토끼",
                "jp": "百味カレーうさぎ",
                "en": "Hundred-Flavor Curry Bunny"
            }
        },
        "kr": "NS2000",
        "jp": "NS2000",
        "en": "NS2000"
    },
    "191": {
        "type": "SMG",
        "id": "191",
        "cn": "M12",
        "code": "M12",
        "icon": "Icon_M12.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_M12.png": {
                "cn": "M12",
                "kr": "M12",
                "jp": "M12",
                "en": "M12",
                "alt": "pic_M12_D.png"
            }
        },
        "kr": "M12",
        "jp": "M12",
        "en": "M12"
    },
    "192": {
        "type": "RF",
        "id": "192",
        "cn": "JS05",
        "code": "JS-127",
        "icon": "Icon_JS-127.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_JS-127.png": {
                "cn": "JS05",
                "kr": "JS05",
                "jp": "JS05",
                "en": "JS05",
                "alt": "pic_JS-127_D.png"
            },
            "pic_JS-127_1804.png": {
                "cn": "JS05-玉帘草",
                "icon": "Icon_JS-127_1804.png",
                "alt": "pic_JS-127_1804_D.png",
                "kr": "JS05 - 제피란테스",
                "jp": "玉簾",
                "en": "Fairy Lily"
            },
            "pic_JS-127_2702.png": {
                "cn": "JS05-离别之奏",
                "icon": "Icon_JS-127_2702.png",
                "alt": "pic_JS-127_2702_D.png",
                "kr": "JS05 - 이별의 연주",
                "jp": "かなで",
                "en": "Swansong"
            }
        },
        "kr": "JS05",
        "jp": "JS05",
        "en": "JS05"
    },
    "193": {
        "type": "AR",
        "id": "193",
        "cn": "T65",
        "code": "T65",
        "icon": "Icon_T65.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_T65.png": {
                "cn": "T65",
                "kr": "T65",
                "jp": "T65",
                "en": "T65",
                "alt": "pic_T65_D.png"
            }
        },
        "kr": "T65",
        "jp": "T65",
        "en": "T65"
    },
    "194": {
        "type": "AR",
        "id": "194",
        "cn": "K2",
        "code": "K2",
        "icon": "Icon_K2.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_K2.png": {
                "cn": "K2",
                "kr": "K2",
                "jp": "K2",
                "en": "K2",
                "alt": "pic_K2_D.png"
            },
            "pic_K2_2001.png": {
                "cn": "K2-远东公主",
                "icon": "Icon_K2_2001.png",
                "alt": "pic_K2_2001_D.png",
                "kr": "K2 - 동방의 공주",
                "jp": "極東の姫君",
                "en": "Far East Princess"
            },
            "pic_K2_3301.png": {
                "cn": "K2-黎明之前",
                "icon": "Icon_K2_3301.png",
                "alt": "pic_K2_3301_D.png",
                "kr": "K2 - 해뜨기 전에",
                "jp": "夜明け前",
                "en": "Before Dawn"
            }
        },
        "kr": "K2",
        "jp": "K2",
        "en": "K2"
    },
    "195": {
        "type": "MG",
        "id": "195",
        "cn": "HK23",
        "code": "HK23",
        "icon": "Icon_HK23.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_HK23.png": {
                "cn": "HK23",
                "kr": "HK23",
                "jp": "Gr MG23",
                "en": "Gr MG23",
                "alt": "pic_HK23_D.png"
            }
        },
        "kr": "HK23",
        "jp": "Gr MG23",
        "en": "Gr MG23"
    },
    "196": {
        "type": "AR",
        "id": "196",
        "cn": "Zas M21",
        "code": "ZastavaM21",
        "icon": "Icon_ZastavaM21.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_ZastavaM21.png": {
                "cn": "Zas M21",
                "kr": "Zas M21",
                "jp": "Zas M21",
                "en": "Zas M21",
                "alt": "pic_ZastavaM21_D.png"
            },
            "pic_ZastavaM21_1603.png": {
                "cn": "Zas M21-献上枪声的雪姑娘",
                "icon": "Icon_ZastavaM21_1603.png",
                "alt": "pic_ZastavaM21_1603_D.png",
                "kr": "Zas M21 - 총성을 울리는 설녀",
                "jp": "銃声を捧げる雪姫",
                "en": "Gunshot in the Snow"
            },
            "pic_ZastavaM21_2104.png": {
                "cn": "Zas M21-白棋王后",
                "icon": "Icon_ZastavaM21_2104.png",
                "alt": "pic_ZastavaM21_2104_D.png",
                "kr": "Zas M21 - 화이트 퀸",
                "jp": "白の王妃",
                "en": "White Queen"
            },
            "pic_ZastavaM21_4304.png": {
                "cn": "Zas M21-花之后的情愫",
                "icon": "Icon_ZastavaM21_4304.png",
                "alt": "pic_ZastavaM21_4304_D.png",
                "kr": "Zas M21 - 꽃에 숨은 진심",
                "jp": "花の裏のクオリア",
                "en": "Affections Behind the Bouquet"
            }
        },
        "kr": "Zas M21",
        "jp": "Zas M21",
        "en": "Zas M21"
    },
    "197": {
        "type": "RF",
        "id": "197",
        "cn": "卡尔卡诺M1891",
        "code": "Carcano1891",
        "icon": "Icon_Carcano1891.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_Carcano1891.png": {
                "cn": "卡尔卡诺M1891",
                "kr": "카르카노M1891",
                "jp": "カルカノ M1891",
                "en": "Carcano M1891",
                "alt": "pic_Carcano1891_D.png"
            },
            "pic_Carcano1891_2201.png": {
                "cn": "卡尔卡诺M1891-勇敢的小卡诺",
                "icon": "Icon_Carcano1891_2201.png",
                "alt": "pic_Carcano1891_2201_D.png",
                "kr": "카르카노M1891 - 용감한 재봉사",
                "jp": "勇ましいちびカルカノ",
                "en": "Little Brave Cano"
            },
            "pic_Carcano1891_2905.png": {
                "cn": "卡尔卡诺M1891-起始的钟声",
                "icon": "Icon_Carcano1891_2905.png",
                "alt": "pic_Carcano1891_2905_D.png",
                "kr": "카르카노 M1891 - 시작을 알리는 소리",
                "jp": "始まりの鐘",
                "en": "Bells of Beginning"
            }
        },
        "kr": "카르카노M1891",
        "jp": "カルカノ M1891",
        "en": "Carcano M1891"
    },
    "198": {
        "type": "RF",
        "id": "198",
        "cn": "卡尔卡诺M91/38",
        "code": "Carcano1938",
        "icon": "Icon_Carcano1938.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_Carcano1938.png": {
                "cn": "卡尔卡诺M91/38",
                "kr": "카르카노M91/38",
                "jp": "カルカノ M91/38",
                "en": "Carcano M91/38",
                "alt": "pic_Carcano1938_D.png"
            },
            "pic_Carcano1938_2202.png": {
                "cn": "卡尔卡诺M91/38-匹诺曹小姐",
                "icon": "Icon_Carcano1938_2202.png",
                "alt": "pic_Carcano1938_2202_D.png",
                "kr": "카르카노M91/38 - 시노키오",
                "jp": "ミスピノキオ",
                "en": "Miss Pinocchio"
            },
            "pic_Carcano1938_2904.png": {
                "cn": "卡尔卡诺M91/38-Insegui l'aquilone",
                "icon": "Icon_Carcano1938_2904.png",
                "alt": "pic_Carcano1938_2904_D.png",
                "kr": "카르카노 M91/38 - Insegui l'aquilone",
                "jp": "Insegui l'aquilone",
                "en": "Insegui l'aquilone"
            }
        },
        "kr": "카르카노M91/38",
        "jp": "カルカノ M91/38",
        "en": "Carcano M91/38"
    },
    "199": {
        "type": "MG",
        "id": "199",
        "cn": "80式",
        "code": "80type",
        "icon": "Icon_80type.png",
        "modded": true,
        "rarity": 4,
        "skins": {
            "pic_80type.png": {
                "cn": "80式",
                "kr": "80식",
                "jp": "80式",
                "en": "Type80",
                "alt": "pic_80type_D.png"
            },
            "pic_80typeMod.png": {
                "cn": "80式",
                "kr": "80식",
                "jp": "80式",
                "en": "Type80",
                "icon": "mod",
                "alt": "pic_80typeMod_D.png"
            },
            "pic_80type_2504.png": {
                "cn": "80式-钢化蝴蝶",
                "icon": "Icon_80type_2504.png",
                "alt": "pic_80type_2504_D.png",
                "kr": "80식 - 스틸 버터플라이",
                "jp": "Steel　Butterfly",
                "en": "Steel Butterfly"
            }
        },
        "kr": "80식",
        "jp": "80式",
        "en": "Type80",
        "moddedIcon": "Icon_80typeMod.png",
        "modRarity": 5
    },
    "200": {
        "type": "RF",
        "id": "200",
        "cn": "XM3",
        "code": "xm3",
        "icon": "Icon_xm3.png",
        "modded": true,
        "rarity": 4,
        "skins": {
            "pic_xm3.png": {
                "cn": "XM3",
                "kr": "XM3",
                "jp": "XM3",
                "en": "XM3",
                "alt": "pic_xm3_D.png"
            },
            "pic_xm3Mod.png": {
                "cn": "XM3",
                "kr": "XM3",
                "jp": "XM3",
                "en": "XM3",
                "icon": "mod",
                "alt": "pic_xm3Mod_D.png"
            }
        },
        "kr": "XM3",
        "jp": "XM3",
        "en": "XM3",
        "moddedIcon": "Icon_xm3Mod.png",
        "modRarity": 5
    },
    "201": {
        "type": "RF",
        "id": "201",
        "cn": "猎豹M1",
        "code": "GepardM1",
        "icon": "Icon_GepardM1.png",
        "modded": true,
        "rarity": 3,
        "skins": {
            "pic_GepardM1.png": {
                "cn": "猎豹M1",
                "kr": "게파드 M1",
                "jp": "ゲパード M1",
                "en": "Gepard M1",
                "alt": "pic_GepardM1_D.png"
            },
            "pic_GepardM1Mod.png": {
                "cn": "猎豹M1",
                "kr": "게파드 M1",
                "jp": "ゲパード M1",
                "en": "Gepard M1",
                "icon": "mod",
                "alt": "pic_GepardM1Mod_D.png"
            },
            "pic_GepardM1_2305.png": {
                "cn": "猎豹M1-今日合约",
                "icon": "Icon_GepardM1_2305.png",
                "alt": "pic_GepardM1_2305_D.png",
                "kr": "게파드 M1 - 1일 계약",
                "jp": "刻下の契り",
                "en": "Contracted Today"
            },
            "pic_GepardM1_3107.png": {
                "cn": "猎豹M1-期待着的明天",
                "icon": "Icon_GepardM1_3107.png",
                "alt": "pic_GepardM1_3107_D.png",
                "kr": "게파드 M1 - 기대되는 내일",
                "jp": "待望の明日",
                "en": "Exciting Future"
            },
            "pic_GepardM1_4006.png": {
                "cn": "猎豹M1-无垢庇护者",
                "icon": "Icon_GepardM1_4006.png",
                "alt": "pic_GepardM1_4006_D.png",
                "kr": "게파드M1 - 무구한 수호자",
                "jp": "無垢なる庇護者",
                "en": "Unblemished Protector"
            }
        },
        "kr": "게파드 M1",
        "jp": "ゲパード M1",
        "en": "Gepard M1",
        "moddedIcon": "Icon_GepardM1Mod.png",
        "modRarity": 4
    },
    "202": {
        "type": "HG",
        "id": "202",
        "cn": "雷电",
        "code": "Thunder50",
        "icon": "Icon_Thunder50.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_Thunder50.png": {
                "cn": "雷电",
                "kr": "썬더",
                "jp": "Thunder",
                "en": "Thunder",
                "alt": "pic_Thunder50_D.png"
            },
            "pic_Thunder50_2206.png": {
                "cn": "雷电-莉诺尔的乌鸦",
                "icon": "Icon_Thunder50_2206.png",
                "alt": "pic_Thunder50_2206_D.png",
                "kr": "썬더 - 레이븐 네버모어",
                "jp": "二度とない大鴉",
                "en": "Lenore's Raven"
            },
            "pic_Thunder50_3309.png": {
                "cn": "雷电-黑天鹅的梦",
                "icon": "Icon_Thunder50_3309.png",
                "alt": "pic_Thunder50_3309_D.png",
                "kr": "썬더 - 블랙 스완의 꿈",
                "jp": "ブラックスワンの夢",
                "en": "Black Swan's Dream"
            }
        },
        "kr": "썬더",
        "jp": "Thunder",
        "en": "Thunder"
    },
    "203": {
        "type": "SMG",
        "id": "203",
        "cn": "蜜獾",
        "code": "PDW",
        "icon": "Icon_PDW.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_PDW.png": {
                "cn": "蜜獾",
                "kr": "허니뱃저",
                "jp": "Honey Badger",
                "en": "Honey Badger",
                "alt": "pic_PDW_D.png"
            },
            "pic_PDW_4005.png": {
                "cn": "蜜獾-圣诞公主和不笑贝特",
                "icon": "Icon_PDW_4005.png",
                "alt": "pic_PDW_4005_D.png",
                "kr": "허니뱃저 - 산타 공주와 무표정 오소리",
                "jp": "クリスマス皇女と笑わないペト",
                "en": "The X'mas Princess and the Stony Pett"
            }
        },
        "kr": "허니뱃저",
        "jp": "Honey Badger",
        "en": "Honey Badger"
    },
    "204": {
        "type": "RF",
        "id": "204",
        "cn": "芭莉斯塔",
        "code": "Ballista",
        "icon": "Icon_Ballista.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_Ballista.png": {
                "cn": "芭莉斯塔",
                "kr": "발리스타",
                "jp": "Ballista",
                "en": "Ballista",
                "alt": "pic_Ballista_D.png"
            }
        },
        "kr": "발리스타",
        "jp": "Ballista",
        "en": "Ballista"
    },
    "205": {
        "type": "AR",
        "id": "205",
        "cn": "AN-94",
        "code": "AN94",
        "icon": "Icon_AN94.png",
        "modded": true,
        "rarity": 5,
        "skins": {
            "pic_AN94.png": {
                "cn": "AN-94",
                "kr": "AN-94",
                "jp": "AN-94",
                "en": "AN-94",
                "alt": "pic_AN94_D.png"
            },
            "pic_AN94Mod.png": {
                "cn": "AN-94",
                "kr": "AN-94",
                "jp": "AN-94",
                "en": "AN-94",
                "icon": "mod",
                "alt": "pic_AN94Mod_D.png"
            },
            "pic_AN94_2404.png": {
                "cn": "AN-94-潜水钟与人偶",
                "icon": "Icon_AN94_2404.png",
                "alt": "pic_AN94_2404_D.png",
                "kr": "AN-94 - 잠수종과 인형",
                "jp": "潜水服は人形の夢を見る",
                "en": "The Diving Bell and the Doll"
            },
            "pic_AN94_3303.png": {
                "cn": "AN-94-沉默嫣红",
                "icon": "Icon_AN94_3303.png",
                "alt": "pic_AN94_3303_D.png",
                "kr": "AN-94 - 사일런트 레드",
                "jp": "鮮紅たる沈黙",
                "en": "Silent Rouge"
            }
        },
        "kr": "AN-94",
        "jp": "AN-94",
        "en": "AN-94",
        "moddedIcon": "Icon_AN94Mod.png",
        "modRarity": 6
    },
    "206": {
        "type": "AR",
        "id": "206",
        "cn": "AK-12",
        "code": "AK12",
        "icon": "Icon_AK12.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_AK12.png": {
                "cn": "AK-12",
                "kr": "AK-12",
                "jp": "AK-12",
                "en": "AK-12",
                "alt": "pic_AK12_D.png"
            },
            "pic_AK12_540.png": {
                "cn": "AK-12-极昼微光",
                "icon": "Icon_AK12_540.png",
                "alt": "pic_AK12_540_D.png",
                "kr": "AK-12 - 극주의 빛",
                "jp": "",
                "en": ""
            },
            "pic_AK12_2402.png": {
                "cn": "AK-12-冰沙时代",
                "icon": "Icon_AK12_2402.png",
                "alt": "pic_AK12_2402_D.png",
                "kr": "AK-12 - 빙수시대",
                "jp": "スムージー・エイジ",
                "en": "Age of Slushies"
            },
            "pic_AK12_3302.png": {
                "cn": "AK-12-静寂苍蓝",
                "icon": "Icon_AK12_3302.png",
                "alt": "pic_AK12_3302_D.png",
                "kr": "AK-12 - 프리징 블루",
                "jp": "青藍なる静寂",
                "en": "Quiet Azure"
            }
        },
        "kr": "AK-12",
        "jp": "AK-12",
        "en": "AK-12"
    },
    "207": {
        "type": "AR",
        "id": "207",
        "cn": "CZ2000",
        "code": "CZ2000",
        "icon": "Icon_CZ2000.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_CZ2000.png": {
                "cn": "CZ2000",
                "kr": "CZ2000",
                "jp": "CZ2000",
                "en": "CZ2000",
                "alt": "pic_CZ2000_D.png"
            }
        },
        "kr": "CZ2000",
        "jp": "CZ2000",
        "en": "CZ2000"
    },
    "208": {
        "type": "MG",
        "id": "208",
        "cn": "HK21",
        "code": "HK21",
        "icon": "Icon_HK21.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_HK21.png": {
                "cn": "HK21",
                "kr": "HK21",
                "jp": "HMG21",
                "en": "HMG21",
                "alt": "pic_HK21_D.png"
            },
            "pic_HK21_2701.png": {
                "cn": "HK21-击穿锁链的子弹",
                "icon": "Icon_HK21_2701.png",
                "alt": "pic_HK21_2701_D.png",
                "kr": "HK21 - 총알은 사슬을 꿰뚫고",
                "jp": "銃弾は鎖を撃ち抜いて",
                "en": "Chain Breaker"
            },
            "pic_HK21_4002.png": {
                "cn": "HK21-银狐的⅑月台",
                "icon": "Icon_HK21_4002.png",
                "alt": "pic_HK21_4002_D.png",
                "kr": "HK21 - 은여우와 9분의 1 승강장",
                "jp": "銀狐の⅑プラットフォーム",
                "en": "Vixen's Platform ⅑"
            }
        },
        "kr": "HK21",
        "jp": "HMG21",
        "en": "HMG21"
    },
    "209": {
        "type": "SMG",
        "id": "209",
        "cn": "OTs-39",
        "code": "OTs39",
        "icon": "Icon_OTs39.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_OTs39.png": {
                "cn": "OTs-39",
                "kr": "OTs-39",
                "jp": "OTs-39",
                "en": "OTs-39",
                "alt": "pic_OTs39_D.png"
            }
        },
        "kr": "OTs-39",
        "jp": "OTs-39",
        "en": "OTs-39"
    },
    "210": {
        "type": "HG",
        "id": "210",
        "cn": "CZ52",
        "code": "CZ52",
        "icon": "Icon_CZ52.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_CZ52.png": {
                "cn": "CZ52",
                "kr": "CZ52",
                "jp": "CZ52",
                "en": "CZ52",
                "alt": "pic_CZ52_D.png"
            },
            "pic_CZ52_3007.png": {
                "cn": "CZ52-琉璃唐",
                "icon": "Icon_CZ52_3007.png",
                "alt": "pic_CZ52_3007_D.png",
                "kr": "CZ52 - 네모필라",
                "jp": "瑠璃唐草",
                "en": "Baby Blue Eyes"
            }
        },
        "kr": "CZ52",
        "jp": "CZ52",
        "en": "CZ52"
    },
    "211": {
        "type": "RF",
        "id": "211",
        "cn": "SRS",
        "code": "DTASRS",
        "icon": "Icon_DTASRS.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_DTASRS.png": {
                "cn": "SRS",
                "kr": "SRS",
                "jp": "SRS",
                "en": "SRS",
                "alt": "pic_DTASRS_D.png"
            }
        },
        "kr": "SRS",
        "jp": "SRS",
        "en": "SRS"
    },
    "212": {
        "type": "HG",
        "id": "212",
        "cn": "K5",
        "code": "K5",
        "icon": "Icon_K5.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_K5.png": {
                "cn": "K5",
                "kr": "K5",
                "jp": "K5",
                "en": "K5",
                "alt": "pic_K5_D.png"
            },
            "pic_K5_2002.png": {
                "cn": "K5-穹顶月光",
                "icon": "Icon_K5_2002.png",
                "alt": "pic_K5_2002_D.png",
                "kr": "K5 - 둥근 달빛",
                "jp": "ムーンライト",
                "en": "Dome Moonlight"
            },
            "pic_K5_3308.png": {
                "cn": "K5-命运华尔兹",
                "icon": "Icon_K5_3308.png",
                "alt": "pic_K5_3308_D.png",
                "kr": "K5 - 운명의 왈츠",
                "jp": "運命のワルツ",
                "en": "Destiny Waltz"
            },
            "pic_K5_5306.png": {
                "cn": "K5-拾愿者K德瑞拉",
                "icon": "Icon_K5_5306.png",
                "alt": "pic_K5_5306_D.png",
                "kr": "K5 - 소원 듣는 신데렐라",
                "jp": "",
                "en": "Wishmaker K-derella"
            },
            "pic_K5_6905.png": {
                "cn": "K5-维纳斯之阵",
                "icon": "Icon_K5_6905.png",
                "alt": "pic_K5_6905_D.png",
                "kr": "K5 - 비너스의 진",
                "jp": "",
                "en": ""
            }
        },
        "kr": "K5",
        "jp": "K5",
        "en": "K5"
    },
    "213": {
        "type": "SMG",
        "id": "213",
        "cn": "C-MS",
        "code": "CBJMS",
        "icon": "Icon_CBJMS.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_CBJMS.png": {
                "cn": "C-MS",
                "kr": "C-MS",
                "jp": "C-MS",
                "en": "C-MS",
                "alt": "pic_CBJMS_D.png"
            },
            "pic_CBJMS_2205.png": {
                "cn": "C-MS-飞鹅旅行记",
                "icon": "Icon_CBJMS_2205.png",
                "alt": "pic_CBJMS_2205_D.png",
                "kr": "C-MS - 거위의 신비한 여행",
                "jp": "ガチョウのふしぎな旅",
                "en": "The Wonderful Adventures of Goose"
            },
            "pic_CBJMS_3503.png": {
                "cn": "C-MS-进击的飞鱼",
                "icon": "Icon_CBJMS_3503.png",
                "alt": "pic_CBJMS_3503_D.png",
                "kr": "C-MS - 날치 대행진",
                "jp": "進撃の飛魚",
                "en": "Flying Fish Assault"
            },
            "pic_CBJMS_6403.png": {
                "cn": "C-MS-献给乔安娜",
                "icon": "Icon_CBJMS_6403.png",
                "alt": "pic_CBJMS_6403_D.png",
                "kr": "C-MS - 요한나를 위하여",
                "jp": "ヨアンナに捧ぐ",
                "en": "To Matka Joanna"
            }
        },
        "kr": "C-MS",
        "jp": "C-MS",
        "en": "C-MS"
    },
    "214": {
        "type": "AR",
        "id": "214",
        "cn": "ADS",
        "code": "ADS",
        "icon": "Icon_ADS.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_ADS.png": {
                "cn": "ADS",
                "kr": "ADS",
                "jp": "ADS",
                "en": "ADS",
                "alt": "pic_ADS_D.png"
            },
            "pic_ADS_3601.png": {
                "cn": "ADS-水色青春",
                "icon": "Icon_ADS_3601.png",
                "alt": "pic_ADS_3601_D.png",
                "kr": "ADS - 물빛 청춘",
                "jp": "水色の青春",
                "en": "Aqua Youth"
            }
        },
        "kr": "ADS",
        "jp": "ADS",
        "en": "ADS"
    },
    "215": {
        "type": "AR",
        "id": "215",
        "cn": "MDR",
        "code": "MDR",
        "icon": "Icon_MDR.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_MDR.png": {
                "cn": "MDR",
                "kr": "MDR",
                "jp": "MDR",
                "en": "MDR",
                "alt": "pic_MDR_D.png"
            },
            "pic_MDR_2603.png": {
                "cn": "MDR-幽灵陷阱",
                "icon": "Icon_MDR_2603.png",
                "alt": "pic_MDR_2603_D.png",
                "kr": "MDR - 고스트랩",
                "jp": "ゴーストトラップ",
                "en": "Ghost Trap"
            },
            "pic_MDR_3305.png": {
                "cn": "MDR-酒会观测者",
                "icon": "Icon_MDR_3305.png",
                "alt": "pic_MDR_3305_D.png",
                "kr": "MDR - 연회 관측자",
                "jp": "パーティの観測者",
                "en": "Cocktail Observer"
            }
        },
        "kr": "MDR",
        "jp": "MDR",
        "en": "MDR"
    },
    "216": {
        "type": "AR",
        "id": "216",
        "cn": "XM8",
        "code": "XM8",
        "icon": "Icon_XM8.png",
        "modded": true,
        "rarity": 4,
        "skins": {
            "pic_XM8.png": {
                "cn": "XM8",
                "kr": "XM8",
                "jp": "XM8",
                "en": "XM8",
                "alt": "pic_XM8_D.png"
            },
            "pic_XM8Mod.png": {
                "cn": "XM8",
                "kr": "XM8",
                "jp": "XM8",
                "en": "XM8",
                "icon": "mod",
                "alt": "pic_XM8Mod_D.png"
            },
            "pic_XM8_5606.png": {
                "cn": "XM8-玫瑰棋手的告白",
                "icon": "Icon_XM8_5606.png",
                "alt": "pic_XM8_5606_D.png",
                "kr": "XM8 - 장미 기사의 고백",
                "jp": "バラ棋士の告白",
                "en": "The Rose Chess Player's Confession"
            }
        },
        "kr": "XM8",
        "jp": "XM8",
        "en": "XM8",
        "moddedIcon": "Icon_XM8Mod.png",
        "modRarity": 5
    },
    "217": {
        "type": "RF",
        "id": "217",
        "cn": "SM-1",
        "code": "HEZISM1",
        "icon": "Icon_HEZISM1.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_HEZISM1.png": {
                "cn": "SM-1",
                "kr": "SM-1",
                "jp": "SM-1",
                "en": "SM-1",
                "alt": "pic_HEZISM1_D.png"
            }
        },
        "kr": "SM-1",
        "jp": "SM-1",
        "en": "SM-1"
    },
    "218": {
        "type": "SMG",
        "id": "218",
        "cn": "T77",
        "code": "T77",
        "icon": "Icon_T77.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_T77.png": {
                "cn": "T77",
                "kr": "T77",
                "jp": "T77",
                "en": "T77",
                "alt": "pic_T77_D.png"
            },
            "pic_T77_6906.png": {
                "cn": "T77-彼岸星光",
                "icon": "Icon_T77_6906.png",
                "alt": "pic_T77_6906_D.png",
                "kr": "T77 - 저편의 별빛",
                "jp": "",
                "en": ""
            }
        },
        "kr": "T77",
        "jp": "T77",
        "en": "T77"
    },
    "220": {
        "type": "HG",
        "id": "220",
        "cn": "MP-443",
        "code": "MP443",
        "icon": "Icon_MP443.png",
        "modded": true,
        "rarity": 3,
        "skins": {
            "pic_MP443.png": {
                "cn": "MP-443",
                "kr": "MP-443",
                "jp": "MP-443",
                "en": "MP-443",
                "alt": "pic_MP443_D.png"
            },
            "pic_MP443Mod.png": {
                "cn": "MP-443",
                "kr": "MP-443",
                "jp": "MP-443",
                "en": "MP-443",
                "icon": "mod",
                "alt": "pic_MP443Mod_D.png"
            },
            "pic_MP443_6405.png": {
                "cn": "MP-443-迷途引渡人",
                "icon": "Icon_MP443_6405.png",
                "alt": "pic_MP443_6405_D.png",
                "kr": "MP-443 - 미궁의 안내인",
                "jp": "迷える案内人",
                "en": "Shepherd of the Lost"
            },
            "pic_MP443_7105.png": {
                "cn": "MP-443-碎金花信",
                "icon": "Icon_MP443_7105.png",
                "alt": "pic_MP443_7105_D.png",
                "kr": "MP-443 - 금박지 편지",
                "en": ""
            }
        },
        "kr": "MP-443",
        "jp": "MP-443",
        "en": "MP-443",
        "moddedIcon": "Icon_MP443Mod.png",
        "modRarity": 4
    },
    "221": {
        "type": "HG",
        "id": "221",
        "cn": "GSh-18",
        "code": "GSH18",
        "icon": "Icon_GSH18.png",
        "modded": true,
        "rarity": 3,
        "skins": {
            "pic_GSH18.png": {
                "cn": "GSh-18",
                "kr": "GSh-18",
                "jp": "GSh-18",
                "en": "GSh-18",
                "alt": "pic_GSH18_D.png"
            },
            "pic_GSH18Mod.png": {
                "cn": "GSh-18",
                "kr": "GSh-18",
                "jp": "GSh-18",
                "en": "GSh-18",
                "icon": "mod",
                "alt": "pic_GSH18Mod_D.png"
            },
            "pic_GSH18_523.png": {
                "cn": "GSh-18-行走的手术台",
                "icon": "Icon_GSH18_523.png",
                "alt": "pic_GSH18_523_D.png",
                "kr": "GSh-18 - 전진 수술실",
                "jp": "歩く手術台",
                "en": "Mobile Operating Table"
            }
        },
        "kr": "GSh-18",
        "jp": "GSh-18",
        "en": "GSh-18",
        "moddedIcon": "Icon_GSH18Mod.png",
        "modRarity": 4
    },
    "222": {
        "type": "RF",
        "id": "222",
        "cn": "TAC-50",
        "code": "TAC50",
        "icon": "Icon_TAC50.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_TAC50.png": {
                "cn": "TAC-50",
                "kr": "TAC-50",
                "jp": "TAC-50",
                "en": "TAC-50",
                "alt": "pic_TAC50_D.png"
            },
            "pic_TAC50_2602.png": {
                "cn": "TAC-50-精灵狙魔士",
                "icon": "Icon_TAC50_2602.png",
                "alt": "pic_TAC50_2602_D.png",
                "kr": "TAC-50 - 엘프 악마사냥꾼",
                "jp": "エルフ・ヘルシング",
                "en": "Elf Helsing"
            }
        },
        "kr": "TAC-50",
        "jp": "TAC-50",
        "en": "TAC-50"
    },
    "223": {
        "type": "AR",
        "id": "223",
        "cn": "Model L",
        "code": "CETME556",
        "icon": "Icon_CETME556.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_CETME556.png": {
                "cn": "Model L",
                "kr": "Model L",
                "jp": "Model L",
                "en": "Model L",
                "alt": "pic_CETME556_D.png"
            },
            "pic_CETME556_3809.png": {
                "cn": "Model L-暗夜炼狱刹",
                "icon": "Icon_CETME556_3809.png",
                "alt": "pic_CETME556_3809_D.png",
                "kr": "Model L - 흑야연옥찰",
                "jp": "宵闇の執行者",
                "en": "Nocturnal Executioner"
            },
            "pic_CETME556_6306.png": {
                "cn": "Model L-向着碧空漾去",
                "icon": "Icon_CETME556_6306.png",
                "alt": "pic_CETME556_6306_D.png",
                "kr": "Model L - 푸른 하늘로 두둥실",
                "jp": ""
            }
        },
        "kr": "Model L",
        "jp": "Model L",
        "en": "Model L"
    },
    "224": {
        "type": "SMG",
        "id": "224",
        "cn": "PM-06",
        "code": "PM06",
        "icon": "Icon_PM06.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_PM06.png": {
                "cn": "PM-06",
                "kr": "PM-06",
                "jp": "PM-06",
                "en": "PM-06",
                "alt": "pic_PM06_D.png"
            },
            "pic_PM06_2703.png": {
                "cn": "PM-06-翱翔天空之法",
                "icon": "Icon_PM06_2703.png",
                "alt": "pic_PM06_2703_D.png",
                "kr": "PM-06 - 창공을 나는 법",
                "jp": "そらの飛び方",
                "en": "I'm Soarin', Flyin'"
            }
        },
        "kr": "PM-06",
        "jp": "PM-06",
        "en": "PM-06"
    },
    "225": {
        "type": "SMG",
        "id": "225",
        "cn": "Cx4 风暴",
        "code": "Cx4Storm",
        "icon": "Icon_Cx4Storm.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_Cx4Storm.png": {
                "cn": "Cx4 风暴",
                "kr": "Cx4 스톰",
                "jp": "Cx4 ストーム",
                "en": "Cx4 Storm",
                "alt": "pic_Cx4Storm_D.png"
            },
            "pic_Cx4Storm_6606.png": {
                "cn": "Cx4 风暴-泳池边的圣诞奇遇",
                "icon": "Icon_Cx4Storm_6606.png",
                "alt": "pic_Cx4Storm_6606_D.png",
                "kr": "Cx4 스톰 - 성탄절 풀장에서의 만남",
                "jp": "プールサイドでの出逢い",
                "en": ""
            }
        },
        "kr": "Cx4 스톰",
        "jp": "Cx4 ストーム",
        "en": "Cx4 Storm"
    },
    "226": {
        "type": "RF",
        "id": "226",
        "cn": "Mk 12",
        "code": "Mk12",
        "icon": "Icon_Mk12.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_Mk12.png": {
                "cn": "Mk 12",
                "kr": "Mk 12",
                "jp": "Mk 12",
                "en": "Mk 12",
                "alt": "pic_Mk12_D.png"
            },
            "pic_Mk12_6203.png": {
                "cn": "Mk 12-食劫者的正义",
                "icon": "Icon_Mk12_6203.png",
                "alt": "pic_Mk12_6203_D.png",
                "kr": "Mk 12 - 정의로운 식량털이",
                "jp": "フードジャッカーの正義",
                "en": "Food Thief's Righteousness"
            }
        },
        "kr": "Mk 12",
        "jp": "Mk 12",
        "en": "Mk 12"
    },
    "227": {
        "type": "AR",
        "id": "227",
        "cn": "A-91",
        "code": "A91",
        "icon": "Icon_A91.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_A91.png": {
                "cn": "A-91",
                "kr": "A-91",
                "jp": "A-91",
                "en": "A-91",
                "alt": "pic_A91_D.png"
            },
            "pic_A91_4403.png": {
                "cn": "A-91-可燃乌龙茶",
                "icon": "Icon_A91_4403.png",
                "alt": "pic_A91_4403_D.png",
                "kr": "A-91 - 화끈한 우롱차",
                "jp": "可燃ウーロン茶",
                "en": "Inflammable Oolong Tea"
            }
        },
        "kr": "A-91",
        "jp": "A-91",
        "en": "A-91"
    },
    "228": {
        "type": "SMG",
        "id": "228",
        "cn": "樱花",
        "code": "Type100",
        "icon": "Icon_Type100.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_Type100.png": {
                "cn": "樱花",
                "kr": "100식",
                "jp": "一〇〇式",
                "en": "100 Shiki",
                "alt": "pic_Type100_D.png"
            },
            "pic_Type100_2903.png": {
                "cn": "樱花-枪使巫女",
                "icon": "Icon_Type100_2903.png",
                "alt": "pic_Type100_2903_D.png",
                "kr": "100식 - 총잡이 무녀",
                "jp": "銃使ノ巫女",
                "en": "Gunslinger Miko"
            },
            "pic_Type100_4004.png": {
                "cn": "樱花-埋入心底的宝藏",
                "icon": "Icon_Type100_4004.png",
                "alt": "pic_Type100_4004_D.png",
                "kr": "100식 - 마음에 묻어둔 보물",
                "jp": "ココロの埋蔵品",
                "en": "Treasure Buried Deep Within"
            },
            "pic_Type100_4905.png": {
                "cn": "樱花-玄衣神乐",
                "icon": "Icon_Type100_4905.png",
                "alt": "pic_Type100_4905_D.png",
                "kr": "100식 - 현의 카구라",
                "jp": "蔵六神楽",
                "en": "Kagura in Black"
            },
            "pic_Type100_7102.png": {
                "cn": "樱花-蝶影绮谭",
                "icon": "Icon_Type100_7102.png",
                "alt": "pic_Type100_7102_D.png",
                "kr": "100식 - 나비 기담",
                "en": ""
            }
        },
        "kr": "100식",
        "jp": "一〇〇式",
        "en": "100 Shiki"
    },
    "229": {
        "type": "SG",
        "id": "229",
        "cn": "M870",
        "code": "M870P",
        "icon": "Icon_M870P.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_M870P.png": {
                "cn": "M870",
                "kr": "M870",
                "jp": "M870",
                "en": "M870",
                "alt": "pic_M870P_D.png"
            },
            "pic_M870P_3803.png": {
                "cn": "M870-南瓜堡垒",
                "icon": "Icon_M870P_3803.png",
                "alt": "pic_M870P_3803_D.png",
                "kr": "M870 - 펌킨 포트리스",
                "jp": "かぼちゃ要塞",
                "en": "Pumpkin Fortress"
            }
        },
        "kr": "M870",
        "jp": "M870",
        "en": "M870"
    },
    "230": {
        "type": "RF",
        "id": "230",
        "cn": "OBR",
        "code": "OBR",
        "icon": "Icon_OBR.png",
        "modded": true,
        "rarity": 3,
        "skins": {
            "pic_OBR.png": {
                "cn": "OBR",
                "kr": "OBR",
                "jp": "OBR",
                "en": "OBR",
                "alt": "pic_OBR_D.png"
            },
            "pic_OBRMod.png": {
                "cn": "OBR",
                "kr": "OBR",
                "jp": "OBR",
                "en": "OBR",
                "icon": "mod",
                "alt": "pic_OBRMod_D.png"
            },
            "pic_OBR_586.png": {
                "cn": "OBR-卡斯蒂利亚女王",
                "icon": "Icon_OBR_586.png",
                "alt": "pic_OBR_586_D.png",
                "kr": "OBR - 카스티아의 여왕",
                "en": ""
            },
            "pic_OBR_5407.png": {
                "cn": "OBR-春报信使",
                "icon": "Icon_OBR_5407.png",
                "alt": "pic_OBR_5407_D.png",
                "kr": "OBR - 봄을 알리는 우편부",
                "jp": "春を告げる信使",
                "en": "Envoy of Spring"
            }
        },
        "kr": "OBR",
        "jp": "OBR",
        "en": "OBR",
        "moddedIcon": "Icon_OBRMod.png",
        "modRarity": 4
    },
    "231": {
        "type": "RF",
        "id": "231",
        "cn": "M82A1",
        "code": "M82A1",
        "icon": "Icon_M82A1.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_M82A1.png": {
                "cn": "M82A1",
                "kr": "M82A1",
                "jp": "M82A1",
                "en": "M82A1",
                "alt": "pic_M82A1_D.png"
            },
            "pic_M82A1_5803.png": {
                "cn": "M82A1-来自闇冥",
                "icon": "Icon_M82A1_5803.png",
                "alt": "pic_M82A1_5803_D.png",
                "kr": "M82A1 - 심연으로부터",
                "jp": "宵闇より来たる",
                "en": "Out of Darkness"
            }
        },
        "kr": "M82A1",
        "jp": "M82A1",
        "en": "M82A1"
    },
    "232": {
        "type": "HG",
        "id": "232",
        "cn": "MP-448",
        "code": "MP448",
        "icon": "Icon_MP448.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_MP448.png": {
                "cn": "MP-448",
                "kr": "MP-448",
                "jp": "MP-448",
                "en": "MP-448",
                "alt": "pic_MP448_D.png"
            }
        },
        "kr": "MP-448",
        "jp": "MP-448",
        "en": "MP-448"
    },
    "233": {
        "type": "HG",
        "id": "233",
        "cn": "Px4 风暴",
        "code": "Px4Storm",
        "icon": "Icon_Px4Storm.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_Px4Storm.png": {
                "cn": "Px4 风暴",
                "kr": "Px4 스톰",
                "jp": "Px4 ストーム",
                "en": "Px4 Storm",
                "alt": "pic_Px4Storm_D.png"
            },
            "pic_Px4Storm_2801.png": {
                "cn": "Px4 风暴-圣诞晨间女王",
                "icon": "Icon_Px4Storm_2801.png",
                "alt": "pic_Px4Storm_2801_D.png",
                "kr": "Px4 스톰 - 크리스마스 모닝퀸",
                "jp": "クリスマスの朝",
                "en": "Queen of X'mas Morning"
            },
            "pic_Px4Storm_6103.png": {
                "cn": "Px4 风暴-临海准则",
                "icon": "Icon_Px4Storm_6103.png",
                "alt": "pic_Px4Storm_6103_D.png",
                "kr": "Px4 스톰 - 해변 안전수칙",
                "jp": "シーサイド・パラダイム",
                "en": "Seaside Paradigm"
            },
            "pic_Px4Storm_7203.png": {
                "cn": "Px4 风暴-冬眠守梦者",
                "icon": "Icon_Px4Storm_7203.png",
                "alt": "pic_Px4Storm_7203_D.png",
                "kr": "Px4 스톰 - 겨울잠 꿈지기",
                "en": ""
            }
        },
        "kr": "Px4 스톰",
        "jp": "Px4 ストーム",
        "en": "Px4 Storm"
    },
    "234": {
        "type": "SMG",
        "id": "234",
        "cn": "JS 9",
        "code": "JS9mm",
        "icon": "Icon_JS9mm.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_JS9mm.png": {
                "cn": "JS 9",
                "kr": "JS 9",
                "jp": "JS 9",
                "en": "JS 9",
                "alt": "pic_JS9mm_D.png"
            },
            "pic_JS9mm_4204.png": {
                "cn": "JS 9-棣棠卿",
                "icon": "Icon_JS9mm_4204.png",
                "alt": "pic_JS9mm_4204_D.png",
                "kr": "JS9 - 황매화",
                "jp": "山吹卿",
                "en": "Tender Marigold"
            },
            "pic_JS9mm_4702.png": {
                "cn": "JS 9-逆戟之行",
                "icon": "Icon_JS9mm_4702.png",
                "alt": "pic_JS9mm_4702_D.png",
                "kr": "JS 9- 범고래 타고",
                "jp": "逆戟の旅",
                "en": "Orca's Journey"
            }
        },
        "kr": "JS 9",
        "jp": "JS 9",
        "en": "JS 9"
    },
    "235": {
        "type": "RF",
        "id": "235",
        "cn": "SPR A3G",
        "code": "FNSPR",
        "icon": "Icon_FNSPR.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_FNSPR.png": {
                "cn": "SPR A3G",
                "kr": "SPR A3G",
                "jp": "SPR A3G",
                "en": "SPR A3G",
                "alt": "pic_FNSPR_D.png"
            }
        },
        "kr": "SPR A3G",
        "jp": "SPR A3G",
        "en": "SPR A3G"
    },
    "236": {
        "type": "AR",
        "id": "236",
        "cn": "K11",
        "code": "K11",
        "icon": "Icon_K11.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_K11.png": {
                "cn": "K11",
                "kr": "K11",
                "jp": "K11",
                "en": "K11",
                "alt": "pic_K11_D.png"
            },
            "pic_K11_3402.png": {
                "cn": "K11-小小科学家",
                "icon": "Icon_K11_3402.png",
                "alt": "pic_K11_3402_D.png",
                "kr": "K11 - 꼬마 과학자",
                "jp": "ちっちゃなかがくしゃ",
                "en": "Lil' Scientist"
            }
        },
        "kr": "K11",
        "jp": "K11",
        "en": "K11"
    },
    "237": {
        "type": "AR",
        "id": "237",
        "cn": "SAR-21",
        "code": "SAR21",
        "icon": "Icon_SAR21.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_SAR21.png": {
                "cn": "SAR-21",
                "kr": "SAR-21",
                "jp": "SAR-21",
                "en": "SAR-21",
                "alt": "pic_SAR21_D.png"
            }
        },
        "kr": "SAR-21",
        "jp": "SAR-21",
        "en": "SAR-21"
    },
    "238": {
        "type": "MG",
        "id": "238",
        "cn": "88式",
        "code": "Type88",
        "icon": "Icon_Type88.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_Type88.png": {
                "cn": "88式",
                "kr": "88식",
                "jp": "88式",
                "en": "QJY-88",
                "alt": "pic_Type88_D.png"
            },
            "pic_Type88_3003.png": {
                "cn": "88式-朵幽兰",
                "icon": "Icon_Type88_3003.png",
                "alt": "pic_Type88_3003_D.png",
                "kr": "88식 - 봄 난초",
                "jp": "幽谷蘭",
                "en": "Noble Orchid"
            },
            "pic_Type88_3504.png": {
                "cn": "88式-反溺水配件",
                "icon": "Icon_Type88_3504.png",
                "alt": "pic_Type88_3504_D.png",
                "kr": "88식 - 침수 방지 키트",
                "jp": "溺水防止アタッチメント",
                "en": "Anti-Drowning Accessories"
            }
        },
        "kr": "88식",
        "jp": "88式",
        "en": "QJY-88"
    },
    "239": {
        "type": "AR",
        "id": "239",
        "cn": "03式",
        "code": "Type03",
        "icon": "Icon_Type03.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_Type03.png": {
                "cn": "03式",
                "kr": "03식",
                "jp": "03式",
                "en": "Type03",
                "alt": "pic_Type03_D.png"
            }
        },
        "kr": "03식",
        "jp": "03式",
        "en": "Type03"
    },
    "240": {
        "type": "MG",
        "id": "240",
        "cn": "Mk46",
        "code": "Mk46",
        "icon": "Icon_Mk46.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_Mk46.png": {
                "cn": "Mk46",
                "kr": "Mk46",
                "jp": "Mk46",
                "en": "Mk46",
                "alt": "pic_Mk46_D.png"
            }
        },
        "kr": "Mk46",
        "jp": "Mk46",
        "en": "Mk46"
    },
    "241": {
        "type": "RF",
        "id": "241",
        "cn": "RT-20",
        "code": "RT20",
        "icon": "Icon_RT20.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_RT20.png": {
                "cn": "RT-20",
                "kr": "RT-20",
                "jp": "RT-20",
                "en": "RT-20",
                "alt": "pic_RT20_D.png"
            }
        },
        "kr": "RT-20",
        "jp": "RT-20",
        "en": "RT-20"
    },
    "242": {
        "type": "HG",
        "id": "242",
        "cn": "P22",
        "code": "P22",
        "icon": "Icon_P22.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_P22.png": {
                "cn": "P22",
                "kr": "P22",
                "jp": "P22",
                "en": "P22",
                "alt": "pic_P22_D.png"
            },
            "pic_P22_3902.png": {
                "cn": "P22-跃动冲刺",
                "icon": "Icon_P22_3902.png",
                "alt": "pic_P22_3902_D.png",
                "kr": "P22 - 스퍼트 매그넘",
                "jp": "躍動のラストスパート",
                "en": "Pulsing Dash"
            },
            "pic_P22_6903.png": {
                "cn": "P22-幻想圆舞曲",
                "icon": "Icon_P22_6903.png",
                "alt": "pic_P22_6903_D.png",
                "kr": "P22 - 환상의 왈츠",
                "jp": "",
                "en": ""
            }
        },
        "kr": "P22",
        "jp": "P22",
        "en": "P22"
    },
    "243": {
        "type": "AR",
        "id": "243",
        "cn": "64式自",
        "code": "Type64-AR",
        "icon": "Icon_Type64-AR.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_Type64-AR.png": {
                "cn": "64式自",
                "kr": "64식 소총",
                "jp": "64式自",
                "en": "64 Shiki",
                "alt": "pic_Type64-AR_D.png"
            },
            "pic_Type64-AR_2901.png": {
                "cn": "64式自-新年祈愿",
                "icon": "Icon_Type64-AR_2901.png",
                "alt": "pic_Type64-AR_2901_D.png",
                "kr": "64식 소총 - 새해의 소망",
                "jp": "新年の祈り",
                "en": "New Year Wish"
            },
            "pic_Type64-AR_5702.png": {
                "cn": "64式自-一份不适合她的工作",
                "icon": "Icon_Type64-AR_5702.png",
                "alt": "pic_Type64-AR_5702_D.png",
                "kr": "64식 소총 - 그녀에게 맞지 않는 일",
                "jp": "彼女には向かない職業",
                "en": "An Unsuitable Job for Her"
            }
        },
        "kr": "64식 소총",
        "jp": "64式自",
        "en": "64 Shiki"
    },
    "244": {
        "type": "HG",
        "id": "244",
        "cn": "TEC-9",
        "code": "TEC9",
        "icon": "Icon_TEC9.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_TEC9.png": {
                "cn": "TEC-9",
                "kr": "TEC-9",
                "jp": "TEC-9",
                "en": "TEC-9",
                "alt": "pic_TEC9_D.png"
            },
            "pic_TEC9_5206.png": {
                "cn": "TEC-9-窃听疑云",
                "icon": "Icon_TEC9_5206.png",
                "alt": "pic_TEC9_5206_D.png",
                "kr": "TEC-9 - 의문의 감청자",
                "jp": "インターセプション",
                "en": "Wiretap Mystery"
            }
        },
        "kr": "TEC-9",
        "jp": "TEC-9",
        "en": "TEC-9"
    },
    "245": {
        "type": "SMG",
        "id": "245",
        "cn": "P90",
        "code": "P90",
        "icon": "Icon_P90.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_P90.png": {
                "cn": "P90",
                "kr": "P90",
                "jp": "P90",
                "en": "P90",
                "alt": "pic_P90_D.png"
            },
            "pic_P90_2802.png": {
                "cn": "P90-绯红涡轮",
                "icon": "Icon_P90_2802.png",
                "alt": "pic_P90_2802_D.png",
                "kr": "P90 - 스칼렛 터보",
                "jp": "スカーレットターボ",
                "en": "Scarlet Turbo"
            },
            "pic_P90_5701.png": {
                "cn": "P90-她来自比利时",
                "icon": "Icon_P90_5701.png",
                "alt": "pic_P90_5701_D.png",
                "kr": "P90 - 벨기에에서 온 그녀",
                "jp": "ベルギーより来る",
                "en": "The Girl from B.E.L"
            }
        },
        "kr": "P90",
        "jp": "P90",
        "en": "P90"
    },
    "247": {
        "type": "RF",
        "id": "247",
        "cn": "K31",
        "code": "K31",
        "icon": "Icon_K31.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_K31.png": {
                "cn": "K31",
                "kr": "K31",
                "jp": "K31",
                "en": "K31",
                "alt": "pic_K31_D.png"
            }
        },
        "kr": "K31",
        "jp": "K31",
        "en": "K31"
    },
    "248": {
        "type": "HG",
        "id": "248",
        "cn": "杰里科",
        "code": "Jericho",
        "icon": "Icon_Jericho.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_Jericho.png": {
                "cn": "杰里科",
                "kr": "제리코",
                "jp": "ジェリコ",
                "en": "Jericho",
                "alt": "pic_Jericho_D.png"
            }
        },
        "kr": "제리코",
        "jp": "ジェリコ",
        "en": "Jericho"
    },
    "249": {
        "type": "MG",
        "id": "249",
        "cn": "62式",
        "code": "Type62",
        "icon": "Icon_Type62.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_Type62.png": {
                "cn": "62式",
                "kr": "62식",
                "jp": "62式",
                "en": "62 Shiki",
                "alt": "pic_Type62_D.png"
            },
            "pic_Type62_2908.png": {
                "cn": "62式-新年游园会",
                "icon": "Icon_Type62_2908.png",
                "alt": "pic_Type62_2908_D.png",
                "kr": "62식 - 축제 나들이",
                "jp": "お祭りの正しい遊び方",
                "en": "New Year Fair"
            }
        },
        "kr": "62식",
        "jp": "62式",
        "en": "62 Shiki"
    },
    "250": {
        "type": "HG",
        "id": "250",
        "cn": "HS2000",
        "code": "HS2000",
        "icon": "Icon_HS2000.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_HS2000.png": {
                "cn": "HS2000",
                "kr": "HS2000",
                "jp": "HS2000",
                "en": "HS2000",
                "alt": "pic_HS2000_D.png"
            },
            "pic_HS2000_5304.png": {
                "cn": "HS2000-燃心铁皮人",
                "icon": "Icon_HS2000_5304.png",
                "alt": "pic_HS2000_5304_D.png",
                "kr": "HS2000 - 마음 뜨거운 양철인형",
                "jp": "",
                "en": "Warm-Hearted Tin Man"
            }
        },
        "kr": "HS2000",
        "jp": "HS2000",
        "en": "HS2000"
    },
    "251": {
        "type": "SMG",
        "id": "251",
        "cn": "X95",
        "code": "X95",
        "icon": "Icon_X95.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_X95.png": {
                "cn": "X95",
                "kr": "X95",
                "jp": "X95",
                "en": "X95",
                "alt": "pic_X95_D.png"
            },
            "pic_X95_4603.png": {
                "cn": "X95-白蔷薇少女",
                "icon": "Icon_X95_4603.png",
                "alt": "pic_X95_4603_D.png",
                "kr": "X95 - 백장미 소녀",
                "jp": "白薔薇の少女",
                "en": "White Rose Girl"
            }
        },
        "kr": "X95",
        "jp": "X95",
        "en": "X95"
    },
    "252": {
        "type": "RF",
        "id": "252",
        "cn": "KSVK",
        "code": "KSVK",
        "icon": "Icon_KSVK.png",
        "modded": true,
        "rarity": 4,
        "skins": {
            "pic_KSVK.png": {
                "cn": "KSVK",
                "kr": "KSVK",
                "jp": "KSVK",
                "en": "KSVK",
                "alt": "pic_KSVK_D.png"
            },
            "pic_KSVKMod.png": {
                "cn": "KSVK",
                "kr": "KSVK",
                "jp": "KSVK",
                "en": "KSVK",
                "icon": "mod",
                "alt": "pic_KSVKMod_D.png"
            },
            "pic_KSVK_3405.png": {
                "cn": "KSVK-天使的画笔",
                "icon": "Icon_KSVK_3405.png",
                "alt": "pic_KSVK_3405_D.png",
                "kr": "KSVK - 천사의 물감",
                "jp": "天使の絵筆",
                "en": "Angel's Paint Brush"
            },
            "pic_KSVK_3805.png": {
                "cn": "KSVK-月暗面漫步",
                "icon": "Icon_KSVK_3805.png",
                "alt": "pic_KSVK_3805_D.png",
                "kr": "KSVK - 뒷면의 문워커",
                "jp": "ダークムーンウォーク",
                "en": "Darkside Moonwalk"
            },
            "pic_KSVK_4509.png": {
                "cn": "KSVK-楚门的旅行者",
                "icon": "Icon_KSVK_4509.png",
                "alt": "pic_KSVK_4509_D.png",
                "kr": "KSVK - 트루먼 여행객",
                "jp": "トゥルーマンを渡る者",
                "en": "Truman Traveler"
            },
            "pic_KSVK_5504.png": {
                "cn": "KSVK-挽玉环",
                "icon": "Icon_KSVK_5504.png",
                "alt": "pic_KSVK_5504_D.png",
                "kr": "KSVK - 옥걸이 고리",
                "jp": "",
                "en": "Grasp of the Mimosa"
            }
        },
        "kr": "KSVK",
        "jp": "KSVK",
        "en": "KSVK",
        "moddedIcon": "Icon_KSVKMod.png",
        "modRarity": 5
    },
    "253": {
        "type": "MG",
        "id": "253",
        "cn": "刘易斯",
        "code": "Lewis",
        "icon": "Icon_Lewis.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_Lewis.png": {
                "cn": "刘易斯",
                "kr": "루이스",
                "jp": "ルイス",
                "en": "Lewis",
                "alt": "pic_Lewis_D.png"
            },
            "pic_Lewis_3502.png": {
                "cn": "刘易斯-防晒大作战",
                "icon": "Icon_Lewis_3502.png",
                "alt": "pic_Lewis_3502_D.png",
                "kr": "루이스 - 자외선 차단 작전",
                "jp": "UVカット大作戦",
                "en": "Sunscreen Battle"
            },
            "pic_Lewis_4001.png": {
                "cn": "刘易斯-圣夜约定",
                "icon": "Icon_Lewis_4001.png",
                "alt": "pic_Lewis_4001_D.png",
                "kr": "루이스 - 크리스마스이브의 약속",
                "jp": "聖夜の約束",
                "en": "Holy Night Promise"
            },
            "pic_Lewis_5501.png": {
                "cn": "刘易斯-迎寒客",
                "icon": "Icon_Lewis_5501.png",
                "alt": "pic_Lewis_5501_D.png",
                "kr": "루이스 - 추위를 맞는 손님",
                "jp": "",
                "en": "Warmth of the Wintersweet"
            },
            "pic_Lewis_6901.png": {
                "cn": "刘易斯-紫鸢醉蝶",
                "icon": "Icon_Lewis_6901.png",
                "alt": "pic_Lewis_6901_D.png",
                "kr": "루이스 - 붓꽃에 취한 나비",
                "jp": "",
                "en": ""
            }
        },
        "kr": "루이스",
        "jp": "ルイス",
        "en": "Lewis"
    },
    "254": {
        "type": "MG",
        "id": "254",
        "cn": "UKM-2000",
        "code": "UKM2000",
        "icon": "Icon_UKM2000.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_UKM2000.png": {
                "cn": "UKM-2000",
                "kr": "UKM-2000",
                "jp": "UKM-2000",
                "en": "UKM-2000",
                "alt": "pic_UKM2000_D.png"
            },
            "pic_UKM2000_3903.png": {
                "cn": "UKM-2000-急速风流",
                "icon": "Icon_UKM2000_3903.png",
                "alt": "pic_UKM2000_3903_D.png",
                "kr": "UKM-2000 - 퀘이사 스트림",
                "jp": "疾風迅雷",
                "en": "Breakneck Whirlwind"
            },
            "pic_UKM2000_5406.png": {
                "cn": "UKM-2000-冬原宅急便",
                "icon": "Icon_UKM2000_5406.png",
                "alt": "pic_UKM2000_5406_D.png",
                "kr": "UKM-2000 - 설원 배달부",
                "jp": "雪原の宅配便",
                "en": "Snowfield Delivery Service"
            },
            "pic_UKM2000_6106.png": {
                "cn": "UKM-2000-酸甜水物语",
                "icon": "Icon_UKM2000_6106.png",
                "alt": "pic_UKM2000_6106_D.png",
                "kr": "UKM-2000 - 레몬에이드 테일즈",
                "jp": "サイダー物語",
                "en": "Soda Tale"
            }
        },
        "kr": "UKM-2000",
        "jp": "UKM-2000",
        "en": "UKM-2000"
    },
    "255": {
        "type": "RF",
        "id": "255",
        "cn": "侦察者",
        "code": "scout",
        "icon": "Icon_scout.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_scout.png": {
                "cn": "侦察者",
                "kr": "스카웃",
                "jp": "スカウト",
                "en": "Scout",
                "alt": "pic_scout_D.png"
            }
        },
        "kr": "스카웃",
        "jp": "スカウト",
        "en": "Scout"
    },
    "256": {
        "type": "RF",
        "id": "256",
        "cn": "隼",
        "code": "Falcon",
        "icon": "Icon_Falcon.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_Falcon.png": {
                "cn": "隼",
                "kr": "팔콘",
                "jp": "ファルコン",
                "en": "Falcon",
                "alt": "pic_Falcon_D.png"
            },
            "pic_Falcon_4107.png": {
                "cn": "隼-伴君侧",
                "icon": "Icon_Falcon_4107.png",
                "alt": "pic_Falcon_4107_D.png",
                "kr": "팔콘 - 그대 곁에서",
                "jp": "君とともに",
                "en": "With You"
            },
            "pic_Falcon_6908.png": {
                "cn": "隼-晨露之歌",
                "icon": "Icon_Falcon_6908.png",
                "alt": "pic_Falcon_6908_D.png",
                "kr": "팔콘 - 이슬의 노래",
                "jp": "",
                "en": ""
            }
        },
        "kr": "팔콘",
        "jp": "ファルコン",
        "en": "Falcon"
    },
    "257": {
        "type": "RF",
        "id": "257",
        "cn": "M200",
        "code": "M200",
        "icon": "Icon_M200.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_M200.png": {
                "cn": "M200",
                "kr": "M200",
                "jp": "M200",
                "en": "M200",
                "alt": "pic_M200_D.png"
            },
            "pic_M200_560.png": {
                "cn": "M200-庄严行进",
                "icon": "Icon_M200_560.png",
                "alt": "pic_M200_560_D.png",
                "kr": "M200 - 장엄한 행진",
                "jp": "厳粛な行進",
                "en": "Solemn March"
            },
            "pic_M200_4502.png": {
                "cn": "M200-战地的采访者",
                "icon": "Icon_M200_4502.png",
                "alt": "pic_M200_4502_D.png",
                "kr": "M200 - 전장의 취재자",
                "jp": "戦場の取材者",
                "en": "War Correspondent"
            }
        },
        "kr": "M200",
        "jp": "M200",
        "en": "M200"
    },
    "258": {
        "type": "AR",
        "id": "258",
        "cn": "马盖尔",
        "code": "Magal",
        "icon": "Icon_Magal.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_Magal.png": {
                "cn": "马盖尔",
                "kr": "마갈",
                "jp": "マガル",
                "en": "Magal",
                "alt": "pic_Magal_D.png"
            },
            "pic_Magal_5707.png": {
                "cn": "马盖尔-马盖尔小姐",
                "icon": "Icon_Magal_5707.png",
                "alt": "pic_Magal_5707_D.png",
                "kr": "마갈 - 레이디 마갈",
                "jp": "ミス・マガル",
                "en": "Miss Magal"
            }
        },
        "kr": "마갈",
        "jp": "マガル",
        "en": "Magal"
    },
    "259": {
        "type": "SMG",
        "id": "259",
        "cn": "PM-9",
        "code": "PM9",
        "icon": "Icon_PM9.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_PM9.png": {
                "cn": "PM-9",
                "kr": "PM-9",
                "jp": "PM-9",
                "en": "PM-9",
                "alt": "pic_PM9_D.png"
            },
            "pic_PM9_6201.png": {
                "cn": "PM-9-不败的金色龙卷",
                "icon": "Icon_PM9_6201.png",
                "alt": "pic_PM9_6201_D.png",
                "kr": "PM-9 - 백전불패 황금빛",
                "jp": "負け知らずのゴールデントルネード",
                "en": "Invincible Golden Tornado"
            }
        },
        "kr": "PM-9",
        "jp": "PM-9",
        "en": "PM-9"
    },
    "260": {
        "type": "HG",
        "id": "260",
        "cn": "PA-15",
        "code": "PA15",
        "icon": "Icon_PA15.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_PA15.png": {
                "cn": "PA-15",
                "kr": "PA-15",
                "jp": "PA-15",
                "en": "PA-15",
                "alt": "pic_PA15_D.png"
            },
            "pic_PA15_3701.png": {
                "cn": "PA-15-高校心跳物语",
                "icon": "Icon_PA15_3701.png",
                "alt": "pic_PA15_3701_D.png",
                "kr": "PA-15 - 두근두근 하이스쿨",
                "jp": "高校胸キュン物語",
                "en": "High School Thrills"
            },
            "pic_PA15_4202.png": {
                "cn": "PA-15-翠雀媚",
                "icon": "Icon_PA15_4202.png",
                "alt": "pic_PA15_4202_D.png",
                "kr": "PA-15 - 델피니움",
                "jp": "蠱惑な千鳥草",
                "en": "Alluring Larkspur"
            },
            "pic_PA15_4402.png": {
                "cn": "PA-15-奇妙山药饼",
                "icon": "Icon_PA15_4402.png",
                "alt": "pic_PA15_4402_D.png",
                "kr": "PA-15 - 기묘한 고구마칩",
                "jp": "奇怪・とろろもち",
                "en": "Marvelous Yam Pastry"
            },
            "pic_PA15_5802.png": {
                "cn": "PA-15-香槟怪盗",
                "icon": "Icon_PA15_5802.png",
                "alt": "pic_PA15_5802_D.png",
                "kr": "PA-15 - 샴페인 괴도",
                "jp": "シャンパンの怪盗",
                "en": "Lady Thief of Champagne"
            }
        },
        "kr": "PA-15",
        "jp": "PA-15",
        "en": "PA-15"
    },
    "261": {
        "type": "RF",
        "id": "261",
        "cn": "QBU-88",
        "code": "QBU88",
        "icon": "Icon_QBU88.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_QBU88.png": {
                "cn": "QBU-88",
                "kr": "QBU-88",
                "jp": "QBU-88",
                "en": "QBU-88",
                "alt": "pic_QBU88_D.png"
            },
            "pic_QBU88_566.png": {
                "cn": "QBU-88-晨光欧蕾",
                "icon": "Icon_QBU88_566.png",
                "alt": "pic_QBU88_566_D.png",
                "kr": "QBU-88 - 아침햇살",
                "jp": "モーニング・オレ",
                "en": "Morning Au Lait"
            },
            "pic_QBU88_3801.png": {
                "cn": "QBU-88-拦路劫糖！",
                "icon": "Icon_QBU88_3801.png",
                "alt": "pic_QBU88_3801_D.png",
                "kr": "QBU-88 - 사탕 내놔라!",
                "jp": "お菓子をくれなきゃ通さない！",
                "en": "Candy Mugger!"
            },
            "pic_QBU88_4503.png": {
                "cn": "QBU-88-自然的探索者",
                "icon": "Icon_QBU88_4503.png",
                "alt": "pic_QBU88_4503_D.png",
                "kr": "QBU-88 - 자연의 탐험가",
                "jp": "自然の探索者",
                "en": "Explorer of the Wild"
            },
            "pic_QBU88_5502.png": {
                "cn": "QBU-88-舞凌霄",
                "icon": "Icon_QBU88_5502.png",
                "alt": "pic_QBU88_5502_D.png",
                "kr": "QBU-88 - 구름 높이 춤추자",
                "jp": "",
                "en": "Dance of the Trumpet Vine"
            },
            "pic_QBU88_7403.png": {
                "cn": "QBU-88-食铁兽的奇妙航旅",
                "icon": "Icon_QBU88_7403.png",
                "alt": "pic_QBU88_7403_D.png",
                "kr": "QBU-88 - 판다의 기묘한 항해",
                "en": "Panda's Miraculous Voyage"
            }
        },
        "kr": "QBU-88",
        "jp": "QBU-88",
        "en": "QBU-88"
    },
    "262": {
        "type": "AR",
        "id": "262",
        "cn": "EM-2",
        "code": "EM2",
        "icon": "Icon_EM2.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_EM2.png": {
                "cn": "EM-2",
                "kr": "EM-2",
                "jp": "EM-2",
                "en": "EM-2",
                "alt": "pic_EM2_D.png"
            },
            "pic_EM2_4209.png": {
                "cn": "EM-2-丁香意",
                "icon": "Icon_EM2_4209.png",
                "alt": "pic_EM2_4209_D.png",
                "kr": "EM-2 - 라일락",
                "jp": "丁香の意",
                "en": "Fragrant Clove"
            },
            "pic_EM2_5706.png": {
                "cn": "EM-2-银色子弹",
                "icon": "Icon_EM2_5706.png",
                "alt": "pic_EM2_5706_D.png",
                "kr": "EM-2 - 은색의 탄환",
                "jp": "銀色の弾丸",
                "en": "Silver Bullet"
            }
        },
        "kr": "EM-2",
        "jp": "EM-2",
        "en": "EM-2"
    },
    "263": {
        "type": "MG",
        "id": "263",
        "cn": "MG36",
        "code": "MG36",
        "icon": "Icon_MG36.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_MG36.png": {
                "cn": "MG36",
                "kr": "MG36",
                "jp": "Gr MG36",
                "en": "Gr MG36",
                "alt": "pic_MG36_D.png"
            },
            "pic_MG36_4205.png": {
                "cn": "MG36-悬铃绯",
                "icon": "Icon_MG36_4205.png",
                "alt": "pic_MG36_4205_D.png",
                "kr": "MG36 - 히비스커스",
                "jp": "緋メ芙蓉",
                "en": "Scarlet Turk's Cap"
            },
            "pic_MG36_4903.png": {
                "cn": "MG36-竹影清兵卫",
                "icon": "Icon_MG36_4903.png",
                "alt": "pic_MG36_4903_D.png",
                "kr": "MG36 - 대나무숲 검객",
                "jp": "竹影清兵衛",
                "en": "Bamboo Samurai"
            },
            "pic_MG36_6504.png": {
                "cn": "MG36-苍龙屹立09区之上",
                "icon": "Icon_MG36_6504.png",
                "alt": "pic_MG36_6504_D.png",
                "kr": "MG36 - 창룡 S09에 서다",
                "jp": "蒼龍、S09地区に立つ",
                "en": ""
            }
        },
        "kr": "MG36",
        "jp": "Gr MG36",
        "en": "Gr MG36"
    },
    "264": {
        "type": "MG",
        "id": "264",
        "cn": "绍沙",
        "code": "ChauchatM1915",
        "icon": "Icon_ChauchatM1915.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_ChauchatM1915.png": {
                "cn": "绍沙",
                "kr": "쇼샤",
                "jp": "ショーシャ",
                "en": "Chauchat",
                "alt": "pic_ChauchatM1915_D.png"
            }
        },
        "kr": "쇼샤",
        "jp": "ショーシャ",
        "en": "Chauchat"
    },
    "265": {
        "type": "AR",
        "id": "265",
        "cn": "HK33",
        "code": "HK33",
        "icon": "Icon_HK33.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_HK33.png": {
                "cn": "HK33",
                "kr": "HK33",
                "jp": "Gr HK33",
                "en": "Gr HK33",
                "alt": "pic_HK33_D.png"
            }
        },
        "kr": "HK33",
        "jp": "Gr HK33",
        "en": "Gr HK33"
    },
    "266": {
        "type": "RF",
        "id": "266",
        "cn": "R93",
        "code": "R93",
        "icon": "Icon_R93.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_R93.png": {
                "cn": "R93",
                "kr": "R93",
                "jp": "R93",
                "en": "R93",
                "alt": "pic_R93_D.png"
            },
            "pic_R93_3501.png": {
                "cn": "R93-长假幸运星",
                "icon": "Icon_R93_3501.png",
                "alt": "pic_R93_3501_D.png",
                "kr": "R93 - 럭키 바캉스",
                "jp": "ラッキースターの休日",
                "en": "Holiday Lucky Star"
            },
            "pic_R93_4904.png": {
                "cn": "R93-藤萝歌仙",
                "icon": "Icon_R93_4904.png",
                "alt": "pic_R93_4904_D.png",
                "kr": "R93 - 등나무 가희",
                "jp": "藤歌仙",
                "en": "Wisteria Minstrel"
            }
        },
        "kr": "R93",
        "jp": "R93",
        "en": "R93"
    },
    "267": {
        "type": "SMG",
        "id": "267",
        "cn": "MP41",
        "code": "MP41",
        "icon": "Icon_MP41.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_MP41.png": {
                "cn": "MP41",
                "kr": "MP41",
                "jp": "MP41",
                "en": "MP41",
                "alt": "pic_MP41_D.png"
            }
        },
        "kr": "MP41",
        "jp": "MP41",
        "en": "MP41"
    },
    "268": {
        "type": "RF",
        "id": "268",
        "cn": "T-CMS",
        "code": "TCMS",
        "icon": "Icon_TCMS.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_TCMS.png": {
                "cn": "T-CMS",
                "kr": "T-CMS",
                "jp": "T-CMS",
                "en": "T-CMS",
                "alt": "pic_TCMS_D.png"
            }
        },
        "kr": "T-CMS",
        "jp": "T-CMS",
        "en": "T-CMS"
    },
    "269": {
        "type": "HG",
        "id": "269",
        "cn": "P30",
        "code": "P30",
        "icon": "Icon_P30.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_P30.png": {
                "cn": "P30",
                "kr": "P30",
                "jp": "Gr P30",
                "en": "Gr P30",
                "alt": "pic_P30_D.png"
            },
            "pic_P30_4404.png": {
                "cn": "P30-恶魔指环糖",
                "icon": "Icon_P30_4404.png",
                "alt": "pic_P30_4404_D.png",
                "kr": "P30 - 절대반지사탕",
                "jp": "デビルリングキャンディ",
                "en": "Devil's Ring Pop"
            }
        },
        "kr": "P30",
        "jp": "Gr P30",
        "en": "Gr P30"
    },
    "270": {
        "type": "RF",
        "id": "270",
        "cn": "四式",
        "code": "4type",
        "icon": "Icon_4type.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_4type.png": {
                "cn": "四式",
                "kr": "4식",
                "jp": "四式",
                "en": "4 Shiki",
                "alt": "pic_4type_D.png"
            },
            "pic_4type_3505.png": {
                "cn": "四式-海角四号",
                "icon": "Icon_4type_3505.png",
                "alt": "pic_4type_3505_D.png",
                "kr": "4식 - 4번함 출항",
                "jp": "海角四号",
                "en": "Cape No. 4"
            },
            "pic_4type_4103.png": {
                "cn": "四式-花拍子",
                "icon": "Icon_4type_4103.png",
                "alt": "pic_4type_4103_D.png",
                "kr": "4식 - 꽃 제기 치기",
                "jp": "花びらの羽子板",
                "en": "Hanetsuki Paddle"
            },
            "pic_4type_5305.png": {
                "cn": "四式-朝暮仙子",
                "icon": "Icon_4type_5305.png",
                "alt": "pic_4type_5305_D.png",
                "kr": "4식 - 노을 요정",
                "jp": "",
                "en": "Twilight Fairy"
            }
        },
        "kr": "4식",
        "jp": "四式",
        "en": "4 Shiki"
    },
    "271": {
        "type": "MG",
        "id": "271",
        "cn": "K3",
        "code": "K3",
        "icon": "Icon_K3.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_K3.png": {
                "cn": "K3",
                "kr": "K3",
                "jp": "K3",
                "en": "K3",
                "alt": "pic_K3_D.png"
            }
        },
        "kr": "K3",
        "jp": "K3",
        "en": "K3"
    },
    "272": {
        "type": "HG",
        "id": "272",
        "cn": "沙漠之鹰",
        "code": "DesertEagle",
        "icon": "Icon_DesertEagle.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_DesertEagle.png": {
                "cn": "沙漠之鹰",
                "kr": "데저트 이글",
                "jp": "デザートイーグル",
                "en": "Desert Eagle",
                "alt": "pic_DesertEagle_D.png"
            },
            "pic_DesertEagle_6501.png": {
                "cn": "沙漠之鹰-苍穹的迦楼罗",
                "icon": "Icon_DesertEagle_6501.png",
                "alt": "pic_DesertEagle_6501_D.png",
                "kr": "데저트 이글 - 창공의 가루라",
                "jp": "蒼穹のカルラ",
                "en": ""
            }
        },
        "kr": "데저트 이글",
        "jp": "デザートイーグル",
        "en": "Desert Eagle"
    },
    "273": {
        "type": "RF",
        "id": "273",
        "cn": "SSG3000",
        "code": "SSG3000",
        "icon": "Icon_SSG3000.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_SSG3000.png": {
                "cn": "SSG3000",
                "kr": "SSG3000",
                "jp": "SSG3000",
                "en": "SSG3000",
                "alt": "pic_SSG3000_D.png"
            }
        },
        "kr": "SSG3000",
        "jp": "SSG3000",
        "en": "SSG3000"
    },
    "274": {
        "type": "AR",
        "id": "274",
        "cn": "ACR",
        "code": "ACR",
        "icon": "Icon_ACR.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_ACR.png": {
                "cn": "ACR",
                "kr": "ACR",
                "jp": "ACR",
                "en": "ACR",
                "alt": "pic_ACR_D.png"
            },
            "pic_ACR_5401.png": {
                "cn": "ACR-蓝黎软香",
                "icon": "Icon_ACR_5401.png",
                "alt": "pic_ACR_5401_D.png",
                "kr": "ACR - 은은한 란초향",
                "jp": "藍黎の香",
                "en": "Ultramarine Fragrance"
            },
            "pic_ACR_7401.png": {
                "cn": "ACR-星海寻因",
                "icon": "Icon_ACR_7401.png",
                "alt": "pic_ACR_7401_D.png",
                "kr": "ACR - 별의 바다 탐사",
                "en": "Search in the Stars"
            }
        },
        "kr": "ACR",
        "jp": "ACR",
        "en": "ACR"
    },
    "275": {
        "type": "MG",
        "id": "275",
        "cn": "M1895 CB",
        "code": "M1895MG",
        "icon": "Icon_M1895MG.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_M1895MG.png": {
                "cn": "M1895 CB",
                "kr": "M1895 CB",
                "jp": "M1895 CB",
                "en": "M1895 CB",
                "alt": "pic_M1895MG_D.png"
            },
            "pic_M1895MG_4208.png": {
                "cn": "M1895 CB-杓兰雅",
                "icon": "Icon_M1895MG_4208.png",
                "alt": "pic_M1895MG_4208_D.png",
                "kr": "M1895 CB - 복주머니꽃",
                "jp": "",
                "en": "Graceful Lady's-Slipper"
            }
        },
        "kr": "M1895 CB",
        "jp": "M1895 CB",
        "en": "M1895 CB"
    },
    "276": {
        "type": "MG",
        "id": "276",
        "cn": "Kord",
        "code": "Kord",
        "icon": "Icon_Kord.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_Kord.png": {
                "cn": "Kord",
                "kr": "Kord",
                "jp": "Kord",
                "en": "Kord",
                "alt": "pic_Kord_D.png"
            },
            "pic_Kord_5102.png": {
                "cn": "Kord-死寂舞者",
                "icon": "Icon_Kord_5102.png",
                "alt": "pic_Kord_5102_D.png",
                "kr": "Kord - 사일런트 댄서",
                "jp": "",
                "en": ""
            }
        },
        "kr": "Kord",
        "jp": "Kord",
        "en": "Kord"
    },
    "277": {
        "type": "HG",
        "id": "277",
        "cn": "VP70",
        "code": "VP70",
        "icon": "Icon_VP70.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_VP70.png": {
                "cn": "VP70",
                "kr": "VP70",
                "jp": "Gr VP70",
                "en": "Gr VP70",
                "alt": "pic_VP70_D.png"
            }
        },
        "kr": "VP70",
        "jp": "Gr VP70",
        "en": "Gr VP70"
    },
    "278": {
        "type": "SG",
        "id": "278",
        "cn": "CPS-12",
        "code": "Six12",
        "icon": "Icon_Six12.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_Six12.png": {
                "cn": "CPS-12",
                "kr": "Six12",
                "jp": "Six12",
                "en": "Six12",
                "alt": "pic_Six12_D.png"
            }
        },
        "kr": "Six12",
        "jp": "Six12",
        "en": "Six12"
    },
    "279": {
        "type": "AR",
        "id": "279",
        "cn": "英萨斯",
        "code": "INSAS",
        "icon": "Icon_INSAS.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_INSAS.png": {
                "cn": "英萨斯",
                "kr": "INSAS",
                "jp": "INSAS",
                "en": "INSAS",
                "alt": "pic_INSAS_D.png"
            }
        },
        "kr": "INSAS",
        "jp": "INSAS",
        "en": "INSAS"
    },
    "280": {
        "type": "SMG",
        "id": "280",
        "cn": "MAT-49",
        "code": "MAT49",
        "icon": "Icon_MAT49.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_MAT49.png": {
                "cn": "MAT-49",
                "kr": "MAT-49",
                "jp": "MAT-49",
                "en": "MAT-49",
                "alt": "pic_MAT49_D.png"
            }
        },
        "kr": "MAT-49",
        "jp": "MAT-49",
        "en": "MAT-49"
    },
    "281": {
        "type": "SG",
        "id": "281",
        "cn": "CAWS",
        "code": "HKCAWS",
        "icon": "Icon_HKCAWS.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_HKCAWS.png": {
                "cn": "CAWS",
                "kr": "CAWS",
                "jp": "CAWS",
                "en": "CAWS",
                "alt": "pic_HKCAWS_D.png"
            },
            "pic_HKCAWS_4003.png": {
                "cn": "CAWS-120份冬日礼物",
                "icon": "Icon_HKCAWS_4003.png",
                "alt": "pic_HKCAWS_4003_D.png",
                "kr": "CAWS - 120유로의 겨울 선물",
                "jp": "120の贈り物",
                "en": "120 Winter Gifts"
            }
        },
        "kr": "CAWS",
        "jp": "CAWS",
        "en": "CAWS"
    },
    "282": {
        "type": "SG",
        "id": "282",
        "cn": "DP-12",
        "code": "DP12",
        "icon": "Icon_DP12.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_DP12.png": {
                "cn": "DP-12",
                "kr": "DP-12",
                "jp": "DP-12",
                "en": "DP-12",
                "alt": "pic_DP12_D.png"
            },
            "pic_DP12_4201.png": {
                "cn": "DP-12-花月夜行灯",
                "icon": "Icon_DP12_4201.png",
                "alt": "pic_DP12_4201_D.png",
                "kr": "DP-12 - 꽃과 달 등롱",
                "jp": "花月夜提灯",
                "en": "Echeveria Lantern"
            },
            "pic_DP12_4901.png": {
                "cn": "DP-12-三途川女将",
                "icon": "Icon_DP12_4901.png",
                "alt": "pic_DP12_4901_D.png",
                "kr": "DP-12 - 삼도천 여관 주인",
                "jp": "三途川の女将",
                "en": "Keeper of the Sanzu River"
            },
            "pic_DP12_6102.png": {
                "cn": "DP-12-熙光寓言",
                "icon": "Icon_DP12_6102.png",
                "alt": "pic_DP12_6102_D.png",
                "kr": "DP-12 - 햇살 우화",
                "jp": "光の寓話",
                "en": "Morning Fable"
            }
        },
        "kr": "DP-12",
        "jp": "DP-12",
        "en": "DP-12"
    },
    "283": {
        "type": "SG",
        "id": "283",
        "cn": "解放者",
        "code": "Liberator",
        "icon": "Icon_Liberator.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_Liberator.png": {
                "cn": "解放者",
                "kr": "리버레이터",
                "jp": "リベレーター",
                "en": "Liberator",
                "alt": "pic_Liberator_D.png"
            }
        },
        "kr": "리버레이터",
        "jp": "リベレーター",
        "en": "Liberator"
    },
    "284": {
        "type": "RF",
        "id": "284",
        "cn": "Zas M76",
        "code": "ZasM76",
        "icon": "Icon_ZasM76.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_ZasM76.png": {
                "cn": "Zas M76",
                "kr": "Zas M76",
                "jp": "Zas M76",
                "en": "Zas M76",
                "alt": "pic_ZasM76_D.png"
            },
            "pic_ZasM76_4511.png": {
                "cn": "Zas M76-黑夜的舞蹈者",
                "icon": "Icon_ZasM76_4511.png",
                "alt": "pic_ZasM76_4511_D.png",
                "kr": "Zas M76 - 흑야의 댄서",
                "jp": "闇夜と舞う者",
                "en": "Dancer of the Night"
            }
        },
        "kr": "Zas M76",
        "jp": "Zas M76",
        "en": "Zas M76"
    },
    "285": {
        "type": "HG",
        "id": "285",
        "cn": "C-93",
        "code": "C93",
        "icon": "Icon_C93.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_C93.png": {
                "cn": "C-93",
                "kr": "C-93",
                "jp": "C-93",
                "en": "C-93",
                "alt": "pic_C93_D.png"
            },
            "pic_C93_5801.png": {
                "cn": "C-93-如蝶翩跹",
                "icon": "Icon_C93_5801.png",
                "alt": "pic_C93_5801_D.png",
                "kr": "C-93 - 나비처럼 날아서",
                "jp": "蝶のように舞う",
                "en": "Fluttering Butterfly"
            }
        },
        "kr": "C-93",
        "jp": "C-93",
        "en": "C-93"
    },
    "286": {
        "type": "SMG",
        "id": "286",
        "cn": "KAC-PDW",
        "code": "KAC",
        "icon": "Icon_KAC.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_KAC.png": {
                "cn": "KAC-PDW",
                "kr": "KAC-PDW",
                "jp": "K-PDW",
                "en": "K-PDW",
                "alt": "pic_KAC_D.png"
            },
            "pic_KAC_4706.png": {
                "cn": "KAC-PDW-甜慕之心",
                "icon": "Icon_KAC_4706.png",
                "alt": "pic_KAC_4706_D.png",
                "kr": "KAC-PDW - 달콤한 마음",
                "jp": "スイートハート",
                "en": "Sweetheart in Love"
            },
            "pic_KAC_6404.png": {
                "cn": "KAC-PDW-偷心魔不眠",
                "icon": "Icon_KAC_6404.png",
                "alt": "pic_KAC_6404_D.png",
                "kr": "KAC-PDW - 불면의 사랑 도둑",
                "jp": "魅了の悪魔は眠らない",
                "en": "No Rest for the Heart Thief"
            }
        },
        "kr": "KAC-PDW",
        "jp": "K-PDW",
        "en": "K-PDW"
    },
    "287": {
        "type": "AR",
        "id": "287",
        "cn": "SIG-556",
        "code": "SIG556",
        "icon": "Icon_SIG556.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_SIG556.png": {
                "cn": "SIG-556",
                "kr": "SIG-556",
                "jp": "SIG-556",
                "en": "SIG-556",
                "alt": "pic_SIG556_D.png"
            }
        },
        "kr": "SIG-556",
        "jp": "SIG-556",
        "en": "SIG-556"
    },
    "288": {
        "type": "AR",
        "id": "288",
        "cn": "CR-21",
        "code": "CR21",
        "icon": "Icon_CR21.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_CR21.png": {
                "cn": "CR-21",
                "kr": "CR-21",
                "jp": "CR-21",
                "en": "CR-21",
                "alt": "pic_CR21_D.png"
            },
            "pic_CR21_6605.png": {
                "cn": "CR-21-浪巅决骤",
                "icon": "Icon_CR21_6605.png",
                "alt": "pic_CR21_6605_D.png",
                "kr": "CR-21 - 파도 꼭대기",
                "jp": "ウェイブ・スプリント",
                "en": ""
            }
        },
        "kr": "CR-21",
        "jp": "CR-21",
        "en": "CR-21"
    },
    "289": {
        "type": "AR",
        "id": "289",
        "cn": "R5",
        "code": "R5RGP",
        "icon": "Icon_R5RGP.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_R5RGP.png": {
                "cn": "R5",
                "kr": "R5",
                "jp": "R5",
                "en": "R5",
                "alt": "pic_R5RGP_D.png"
            },
            "pic_R5RGP_5302.png": {
                "cn": "R5-终幕双人舞",
                "icon": "Icon_R5RGP_5302.png",
                "alt": "pic_R5RGP_5302_D.png",
                "kr": "R5 - 종막의 론도",
                "jp": "",
                "en": "Pas de Deux"
            }
        },
        "kr": "R5",
        "jp": "R5",
        "en": "R5"
    },
    "290": {
        "type": "AR",
        "id": "290",
        "cn": "89式自",
        "code": "HowaType89",
        "icon": "Icon_HowaType89.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_HowaType89.png": {
                "cn": "89式自",
                "kr": "89식 소총",
                "jp": "89式",
                "en": "89 Shiki",
                "alt": "pic_HowaType89_D.png"
            },
            "pic_HowaType89_6601.png": {
                "cn": "89式自-麋鹿宣言",
                "icon": "Icon_HowaType89_6601.png",
                "alt": "pic_HowaType89_6601_D.png",
                "kr": "89식 소총 - 순록 선언",
                "jp": "シフゾウ宣言",
                "en": ""
            }
        },
        "kr": "89식 소총",
        "jp": "89式",
        "en": "89 Shiki"
    },
    "291": {
        "type": "SMG",
        "id": "291",
        "cn": "43M",
        "code": "Danuvia43M",
        "icon": "Icon_Danuvia43M.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_Danuvia43M.png": {
                "cn": "43M",
                "kr": "43M",
                "jp": "43M",
                "en": "43M",
                "alt": "pic_Danuvia43M_D.png"
            }
        },
        "kr": "43M",
        "jp": "43M",
        "en": "43M"
    },
    "292": {
        "type": "MG",
        "id": "292",
        "cn": "RPK-16",
        "code": "RPK16",
        "icon": "Icon_RPK16.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_RPK16.png": {
                "cn": "RPK-16",
                "kr": "RPK-16",
                "jp": "RPK-16",
                "en": "RPK-16",
                "alt": "pic_RPK16_D.png"
            }
        },
        "kr": "RPK-16",
        "jp": "RPK-16",
        "en": "RPK-16"
    },
    "293": {
        "type": "AR",
        "id": "293",
        "cn": "AK-15",
        "code": "AK15",
        "icon": "Icon_AK15.png",
        "modded": true,
        "rarity": 5,
        "skins": {
            "pic_AK15.png": {
                "cn": "AK-15",
                "kr": "AK-15",
                "jp": "AK-15",
                "en": "AK-15",
                "alt": "pic_AK15_D.png"
            },
            "pic_AK15Mod.png": {
                "cn": "AK-15",
                "kr": "AK-15",
                "jp": "AK-15",
                "en": "AK-15",
                "icon": "mod",
                "alt": "pic_AK15Mod_D.png"
            }
        },
        "kr": "AK-15",
        "jp": "AK-15",
        "en": "AK-15",
        "moddedIcon": "Icon_AK15Mod.png",
        "modRarity": 6
    },
    "294": {
        "type": "HG",
        "id": "294",
        "cn": "韦伯利",
        "code": "Webley",
        "icon": "Icon_Webley.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_Webley.png": {
                "cn": "韦伯利",
                "kr": "웨블리 리볼버",
                "jp": "ウェブリー",
                "en": "Webley",
                "alt": "pic_Webley_D.png"
            },
            "pic_Webley_5601.png": {
                "cn": "韦伯利-日落黄昏时",
                "icon": "Icon_Webley_5601.png",
                "alt": "pic_Webley_5601_D.png",
                "kr": "웨블리 리볼버 - 해가 질 무렵",
                "jp": "黄昏の時",
                "en": "Before Sunset"
            }
        },
        "kr": "웨블리 리볼버",
        "jp": "ウェブリー",
        "en": "Webley"
    },
    "295": {
        "type": "SMG",
        "id": "295",
        "cn": "CF05",
        "code": "06TypeSMG",
        "icon": "Icon_06TypeSMG.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_06TypeSMG.png": {
                "cn": "CF05",
                "kr": "CF05",
                "jp": "CF-05",
                "en": "CF-05",
                "alt": "pic_06TypeSMG_D.png"
            },
            "pic_06TypeSMG_5104.png": {
                "cn": "CF05-灯影魔翼",
                "icon": "Icon_06TypeSMG_5104.png",
                "alt": "pic_06TypeSMG_5104_D.png",
                "kr": "CF05 - 붉은 박쥐",
                "jp": "",
                "en": ""
            },
            "pic_06TypeSMG_5905.png": {
                "cn": "CF05-火锅国国王",
                "icon": "Icon_06TypeSMG_5905.png",
                "alt": "pic_06TypeSMG_5905_D.png",
                "kr": "CF05 - 훠궈 나라 대왕",
                "jp": "",
                "en": "King of Hotpotland"
            },
            "pic_06TypeSMG_7306.png": {
                "cn": "CF05-漂浮的黑白音律",
                "icon": "Icon_06TypeSMG_7306.png",
                "alt": "pic_06TypeSMG_7306_D.png",
                "kr": "CF05 - 둥실둥실 흑백 음표",
                "en": ""
            }
        },
        "kr": "CF05",
        "jp": "CF-05",
        "en": "CF-05"
    },
    "296": {
        "type": "RF",
        "id": "296",
        "cn": "SL8",
        "code": "SL8",
        "icon": "Icon_SL8.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_SL8.png": {
                "cn": "SL8",
                "kr": "SL8",
                "jp": "Gr SL8",
                "en": "Gr SL8",
                "alt": "pic_SL8_D.png"
            },
            "pic_SL8_564.png": {
                "cn": "SL8-即兴狂想乐",
                "icon": "Icon_SL8_564.png",
                "alt": "pic_SL8_564_D.png",
                "kr": "SL8 - 즉흥 랩소디",
                "jp": "即興狂想曲",
                "en": "Improvised Rhapsody"
            },
            "pic_SL8_4704.png": {
                "cn": "SL8-怒涛之巅",
                "icon": "Icon_SL8_4704.png",
                "alt": "pic_SL8_4704_D.png",
                "kr": "SL8 - 파도를 넘어",
                "jp": "怒涛の頂上",
                "en": "Wave Crest"
            },
            "pic_SL8_5202.png": {
                "cn": "SL8-赤月追猎者",
                "icon": "Icon_SL8_5202.png",
                "alt": "pic_SL8_5202_D.png",
                "kr": "SL8 - 붉은 달의 추격자",
                "jp": "赤月のチェイサー",
                "en": "Red Moon Stalker"
            },
            "pic_SL8_6302.png": {
                "cn": "SL8-在世界的一角等你",
                "icon": "Icon_SL8_6302.png",
                "alt": "pic_SL8_6302_D.png",
                "kr": "SL8 - 세상 한 구석에서 기다릴게",
                "jp": ""
            }
        },
        "kr": "SL8",
        "jp": "Gr SL8",
        "en": "Gr SL8"
    },
    "297": {
        "type": "AR",
        "id": "297",
        "cn": "M82",
        "code": "M82",
        "icon": "Icon_M82.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_M82.png": {
                "cn": "M82",
                "kr": "M82",
                "jp": "FI M82",
                "en": "FI M82",
                "alt": "pic_M82_D.png"
            },
            "pic_M82_5105.png": {
                "cn": "M82-非凡者学徒",
                "icon": "Icon_M82_5105.png",
                "alt": "pic_M82_5105_D.png",
                "kr": "M82 - 비범한 학도",
                "jp": "",
                "en": ""
            },
            "pic_M82_5907.png": {
                "cn": "M82-猫咪的合奏",
                "icon": "Icon_M82_5907.png",
                "alt": "pic_M82_5907_D.png",
                "kr": "M82 - 야옹이 대합주",
                "jp": "",
                "en": "Kitty Chorus"
            }
        },
        "kr": "M82",
        "jp": "FI M82",
        "en": "FI M82"
    },
    "298": {
        "type": "AR",
        "id": "298",
        "cn": "Vepr",
        "code": "VEPR",
        "icon": "Icon_VEPR.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_VEPR.png": {
                "cn": "Vepr",
                "kr": "Vepr",
                "jp": "Vepr",
                "en": "Vepr",
                "alt": "pic_VEPR_D.png"
            }
        },
        "kr": "Vepr",
        "jp": "Vepr",
        "en": "Vepr"
    },
    "299": {
        "type": "SG",
        "id": "299",
        "cn": "高标10型",
        "code": "HSM10",
        "icon": "Icon_HSM10.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_HSM10.png": {
                "cn": "高标10型",
                "kr": "HS10",
                "jp": "HSM10",
                "en": "HSM10",
                "alt": "pic_HSM10_D.png"
            }
        },
        "kr": "HS10",
        "jp": "HSM10",
        "en": "HSM10"
    },
    "300": {
        "type": "MG",
        "id": "300",
        "cn": "CAR",
        "code": "CAR",
        "icon": "Icon_CAR.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_CAR.png": {
                "cn": "CAR",
                "kr": "CAR",
                "jp": "CAR",
                "en": "CAR",
                "alt": "pic_CAR_D.png"
            }
        },
        "kr": "CAR",
        "jp": "CAR",
        "en": "CAR"
    },
    "301": {
        "type": "SMG",
        "id": "301",
        "cn": "MAS-38",
        "code": "MAS38",
        "icon": "Icon_MAS38.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_MAS38.png": {
                "cn": "MAS-38",
                "kr": "MAS-38",
                "jp": "MAS-38",
                "en": "MAS-38",
                "alt": "pic_MAS38_D.png"
            }
        },
        "kr": "MAS-38",
        "jp": "MAS-38",
        "en": "MAS-38"
    },
    "302": {
        "type": "SG",
        "id": "302",
        "cn": "防卫者",
        "code": "ColtDefender",
        "icon": "Icon_ColtDefender.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_ColtDefender.png": {
                "cn": "防卫者",
                "kr": "콜트 디펜더",
                "jp": "ディフェンダー",
                "en": "Defender",
                "alt": "pic_ColtDefender_D.png"
            },
            "pic_ColtDefender_5505.png": {
                "cn": "防卫者-梦倒仙",
                "icon": "Icon_ColtDefender_5505.png",
                "alt": "pic_ColtDefender_5505_D.png",
                "kr": "콜트 디펜더 - 꿈에 취한 선녀",
                "jp": "",
                "en": "Lily's Reverie"
            },
            "pic_ColtDefender_7104.png": {
                "cn": "防卫者-星尘帷幕",
                "icon": "Icon_ColtDefender_7104.png",
                "alt": "pic_ColtDefender_7104_D.png",
                "kr": "콜트 디펜더 - 스타더스트 커튼",
                "en": ""
            }
        },
        "kr": "콜트 디펜더",
        "jp": "ディフェンダー",
        "en": "Defender"
    },
    "303": {
        "type": "HG",
        "id": "303",
        "cn": "HP-35",
        "code": "BrowningHP",
        "icon": "Icon_BrowningHP.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_BrowningHP.png": {
                "cn": "HP-35",
                "kr": "HP-35",
                "jp": "HP-35",
                "en": "HP-35",
                "alt": "pic_BrowningHP_D.png"
            },
            "pic_BrowningHP_4602.png": {
                "cn": "HP-35-小小乘风人",
                "icon": "Icon_BrowningHP_4602.png",
                "alt": "pic_BrowningHP_4602_D.png",
                "kr": "HP-35 - 바람 타고 씽씽",
                "jp": "小さな風乗り",
                "en": "Little Glider"
            }
        },
        "kr": "HP-35",
        "jp": "HP-35",
        "en": "HP-35"
    },
    "304": {
        "type": "SMG",
        "id": "304",
        "cn": "SAF",
        "code": "SAF",
        "icon": "Icon_SAF.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_SAF.png": {
                "cn": "SAF",
                "kr": "SAF",
                "jp": "SAF",
                "en": "SAF",
                "alt": "pic_SAF_D.png"
            },
            "pic_SAF_5205.png": {
                "cn": "SAF-神秘行者SA",
                "icon": "Icon_SAF_5205.png",
                "alt": "pic_SAF_5205_D.png",
                "kr": "SAF - 미스테리오 SA",
                "jp": "謎の通行人SA",
                "en": "Mysterious Wayfarer SA"
            },
            "pic_SAF_6607.png": {
                "cn": "SAF-暖冬速递员",
                "icon": "Icon_SAF_6607.png",
                "alt": "pic_SAF_6607_D.png",
                "kr": "SAF - 겨울 산뜻 택배",
                "jp": "ホットウィンターデリバリー",
                "en": ""
            }
        },
        "kr": "SAF",
        "jp": "SAF",
        "en": "SAF"
    },
    "305": {
        "type": "RF",
        "id": "305",
        "cn": "塔布克",
        "code": "Tabuk",
        "icon": "Icon_Tabuk.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_Tabuk.png": {
                "cn": "塔布克",
                "kr": "타부크 저격소총",
                "jp": "タブク",
                "en": "Tabuk",
                "alt": "pic_Tabuk_D.png"
            },
            "pic_Tabuk_4906.png": {
                "cn": "塔布克-食魂料理人",
                "icon": "Icon_Tabuk_4906.png",
                "alt": "pic_Tabuk_4906_D.png",
                "kr": "타부크 - 혼백 주방장",
                "jp": "魂の板前",
                "en": "Culinarian of the Souleaters"
            },
            "pic_Tabuk_6206.png": {
                "cn": "塔布克-三只小猪来租房",
                "icon": "Icon_Tabuk_6206.png",
                "alt": "pic_Tabuk_6206_D.png",
                "kr": "타부크 - 돼지 3형제가 부동산에",
                "jp": "三匹の子ブタ、家を借りる",
                "en": "Three Little Piggy Renters"
            },
            "pic_Tabuk_7204.png": {
                "cn": "塔布克-训宠员日常",
                "icon": "Icon_Tabuk_7204.png",
                "alt": "pic_Tabuk_7204_D.png",
                "kr": "타부크 - 훈련사의 일상",
                "en": ""
            }
        },
        "kr": "타부크 저격소총",
        "jp": "タブク",
        "en": "Tabuk"
    },
    "306": {
        "type": "AR",
        "id": "306",
        "cn": "AK-阿尔法",
        "code": "AKAlfa",
        "icon": "Icon_AKAlfa.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_AKAlfa.png": {
                "cn": "AK-阿尔法",
                "kr": "AK-Alfa",
                "jp": "AK-Alfa",
                "en": "AK-Alfa",
                "alt": "pic_AKAlfa_D.png"
            },
            "pic_AKAlfa_4601.png": {
                "cn": "AK-阿尔法-星夜捕猫人",
                "icon": "Icon_AKAlfa_4601.png",
                "alt": "pic_AKAlfa_4601_D.png",
                "kr": "AK-Alfa - 고양이 사냥꾼",
                "jp": "星夜のにゃんたー",
                "en": "Cat Snatcher Beneath the Stars"
            }
        },
        "kr": "AK-Alfa",
        "jp": "AK-Alfa",
        "en": "AK-Alfa"
    },
    "307": {
        "type": "MG",
        "id": "307",
        "cn": "ZB-26",
        "code": "ZB26",
        "icon": "Icon_ZB26.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_ZB26.png": {
                "cn": "ZB-26",
                "kr": "ZB-26",
                "jp": "ZB-26",
                "en": "ZB-26",
                "alt": "pic_ZB26_D.png"
            },
            "pic_ZB26_4703.png": {
                "cn": "ZB-26-旖梦之隅",
                "icon": "Icon_ZB26_4703.png",
                "alt": "pic_ZB26_4703_D.png",
                "kr": "ZB-26 - 그늘에 숨어",
                "jp": "風なびく夢の隅",
                "en": "Nook of Ephemeral Dreams"
            },
            "pic_ZB26_5603.png": {
                "cn": "ZB-26-第1000只纸鹤",
                "icon": "Icon_ZB26_5603.png",
                "alt": "pic_ZB26_5603_D.png",
                "kr": "ZB-26 - 1000마리 종이학",
                "jp": "千羽目の折り鶴",
                "en": "The 1000th Paper Crane"
            },
            "pic_ZB26_7101.png": {
                "cn": "ZB-26-暗蔷摇曳",
                "icon": "Icon_ZB26_7101.png",
                "alt": "pic_ZB26_7101_D.png",
                "kr": "ZB-26 - 흔들리는 흑장미",
                "en": ""
            }
        },
        "kr": "ZB-26",
        "jp": "ZB-26",
        "en": "ZB-26"
    },
    "308": {
        "type": "RF",
        "id": "308",
        "cn": "C14",
        "code": "C14",
        "icon": "Icon_C14.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_C14.png": {
                "cn": "C14",
                "kr": "C14",
                "jp": "C14",
                "en": "C14",
                "alt": "pic_C14_D.png"
            },
            "pic_C14_7004.png": {
                "cn": "C14-新入职员",
                "icon": "Icon_C14_7004.png",
                "alt": "pic_C14_7004_D.png",
                "kr": "C14 - 신입사원",
                "jp": "新人OLちゃん",
                "en": "New Staff"
            }
        },
        "kr": "C14",
        "jp": "C14",
        "en": "C14"
    },
    "309": {
        "type": "HG",
        "id": "309",
        "cn": "WKp",
        "code": "WKP",
        "icon": "Icon_WKP.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_WKP.png": {
                "cn": "WKp",
                "kr": "WKp",
                "jp": "WKp",
                "en": "WKp",
                "alt": "pic_WKP_D.png"
            }
        },
        "kr": "WKp",
        "jp": "WKp",
        "en": "WKp"
    },
    "310": {
        "type": "HG",
        "id": "310",
        "cn": "Rex-0-1",
        "code": "RexZero1",
        "icon": "Icon_RexZero1.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_RexZero1.png": {
                "cn": "Rex-0-1",
                "kr": "Rex Zero 1",
                "jp": "Rex Zero 1",
                "en": "Rex Zero 1",
                "alt": "pic_RexZero1_D.png"
            },
            "pic_RexZero1_6305.png": {
                "cn": "Rex-0-1-怦动三部曲",
                "icon": "Icon_RexZero1_6305.png",
                "alt": "pic_RexZero1_6305_D.png",
                "kr": "Rex Zero 1 - 두근두근 트릴로지",
                "jp": ""
            },
            "pic_RexZero1_7003.png": {
                "cn": "Rex-0-1-深夜暖茶",
                "icon": "Icon_RexZero1_7003.png",
                "alt": "pic_RexZero1_7003_D.png",
                "kr": "Rex Zero 1 - 심야에 차 한 잔",
                "jp": "深夜のホットティー",
                "en": "Late Night Tea"
            }
        },
        "kr": "Rex Zero 1",
        "jp": "Rex Zero 1",
        "en": "Rex Zero 1"
    },
    "311": {
        "type": "SMG",
        "id": "311",
        "cn": "卢萨",
        "code": "Lusa",
        "icon": "Icon_Lusa.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_Lusa.png": {
                "cn": "卢萨",
                "kr": "Lusa",
                "jp": "Lusa",
                "en": "Lusa",
                "alt": "pic_Lusa_D.png"
            },
            "pic_Lusa_5902.png": {
                "cn": "卢萨-后卫新星",
                "icon": "Icon_Lusa_5902.png",
                "alt": "pic_Lusa_5902_D.png",
                "kr": "Lusa - 수비수 꿈나무",
                "jp": "",
                "en": "New Star Defender"
            },
            "pic_Lusa_6703.png": {
                "cn": "卢萨-竹剑扫落雪",
                "icon": "Icon_Lusa_6703.png",
                "alt": "pic_Lusa_6703_D.png",
                "kr": "Lusa - 죽도로 눈바닥 쓸기",
                "jp": "竹剣雪を薙ぐ",
                "en": ""
            }
        },
        "kr": "Lusa",
        "jp": "Lusa",
        "en": "Lusa"
    },
    "312": {
        "type": "RF",
        "id": "312",
        "cn": "VSK-94",
        "code": "VSK",
        "icon": "Icon_VSK.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_VSK.png": {
                "cn": "VSK-94",
                "kr": "VSK-94",
                "jp": "VSK-94",
                "en": "VSK-94",
                "alt": "pic_VSK_D.png"
            },
            "pic_VSK_5301.png": {
                "cn": "VSK-94-圣夜警探",
                "icon": "Icon_VSK_5301.png",
                "alt": "pic_VSK_5301_D.png",
                "kr": "VSK-94 - 성야의 형사",
                "jp": "",
                "en": "Christmas Eve Detective"
            },
            "pic_VSK_5804.png": {
                "cn": "VSK-94-银湾流转夜",
                "icon": "Icon_VSK_5804.png",
                "alt": "pic_VSK_5804_D.png",
                "kr": "VSK-94 - 은하수 흐르는 밤에",
                "jp": "銀湾の流転する夜",
                "en": "Night on the Silver Bay"
            },
            "pic_VSK_7201.png": {
                "cn": "VSK-94-骄阳般起舞",
                "icon": "Icon_VSK_7201.png",
                "alt": "pic_VSK_7201_D.png",
                "kr": "VSK-94 - 햇님처럼 뛰놀기",
                "en": ""
            }
        },
        "kr": "VSK-94",
        "jp": "VSK-94",
        "en": "VSK-94"
    },
    "313": {
        "type": "AR",
        "id": "313",
        "cn": "S-ACR",
        "code": "SACR",
        "icon": "Icon_SACR.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_SACR.png": {
                "cn": "S-ACR",
                "kr": "S-ACR",
                "jp": "S-ACR",
                "en": "S-ACR",
                "alt": "pic_SACR_D.png"
            },
            "pic_SACR_5303.png": {
                "cn": "S-ACR-甜蜜许愿",
                "icon": "Icon_SACR_5303.png",
                "alt": "pic_SACR_5303_D.png",
                "kr": "S-ACR - 달콤한 소원",
                "jp": "",
                "en": "Make a Sweet Wish"
            },
            "pic_SACR_5903.png": {
                "cn": "S-ACR-追风魔女",
                "icon": "Icon_SACR_5903.png",
                "alt": "pic_SACR_5903_D.png",
                "kr": "S-ACR - 바람 쫓는 마녀",
                "jp": "",
                "en": "Wind-Chasing Witch"
            }
        },
        "kr": "S-ACR",
        "jp": "S-ACR",
        "en": "S-ACR"
    },
    "314": {
        "type": "AR",
        "id": "314",
        "cn": "StG-940",
        "code": "stg940",
        "icon": "Icon_stg940.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_stg940.png": {
                "cn": "StG-940",
                "kr": "StG-940",
                "jp": "StG-940",
                "en": "StG-940",
                "alt": "pic_stg940_D.png"
            }
        },
        "kr": "StG-940",
        "jp": "StG-940",
        "en": "StG-940"
    },
    "315": {
        "type": "SMG",
        "id": "315",
        "cn": "AUG SMG",
        "code": "AUGPARA",
        "icon": "Icon_AUGPARA.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_AUGPARA.png": {
                "cn": "AUG SMG",
                "kr": "AUG Para ",
                "jp": "AUG Para",
                "en": "AUG Para",
                "alt": "pic_AUGPARA_D.png"
            },
            "pic_AUGPARA_561.png": {
                "cn": "AUG SMG-十号小夜曲",
                "icon": "Icon_AUGPARA_561.png",
                "alt": "pic_AUGPARA_561_D.png",
                "kr": "AUG Para - 제10번 세레나데",
                "jp": "セレナーデ第10番",
                "en": "Serenade No.10"
            },
            "pic_AUGPARA_5503.png": {
                "cn": "AUG SMG-聚瑶芳",
                "icon": "Icon_AUGPARA_5503.png",
                "alt": "pic_AUGPARA_5503_D.png",
                "kr": "AUG Para - 보옥을 이끄는 향",
                "jp": "",
                "en": "Fragrant White Bouquet"
            },
            "pic_AUGPARA_6301.png": {
                "cn": "AUG SMG-溯溪踏秋时",
                "icon": "Icon_AUGPARA_6301.png",
                "alt": "pic_AUGPARA_6301_D.png",
                "kr": "AUG Para - 가을 계곡 소풍",
                "jp": ""
            }
        },
        "kr": "AUG Para ",
        "jp": "AUG Para",
        "en": "AUG Para"
    },
    "316": {
        "type": "RF",
        "id": "316",
        "cn": "刘氏步枪",
        "code": "GeneralLiu",
        "icon": "Icon_GeneralLiu.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_GeneralLiu.png": {
                "cn": "刘氏步枪",
                "kr": "류 소총",
                "jp": "劉氏歩槍",
                "en": "General Liu",
                "alt": "pic_GeneralLiu_D.png"
            },
            "pic_GeneralLiu_563.png": {
                "cn": "刘氏步枪-悠思之晨",
                "icon": "Icon_GeneralLiu_563.png",
                "alt": "pic_GeneralLiu_563_D.png",
                "kr": "류 소총 - 고민 많은 아침",
                "jp": "悠思の朝",
                "en": "GMusings in the Morn"
            },
            "pic_GeneralLiu_5101.png": {
                "cn": "刘氏步枪-垂枝梦狐影",
                "icon": "Icon_GeneralLiu_5101.png",
                "alt": "pic_GeneralLiu_5101_D.png",
                "kr": "류 소총 - 버드나무 여우불",
                "jp": "",
                "en": ""
            }
        },
        "kr": "류 소총",
        "jp": "劉氏歩槍",
        "en": "General Liu"
    },
    "317": {
        "type": "RF",
        "id": "317",
        "cn": "蒙德拉贡M1908",
        "code": "MondragonM1908",
        "icon": "Icon_MondragonM1908.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_MondragonM1908.png": {
                "cn": "蒙德拉贡M1908",
                "kr": "몬드라곤 M1908",
                "jp": "モンドラゴンM1908",
                "en": "Mondragon M1908",
                "alt": "pic_MondragonM1908_D.png"
            },
            "pic_MondragonM1908_5704.png": {
                "cn": "蒙德拉贡M1908-宿命的修护者",
                "icon": "Icon_MondragonM1908_5704.png",
                "alt": "pic_MondragonM1908_5704_D.png",
                "kr": "몬드라곤 M1908 - 숙명의 추적자",
                "jp": "宿命の修理人",
                "en": "Repairer of Destinies"
            },
            "pic_MondragonM1908_6304.png": {
                "cn": "蒙德拉贡M1908-残雨暝烟",
                "icon": "Icon_MondragonM1908_6304.png",
                "alt": "pic_MondragonM1908_6304_D.png",
                "kr": "몬드라곤 M1908 - 안개비 내리는 밤",
                "jp": ""
            }
        },
        "kr": "몬드라곤 M1908",
        "jp": "モンドラゴンM1908",
        "en": "Mondragon M1908"
    },
    "318": {
        "type": "AR",
        "id": "318",
        "cn": "VHS",
        "code": "VHS",
        "icon": "Icon_VHS.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_VHS.png": {
                "cn": "VHS",
                "kr": "VHS",
                "jp": "VHS",
                "en": "VHS",
                "alt": "pic_VHS_D.png"
            },
            "pic_VHS_562.png": {
                "cn": "VHS-谐谑天鹅湖",
                "icon": "Icon_VHS_562.png",
                "alt": "pic_VHS_562_D.png",
                "kr": "VHS - 익살극 백조의 호수",
                "jp": "滑稽な白鳥の湖",
                "en": "Swan Lake Scherzo"
            },
            "pic_VHS_5203.png": {
                "cn": "VHS-第八页守密人",
                "icon": "Icon_VHS_5203.png",
                "alt": "pic_VHS_5203_D.png",
                "kr": "VHS - 페이지 에이트 KP",
                "jp": "ページエイトの守護者",
                "en": "Keeper on Page 8"
            }
        },
        "kr": "VHS",
        "jp": "VHS",
        "en": "VHS"
    },
    "319": {
        "type": "MG",
        "id": "319",
        "cn": "PM1910",
        "code": "PM1910",
        "icon": "Icon_PM1910.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_PM1910.png": {
                "cn": "PM1910",
                "kr": "PM1910",
                "jp": "PM1910",
                "en": "PM1910",
                "alt": "pic_PM1910_D.png"
            },
            "pic_PM1910_5307.png": {
                "cn": "PM1910-女王的高塔派对",
                "icon": "Icon_PM1910_5307.png",
                "alt": "pic_PM1910_5307_D.png",
                "kr": "PM1910 - 여왕의 탑에서 축제",
                "jp": "",
                "en": "Party in the Queen's Tower"
            }
        },
        "kr": "PM1910",
        "jp": "PM1910",
        "en": "PM1910"
    },
    "320": {
        "type": "RF",
        "id": "320",
        "cn": "GM6 Lynx",
        "code": "Gm6Lynx",
        "icon": "Icon_Gm6Lynx.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_Gm6Lynx.png": {
                "cn": "GM6 Lynx",
                "kr": "GM6 Lynx",
                "jp": "GM6 Lynx",
                "en": "GM6 Lynx",
                "alt": "pic_Gm6Lynx_D.png"
            }
        },
        "kr": "GM6 Lynx",
        "jp": "GM6 Lynx",
        "en": "GM6 Lynx"
    },
    "321": {
        "type": "SG",
        "id": "321",
        "cn": "TS12",
        "code": "TavorTS12",
        "icon": "Icon_TavorTS12.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_TavorTS12.png": {
                "cn": "TS12",
                "kr": "TS12",
                "jp": "TS12",
                "en": "TS12",
                "alt": "pic_TavorTS12_D.png"
            },
            "pic_TavorTS12_7408.png": {
                "cn": "TS12-献给星河的花束",
                "icon": "Icon_TavorTS12_7408.png",
                "alt": "pic_TavorTS12_7408_D.png",
                "kr": "TS12 - 은하에 바치는 꽃다발",
                "en": "Bouquet for the Galaxy"
            }
        },
        "kr": "TS12",
        "jp": "TS12",
        "en": "TS12"
    },
    "322": {
        "type": "HG",
        "id": "322",
        "cn": "QSB-91",
        "code": "QSB91",
        "icon": "Icon_QSB91.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_QSB91.png": {
                "cn": "QSB-91",
                "kr": "QSB-91",
                "jp": "QSB-91",
                "en": "QSB-91",
                "alt": "pic_QSB91_D.png"
            },
            "pic_QSB91_6108.png": {
                "cn": "QSB-91-浮水薄荷茶",
                "icon": "Icon_QSB91_6108.png",
                "alt": "pic_QSB91_6108_D.png",
                "kr": "QSB-91 - 둥둥 박하차",
                "jp": "スイミング・ミントティー",
                "en": "Floating Mint Tea"
            }
        },
        "kr": "QSB-91",
        "jp": "QSB-91",
        "en": "QSB-91"
    },
    "323": {
        "type": "SG",
        "id": "323",
        "cn": "LTLX7000",
        "code": "LTLX7000",
        "icon": "Icon_LTLX7000.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_LTLX7000.png": {
                "cn": "LTLX7000",
                "kr": "LTLX7000",
                "jp": "LTLX7000",
                "en": "LTLX7000",
                "alt": "pic_LTLX7000_D.png"
            },
            "pic_LTLX7000_6101.png": {
                "cn": "LTLX7000-夜潮的邀约",
                "icon": "Icon_LTLX7000_6101.png",
                "alt": "pic_LTLX7000_6101_D.png",
                "kr": "LTLX7000 - 밀물 데이트",
                "jp": "夜潮のお誘い",
                "en": "Night-Tide Invitation"
            },
            "pic_LTLX7000_6702.png": {
                "cn": "LTLX7000-巫姬翩舞起",
                "icon": "Icon_LTLX7000_6702.png",
                "alt": "pic_LTLX7000_6702_D.png",
                "kr": "LTLX7000 - 하늘하늘 춤추는 무녀",
                "jp": "巫女舞ひらひらり",
                "en": ""
            }
        },
        "kr": "LTLX7000",
        "jp": "LTLX7000",
        "en": "LTLX7000"
    },
    "324": {
        "type": "SG",
        "id": "324",
        "cn": "M6 ASW",
        "code": "M6ASW",
        "icon": "Icon_M6ASW.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_M6ASW.png": {
                "cn": "M6 ASW",
                "kr": "M6 ASW",
                "jp": "M6 ASW",
                "en": "M6 ASW",
                "alt": "pic_M6ASW_D.png"
            },
            "pic_M6ASW_7301.png": {
                "cn": "M6 ASW-狂海求生",
                "icon": "Icon_M6ASW_7301.png",
                "alt": "pic_M6ASW_7301_D.png",
                "kr": "M6 ASW - 파도에서 살아남기",
                "en": ""
            }
        },
        "kr": "M6 ASW",
        "jp": "M6 ASW",
        "en": "M6 ASW"
    },
    "325": {
        "type": "SG",
        "id": "325",
        "cn": "V-PM5",
        "code": "VPM5",
        "icon": "Icon_VPM5.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_VPM5.png": {
                "cn": "V-PM5",
                "kr": "V-PM5",
                "jp": "PM5",
                "en": "PM5",
                "alt": "pic_VPM5_D.png"
            },
            "pic_VPM5_6107.png": {
                "cn": "V-PM5-飞翔海星",
                "icon": "Icon_VPM5_6107.png",
                "alt": "pic_VPM5_6107_D.png",
                "kr": "V-PM5 - 날아라 불가사리",
                "jp": "天翔けるヒトデ",
                "en": "Soaring Starfish"
            },
            "pic_VPM5_6706.png": {
                "cn": "V-PM5-初梦见飞羽",
                "icon": "Icon_VPM5_6706.png",
                "alt": "pic_VPM5_6706_D.png",
                "kr": "V-PM5 - 첫 꿈은 제기치기",
                "jp": "風切羽を夢む元旦",
                "en": ""
            }
        },
        "kr": "V-PM5",
        "jp": "PM5",
        "en": "PM5"
    },
    "326": {
        "type": "SG",
        "id": "326",
        "cn": "HK512",
        "code": "HK512",
        "icon": "Icon_HK512.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_HK512.png": {
                "cn": "HK512",
                "kr": "HK512",
                "jp": "512",
                "en": "512",
                "alt": "pic_HK512_D.png"
            }
        },
        "kr": "HK512",
        "jp": "512",
        "en": "512"
    },
    "327": {
        "type": "SMG",
        "id": "327",
        "cn": "SUB-2000",
        "code": "SUB2000",
        "icon": "Icon_SUB2000.png",
        "modded": false,
        "rarity": 3,
        "skins": {
            "pic_SUB2000.png": {
                "cn": "SUB-2000",
                "kr": "SUB-2000",
                "jp": "SUB-2000",
                "en": "SUB-2000",
                "alt": "pic_SUB2000_D.png"
            }
        },
        "kr": "SUB-2000",
        "jp": "SUB-2000",
        "en": "SUB-2000"
    },
    "328": {
        "type": "SMG",
        "id": "328",
        "cn": "AR-57",
        "code": "AR57",
        "icon": "Icon_AR57.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_AR57.png": {
                "cn": "AR-57",
                "kr": "AR-57",
                "jp": "AR-57",
                "en": "AR-57",
                "alt": "pic_AR57_D.png"
            },
            "pic_AR57_6705.png": {
                "cn": "AR-57-三友伴岁寒",
                "icon": "Icon_AR57_6705.png",
                "alt": "pic_AR57_6705_D.png",
                "kr": "AR-57 - 눈속에도 푸르게",
                "jp": "三友歳寒に相伴す",
                "en": ""
            }
        },
        "kr": "AR-57",
        "jp": "AR-57",
        "en": "AR-57"
    },
    "329": {
        "type": "RF",
        "id": "329",
        "cn": "SVCh",
        "code": "SVCh",
        "icon": "Icon_SVCh.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_SVCh.png": {
                "cn": "SVCh",
                "kr": "SVCh",
                "jp": "SVCh",
                "en": "SVCh",
                "alt": "pic_SVCh_D.png"
            },
            "pic_SVCh_6402.png": {
                "cn": "SVCh-猩红夜猎手",
                "icon": "Icon_SVCh_6402.png",
                "alt": "pic_SVCh_6402_D.png",
                "kr": "SVCh - 스칼렛 나이트 헌터",
                "jp": "紅夜のハンター",
                "en": "Scarlet Night Huntress"
            }
        },
        "kr": "SVCh",
        "jp": "SVCh",
        "en": "SVCh"
    },
    "330": {
        "type": "AR",
        "id": "330",
        "cn": "FX-05",
        "code": "FX05",
        "icon": "Icon_FX05.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_FX05.png": {
                "cn": "FX-05",
                "kr": "FX-05",
                "jp": "FX-05",
                "en": "FX-05",
                "alt": "pic_FX05_D.png"
            },
            "pic_FX05_5806.png": {
                "cn": "FX-05-她从雨中来",
                "icon": "Icon_FX05_5806.png",
                "alt": "pic_FX05_5806_D.png",
                "kr": "FX-05 -비를 맞으며",
                "jp": "雨降りの来訪者",
                "en": "She Walks in the Rain"
            },
            "pic_FX05_7002.png": {
                "cn": "FX-05-飞向云端",
                "icon": "Icon_FX05_7002.png",
                "alt": "pic_FX05_7002_D.png",
                "kr": "FX-05 - 구름을 향해서",
                "jp": "雲の彼方へ",
                "en": "Soaring to the Clouds"
            }
        },
        "kr": "FX-05",
        "jp": "FX-05",
        "en": "FX-05"
    },
    "331": {
        "type": "HG",
        "id": "331",
        "cn": "蜂鸟",
        "code": "Kolibri",
        "icon": "Icon_Kolibri.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_Kolibri.png": {
                "cn": "蜂鸟",
                "kr": "콜리브리",
                "jp": "コリブリ",
                "en": "Kolibri",
                "alt": "pic_Kolibri_D.png"
            },
            "pic_Kolibri_6802.png": {
                "cn": "蜂鸟-夕颜展",
                "icon": "Icon_Kolibri_6802.png",
                "alt": "pic_Kolibri_6802_D.png",
                "kr": "콜리브리 - 나팔꽃 납시오",
                "jp": "夕顔展",
                "en": ""
            }
        },
        "kr": "콜리브리",
        "jp": "コリブリ",
        "en": "Kolibri"
    },
    "332": {
        "type": "HG",
        "id": "332",
        "cn": "德林加",
        "code": "Derringer",
        "icon": "Icon_Derringer.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_Derringer.png": {
                "cn": "德林加",
                "kr": "데린저",
                "jp": "デリンジャー",
                "en": "Derringer",
                "alt": "pic_Derringer_D.png"
            }
        },
        "kr": "데린저",
        "jp": "デリンジャー",
        "en": "Derringer"
    },
    "333": {
        "type": "SMG",
        "id": "333",
        "cn": "VP1915",
        "code": "VP1915",
        "icon": "Icon_VP1915.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_VP1915.png": {
                "cn": "VP1915",
                "kr": "VP1915",
                "jp": "VP1915",
                "en": "VP1915",
                "alt": "pic_VP1915_D.png"
            },
            "pic_VP1915_6604.png": {
                "cn": "VP1915-与帕罗莎同座",
                "icon": "Icon_VP1915_6604.png",
                "alt": "pic_VP1915_6604_D.png",
                "kr": "VP1915 - 페로사와 한자리",
                "jp": "ペロサの隣に",
                "en": ""
            }
        },
        "kr": "VP1915",
        "jp": "VP1915",
        "en": "VP1915"
    },
    "334": {
        "type": "RF",
        "id": "334",
        "cn": "沙维奇99型",
        "code": "Savage99",
        "icon": "Icon_Savage99.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_Savage99.png": {
                "cn": "沙维奇99型",
                "kr": "Savage 99",
                "jp": "Model 99",
                "en": "Model 99",
                "alt": "pic_Savage99_D.png"
            },
            "pic_Savage99_7302.png": {
                "cn": "沙维奇99型-沙维奇想整点薯条",
                "icon": "Icon_Savage99_7302.png",
                "alt": "pic_Savage99_7302_D.png",
                "kr": "Savage 99 - 감자 스틱 먹을래",
                "en": ""
            }
        },
        "kr": "Savage 99",
        "jp": "Model 99",
        "en": "Model 99"
    },
    "335": {
        "type": "AR",
        "id": "335",
        "cn": "菲德洛夫",
        "code": "Fedorov",
        "icon": "Icon_Fedorov.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_Fedorov.png": {
                "cn": "菲德洛夫",
                "kr": "표도로프",
                "jp": "フェドロフ",
                "en": "Fedorov Avtomat",
                "alt": "pic_Fedorov_D.png"
            }
        },
        "kr": "표도로프",
        "jp": "フェドロフ",
        "en": "Fedorov Avtomat"
    },
    "336": {
        "type": "SMG",
        "id": "336",
        "cn": "PPD-40",
        "code": "PPD40",
        "icon": "Icon_PPD40.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_PPD40.png": {
                "cn": "PPD-40",
                "kr": "PPD-40",
                "jp": "PPD-40",
                "en": "PPD-40",
                "alt": "pic_PPD40_D.png"
            },
            "pic_PPD40_6105.png": {
                "cn": "PPD-40-樱桃色珊瑚",
                "icon": "Icon_PPD40_6105.png",
                "alt": "pic_PPD40_6105_D.png",
                "kr": "PPD-40 - 분홍색 산호초",
                "jp": "桃色珊瑚",
                "en": "Pink Coral"
            }
        },
        "kr": "PPD-40",
        "jp": "PPD-40",
        "en": "PPD-40"
    },
    "337": {
        "type": "RF",
        "id": "337",
        "cn": "德利尔",
        "code": "Delisle",
        "icon": "Icon_Delisle.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_Delisle.png": {
                "cn": "德利尔",
                "kr": "드 라일",
                "jp": "デ・リーズル",
                "en": "De Lisle",
                "alt": "pic_Delisle_D.png"
            },
            "pic_Delisle_6202.png": {
                "cn": "德利尔-郊狼蓝调",
                "icon": "Icon_Delisle_6202.png",
                "alt": "pic_Delisle_6202_D.png",
                "kr": "드 라일 - 코요테 블루스",
                "jp": "コヨーテ・ブルース",
                "en": "Coyote Blues"
            }
        },
        "kr": "드 라일",
        "jp": "デ・リーズル",
        "en": "De Lisle"
    },
    "338": {
        "type": "AR",
        "id": "338",
        "cn": "SIG MCX",
        "code": "SIGMCX",
        "icon": "Icon_SIGMCX.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_SIGMCX.png": {
                "cn": "SIG MCX",
                "kr": "SIG MCX",
                "jp": "SIG MCX",
                "en": "SIG MCX",
                "alt": "pic_SIGMCX_D.png"
            },
            "pic_SIGMCX_6502.png": {
                "cn": "SIG MCX-真红陨星",
                "icon": "Icon_SIGMCX_6502.png",
                "alt": "pic_SIGMCX_6502_D.png",
                "kr": "SIG MCX - 스칼렛 메테오",
                "jp": "深紅の隕石",
                "en": ""
            },
            "pic_SIGMCX_7404.png": {
                "cn": "SIG MCX-超时空警备队",
                "icon": "Icon_SIGMCX_7404.png",
                "alt": "pic_SIGMCX_7404_D.png",
                "kr": "SIG MCX - 초시공 경비대",
                "en": "Trans-Dimensional Sentinel"
            }
        },
        "kr": "SIG MCX",
        "jp": "SIG MCX",
        "en": "SIG MCX"
    },
    "339": {
        "type": "MG",
        "id": "339",
        "cn": "RPK-203",
        "code": "RPK203",
        "icon": "Icon_RPK203.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_RPK203.png": {
                "cn": "RPK-203",
                "kr": "RPK-203",
                "jp": "RPK-203",
                "en": "RPK-203",
                "alt": "pic_RPK203_D.png"
            },
            "pic_RPK203_5901.png": {
                "cn": "RPK-203-小小志愿者",
                "icon": "Icon_RPK203_5901.png",
                "alt": "pic_RPK203_5901_D.png",
                "kr": "RPK-203 - 꼬마 자원봉사자",
                "jp": "",
                "en": "Little Volunteer"
            }
        },
        "kr": "RPK-203",
        "jp": "RPK-203",
        "en": "RPK-203"
    },
    "340": {
        "type": "AR",
        "id": "340",
        "cn": "TKB-408",
        "code": "TKB408",
        "icon": "Icon_TKB408.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_TKB408.png": {
                "cn": "TKB-408",
                "kr": "TKB-408",
                "jp": "TKB-408",
                "en": "TKB-408",
                "alt": "pic_TKB408_D.png"
            },
            "pic_TKB408_6804.png": {
                "cn": "TKB-408-朱砂舞",
                "icon": "Icon_TKB408_6804.png",
                "alt": "pic_TKB408_6804_D.png",
                "kr": "TKB-408 - 춤추는 모란",
                "jp": "朱砂舞",
                "en": ""
            }
        },
        "kr": "TKB-408",
        "jp": "TKB-408",
        "en": "TKB-408"
    },
    "341": {
        "type": "SMG",
        "id": "341",
        "cn": "SP9",
        "code": "SP9",
        "icon": "Icon_SP9.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_SP9.png": {
                "cn": "SP9",
                "kr": "SP9",
                "jp": "SP9",
                "en": "",
                "alt": "pic_SP9_D.png"
            },
            "pic_SP9_6303.png": {
                "cn": "SP9-星河中沉睡的梦",
                "icon": "Icon_SP9_6303.png",
                "alt": "pic_SP9_6303_D.png",
                "kr": "SP9 - 은하수에 잠든 꿈",
                "jp": ""
            },
            "pic_SP9_6801.png": {
                "cn": "SP9-寒兰傲",
                "icon": "Icon_SP9_6801.png",
                "alt": "pic_SP9_6801_D.png",
                "kr": "SP9 - 고고한 한란",
                "jp": "寒蘭傲",
                "en": ""
            }
        },
        "kr": "SP9",
        "jp": "SP9",
        "en": ""
    },
    "342": {
        "type": "AR",
        "id": "342",
        "cn": "KH2002",
        "code": "KH2002",
        "icon": "Icon_KH2002.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_KH2002.png": {
                "cn": "KH2002",
                "kr": "KH2002",
                "jp": "KH2002",
                "en": "",
                "alt": "pic_KH2002_D.png"
            }
        },
        "kr": "KH2002",
        "jp": "KH2002",
        "en": ""
    },
    "343": {
        "type": "AR",
        "id": "343",
        "cn": "APC556",
        "code": "APC556",
        "icon": "Icon_APC556.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_APC556.png": {
                "cn": "APC556",
                "kr": "APC556",
                "jp": "APC556",
                "en": "",
                "alt": "pic_APC556_D.png"
            }
        },
        "kr": "APC556",
        "jp": "APC556",
        "en": ""
    },
    "344": {
        "type": "AR",
        "id": "344",
        "cn": "FARA 83",
        "code": "FARA83",
        "icon": "Icon_FARA83.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_FARA83.png": {
                "cn": "FARA 83",
                "kr": "FARA 83",
                "jp": "FARA 83",
                "en": "",
                "alt": "pic_FARA83_D.png"
            }
        },
        "kr": "FARA 83",
        "jp": "FARA 83",
        "en": ""
    },
    "345": {
        "type": "MG",
        "id": "345",
        "cn": "MG338",
        "code": "MG338",
        "icon": "Icon_MG338.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_MG338.png": {
                "cn": "MG338",
                "kr": "MG338",
                "jp": "MG338",
                "en": "",
                "alt": "pic_MG338_D.png"
            }
        },
        "kr": "MG338",
        "jp": "MG338",
        "en": ""
    },
    "346": {
        "type": "HG",
        "id": "346",
        "cn": "CZ 100",
        "code": "CZ100",
        "icon": "Icon_CZ100.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_CZ100.png": {
                "cn": "CZ 100",
                "kr": "CZ 100",
                "jp": "CZ100",
                "en": "CZ100",
                "alt": "pic_CZ100_D.png"
            }
        },
        "kr": "CZ 100",
        "jp": "CZ100",
        "en": "CZ100"
    },
    "347": {
        "type": "SMG",
        "id": "347",
        "cn": "SR-2",
        "code": "SR2",
        "icon": "Icon_SR2.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_SR2.png": {
                "cn": "SR-2",
                "kr": "SR-2",
                "jp": "SR2",
                "en": "SR2",
                "alt": "pic_SR2_D.png"
            }
        },
        "kr": "SR-2",
        "jp": "SR2",
        "en": "SR2"
    },
    "348": {
        "type": "RF",
        "id": "348",
        "cn": "HS.50",
        "code": "HS50",
        "icon": "Icon_HS50.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_HS50.png": {
                "cn": "HS.50",
                "kr": "HS.50",
                "jp": "HS.50",
                "en": "HS.50",
                "alt": "pic_HS50_D.png"
            },
            "pic_HS50_6805.png": {
                "cn": "HS.50-矶松叹",
                "icon": "Icon_HS50_6805.png",
                "alt": "pic_HS50_6805_D.png",
                "kr": "HS.50 - 여울가 소나무",
                "jp": "磯松嘆",
                "en": ""
            },
            "pic_HS50_7304.png": {
                "cn": "HS.50-游向蜜色海心",
                "icon": "Icon_HS50_7304.png",
                "alt": "pic_HS50_7304_D.png",
                "kr": "HS.50 - 노을 진 바다로",
                "en": ""
            }
        },
        "kr": "HS.50",
        "jp": "HS.50",
        "en": "HS.50"
    },
    "349": {
        "type": "AR",
        "id": "349",
        "cn": "AK74M",
        "code": "AK74M",
        "icon": "Icon_AK74M.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_AK74M.png": {
                "cn": "AK74M",
                "kr": "AK74M",
                "jp": "AK74M",
                "en": "AK74M",
                "alt": "pic_AK74M_D.png"
            },
            "pic_AK74M_7305.png": {
                "cn": "AK74M-戟与鱼脍师",
                "icon": "Icon_AK74M_7305.png",
                "alt": "pic_AK74M_7305_D.png",
                "kr": "AK74M - 회극의 스피릿",
                "en": ""
            }
        },
        "kr": "AK74M",
        "jp": "AK74M",
        "en": "AK74M"
    },
    "350": {
        "type": "SG",
        "id": "350",
        "cn": "FO-12",
        "code": "FO12",
        "icon": "Icon_FO12.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_FO12.png": {
                "cn": "FO-12",
                "kr": "FO-12",
                "jp": "FO-12",
                "en": "FO-12",
                "alt": "pic_FO12_D.png"
            }
        },
        "kr": "FO-12",
        "jp": "FO-12",
        "en": "FO-12"
    },
    "351": {
        "type": "SG",
        "id": "351",
        "cn": "M26-MASS",
        "code": "M26MASS",
        "icon": "Icon_M26MASS.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_M26MASS.png": {
                "cn": "M26-MASS",
                "kr": "M26-MASS",
                "jp": "M26-MASS",
                "en": "M26-MASS",
                "alt": "pic_M26MASS_D.png"
            }
        },
        "kr": "M26-MASS",
        "jp": "M26-MASS",
        "en": "M26-MASS"
    },
    "352": {
        "type": "SG",
        "id": "352",
        "cn": "新星",
        "code": "Nova",
        "icon": "Icon_Nova.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_Nova.png": {
                "cn": "新星",
                "kr": "노바",
                "jp": "Nova",
                "en": "Nova",
                "alt": "pic_Nova_D.png"
            }
        },
        "kr": "노바",
        "jp": "Nova",
        "en": "Nova"
    },
    "353": {
        "type": "SG",
        "id": "353",
        "cn": "MAG-7",
        "code": "MAG7",
        "icon": "Icon_MAG7.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_MAG7.png": {
                "cn": "MAG-7",
                "kr": "MAG-7",
                "jp": "MAG-7",
                "en": "MAG-7",
                "alt": "pic_MAG7_D.png"
            }
        },
        "kr": "MAG-7",
        "jp": "MAG-7",
        "en": "MAG-7"
    },
    "354": {
        "type": "HG",
        "id": "354",
        "cn": "ZiP .22",
        "code": "ZIP22",
        "icon": "Icon_ZIP22.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_ZIP22.png": {
                "cn": "ZiP .22",
                "kr": "ZiP .22",
                "jp": "ZiP .22",
                "en": "ZiP .22",
                "alt": "pic_ZIP22_D.png"
            }
        },
        "kr": "ZiP .22",
        "jp": "ZiP .22",
        "en": "ZiP .22"
    },
    "355": {
        "type": "SMG",
        "id": "355",
        "cn": "维涅龙M2",
        "code": "VigneronM2",
        "icon": "Icon_VigneronM2.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_VigneronM2.png": {
                "cn": "维涅龙M2",
                "kr": "비뉴홍 M2",
                "jp": "ビグネロン M2",
                "en": "Vigneron M2",
                "alt": "pic_VigneronM2_D.png"
            }
        },
        "kr": "비뉴홍 M2",
        "jp": "ビグネロン M2",
        "en": "Vigneron M2"
    },
    "356": {
        "type": "AR",
        "id": "356",
        "cn": "A-545",
        "code": "A545",
        "icon": "Icon_A545.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_A545.png": {
                "cn": "A-545",
                "kr": "A-545",
                "jp": "A-545",
                "en": "A-545",
                "alt": "pic_A545_D.png"
            },
            "pic_A545_6803.png": {
                "cn": "A-545-醉茗咲",
                "icon": "Icon_A545_6803.png",
                "alt": "pic_A545_6803_D.png",
                "kr": "A-545 - 뺨에 붉은 꽃",
                "jp": "酔茗咲",
                "en": ""
            }
        },
        "kr": "A-545",
        "jp": "A-545",
        "en": "A-545"
    },
    "357": {
        "type": "HG",
        "id": "357",
        "cn": "芮诺",
        "code": "Rhino",
        "icon": "Icon_Rhino.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_Rhino.png": {
                "cn": "芮诺",
                "kr": "라이노",
                "en": "",
                "alt": "pic_Rhino_D.png"
            },
            "pic_Rhino_7103.png": {
                "cn": "芮诺-孤月之冠",
                "icon": "Icon_Rhino_7103.png",
                "alt": "pic_Rhino_7103_D.png",
                "kr": "라이노 - 고독한 달의 관",
                "en": ""
            }
        },
        "kr": "라이노",
        "en": ""
    },
    "358": {
        "type": "HG",
        "id": "358",
        "cn": "PPQ",
        "code": "PPQ",
        "icon": "Icon_PPQ.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_PPQ.png": {
                "cn": "PPQ",
                "kr": "PPQ",
                "en": "",
                "alt": "pic_PPQ_D.png"
            }
        },
        "kr": "PPQ",
        "en": ""
    },
    "359": {
        "type": "SMG",
        "id": "359",
        "cn": "斯特林",
        "code": "Sterling",
        "icon": "Icon_Sterling.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_Sterling.png": {
                "cn": "斯特林",
                "kr": "스털링",
                "en": "",
                "alt": "pic_Sterling_D.png"
            },
            "pic_Sterling_7303.png": {
                "cn": "斯特林-在热夏融化",
                "icon": "Icon_Sterling_7303.png",
                "alt": "pic_Sterling_7303_D.png",
                "kr": "스털링 - 더위에 녹는다",
                "en": ""
            }
        },
        "kr": "스털링",
        "en": ""
    },
    "360": {
        "type": "RF",
        "id": "360",
        "cn": "TF-Q",
        "code": "TFQ",
        "icon": "Icon_TFQ.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_TFQ.png": {
                "cn": "TF-Q",
                "kr": "TF-Q",
                "en": "",
                "alt": "pic_TFQ_D.png"
            }
        },
        "kr": "TF-Q",
        "en": ""
    },
    "361": {
        "type": "AR",
        "id": "361",
        "cn": "QBZ-191",
        "code": "QBZ191",
        "icon": "Icon_QBZ191.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_QBZ191.png": {
                "cn": "QBZ-191",
                "kr": "QBZ-191",
                "en": "",
                "alt": "pic_QBZ191_D.png"
            }
        },
        "kr": "QBZ-191",
        "en": ""
    },
    "362": {
        "type": "MG",
        "id": "362",
        "cn": "LS26",
        "code": "LS26",
        "icon": "Icon_LS26.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_LS26.png": {
                "cn": "LS26",
                "kr": "LS26",
                "en": "",
                "alt": "pic_LS26_D.png"
            }
        },
        "kr": "LS26",
        "en": ""
    },
    "363": {
        "type": "SMG",
        "id": "363",
        "cn": "MPL",
        "code": "MPL",
        "icon": "Icon_MPL.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_MPL.png": {
                "cn": "MPL",
                "kr": "MPL",
                "en": "",
                "alt": "pic_MPL_D.png"
            }
        },
        "kr": "MPL",
        "en": ""
    },
    "364": {
        "type": "SMG",
        "id": "364",
        "cn": "MPK",
        "code": "MPK",
        "icon": "Icon_MPK.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_MPK.png": {
                "cn": "MPK",
                "kr": "MPK",
                "en": "",
                "alt": "pic_MPK_D.png"
            }
        },
        "kr": "MPK",
        "en": ""
    },
    "365": {
        "type": "AR",
        "id": "365",
        "cn": "SCR",
        "code": "SCR",
        "icon": "Icon_SCR.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_SCR.png": {
                "cn": "SCR",
                "kr": "SCR",
                "en": "SCR",
                "alt": "pic_SCR_D.png"
            },
            "pic_SCR_7402.png": {
                "cn": "SCR-诗农畅想曲",
                "icon": "Icon_SCR_7402.png",
                "alt": "pic_SCR_7402_D.png",
                "kr": "SCR - 팜 랩소디",
                "en": "Capriccio of the Pastoral Poet"
            }
        },
        "kr": "SCR",
        "en": "SCR"
    },
    "366": {
        "type": "SG",
        "id": "366",
        "cn": "SPAS-15",
        "code": "SPAS15",
        "icon": "Icon_SPAS15.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_SPAS15.png": {
                "cn": "SPAS-15",
                "kr": "SPAS-15",
                "jp": "",
                "en": "",
                "alt": "pic_SPAS15_D.png"
            }
        },
        "kr": "SPAS-15",
        "jp": "",
        "en": ""
    },
    "367": {
        "type": "SG",
        "id": "367",
        "cn": "MK3A1",
        "code": "MK3A1",
        "icon": "Icon_MK3A1.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_MK3A1.png": {
                "cn": "MK3A1",
                "kr": "MK3A1",
                "jp": "",
                "en": "",
                "alt": "pic_MK3A1_D.png"
            }
        },
        "kr": "MK3A1",
        "jp": "",
        "en": ""
    },
    "368": {
        "type": "SG",
        "id": "368",
        "cn": "UTS-15",
        "code": "UTS15",
        "icon": "Icon_UTS15.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_UTS15.png": {
                "cn": "UTS-15",
                "kr": "UTS-15",
                "jp": "",
                "en": "",
                "alt": "pic_UTS15_D.png"
            }
        },
        "kr": "UTS-15",
        "jp": "",
        "en": ""
    },
    "369": {
        "type": "HG",
        "id": "369",
        "cn": "M327",
        "code": "M327",
        "icon": "Icon_M327.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_M327.png": {
                "cn": "M327",
                "alt": "pic_M327_D.png"
            }
        }
    },
    "370": {
        "type": "HG",
        "id": "370",
        "cn": "P290",
        "code": "P290",
        "icon": "Icon_P290.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_P290.png": {
                "cn": "P290",
                "alt": "pic_P290_D.png"
            }
        }
    },
    "371": {
        "type": "RF",
        "id": "371",
        "cn": "Saiga 308",
        "code": "Saiga308",
        "icon": "Icon_Saiga308.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_Saiga308.png": {
                "cn": "Saiga 308",
                "alt": "pic_Saiga308_D.png"
            }
        }
    },
    "372": {
        "type": "AR",
        "id": "372",
        "cn": "AR-18",
        "code": "AR18",
        "icon": "Icon_AR18.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_AR18.png": {
                "cn": "AR-18",
                "alt": "pic_AR18_D.png"
            }
        }
    },
    "373": {
        "type": "AR",
        "id": "373",
        "cn": "CMR-30",
        "code": "CMR30",
        "icon": "Icon_CMR30.png",
        "modded": false,
        "rarity": 4,
        "skins": {
            "pic_CMR30.png": {
                "cn": "CMR-30",
                "alt": "pic_CMR30_D.png"
            }
        }
    },
    "374": {
        "type": "MG",
        "id": "374",
        "cn": "M240L",
        "code": "M240L",
        "icon": "Icon_M240L.png",
        "modded": false,
        "rarity": 5,
        "skins": {
            "pic_M240L.png": {
                "cn": "M240L",
                "alt": "pic_M240L_D.png"
            }
        }
    },
    "1001": {
        "type": "HG",
        "id": "1001",
        "cn": "诺爱尔",
        "code": "BB_Noel",
        "icon": "Icon_BB_Noel.png",
        "modded": false,
        "rarity": 1,
        "skins": {
            "pic_BB_Noel.png": {
                "cn": "诺爱尔",
                "kr": "노엘",
                "jp": "ノエル",
                "en": "Noel",
                "alt": "pic_BB_Noel_D.png"
            },
            "pic_BB_Noel_503.png": {
                "cn": "诺爱尔-μ-12",
                "icon": "Icon_BB_Noel_503.png",
                "alt": "pic_BB_Noel_503_D.png",
                "kr": "노엘 - μ-12",
                "jp": "μ-12",
                "en": "μ-12"
            }
        },
        "kr": "노엘",
        "jp": "ノエル",
        "en": "Noel"
    },
    "1002": {
        "type": "SG",
        "id": "1002",
        "cn": "艾尔菲尔特",
        "code": "GG_elfeldt",
        "icon": "Icon_GG_elfeldt.png",
        "modded": false,
        "rarity": 1,
        "skins": {
            "pic_GG_elfeldt.png": {
                "cn": "艾尔菲尔特",
                "kr": "엘펠트",
                "jp": "エルフェルト",
                "en": "Elphelt",
                "alt": "pic_GG_elfeldt_D.png"
            },
            "pic_GG_elfeldt_504.png": {
                "cn": "艾尔菲尔特-马格南婚礼",
                "icon": "Icon_GG_elfeldt_504.png",
                "alt": "pic_GG_elfeldt_504_D.png",
                "kr": "엘펠트 - 매그넘 웨딩",
                "jp": "マグナムウェディング",
                "en": "Magnum Wedding"
            },
            "pic_GG_elfeldt_505.png": {
                "cn": "艾尔菲尔特-人偶歼灭者",
                "icon": "Icon_GG_elfeldt_505.png",
                "alt": "pic_GG_elfeldt_505_D.png",
                "kr": "엘펠트 - 인형 섬멸자",
                "jp": "アナイアレイター",
                "en": "Doll Annihilator"
            }
        },
        "kr": "엘펠트",
        "jp": "エルフェルト",
        "en": "Elphelt"
    },
    "1003": {
        "type": "HG",
        "id": "1003",
        "cn": "琪亚娜",
        "code": "Kiana",
        "icon": "Icon_Kiana.png",
        "modded": false,
        "rarity": 1,
        "skins": {
            "pic_Kiana.png": {
                "cn": "琪亚娜",
                "kr": "키아나",
                "jp": "キアナ",
                "en": "Kiana",
                "alt": "pic_Kiana_D.png"
            },
            "pic_Kiana_506.png": {
                "cn": "琪亚娜-琪亚娜的礼装",
                "icon": "Icon_Kiana_506.png",
                "alt": "pic_Kiana_506_D.png",
                "kr": "키아나 - 키아나의 예복",
                "jp": "キアナの礼装",
                "en": "Kiana's Dress"
            }
        },
        "kr": "키아나",
        "jp": "キアナ",
        "en": "Kiana"
    },
    "1004": {
        "type": "RF",
        "id": "1004",
        "cn": "雷电芽衣",
        "code": "RaidenMei",
        "icon": "Icon_RaidenMei.png",
        "modded": false,
        "rarity": 1,
        "skins": {
            "pic_RaidenMei.png": {
                "cn": "雷电芽衣",
                "kr": "라이덴 메이",
                "jp": "雷電 芽衣",
                "en": "Mei",
                "alt": "pic_RaidenMei_D.png"
            }
        },
        "kr": "라이덴 메이",
        "jp": "雷電 芽衣",
        "en": "Mei"
    },
    "1005": {
        "type": "RF",
        "id": "1005",
        "cn": "布洛妮娅",
        "code": "Bronya",
        "icon": "Icon_Bronya.png",
        "modded": false,
        "rarity": 1,
        "skins": {
            "pic_Bronya.png": {
                "cn": "布洛妮娅",
                "kr": "브로냐",
                "jp": "ブローニャ",
                "en": "Bronya",
                "alt": "pic_Bronya_D.png"
            },
            "pic_Bronya_507.png": {
                "cn": "布洛妮娅-布洛妮娅的装甲",
                "icon": "Icon_Bronya_507.png",
                "alt": "pic_Bronya_507_D.png",
                "kr": "브로냐 - 브로냐의 장갑",
                "jp": "ブローニャの装甲",
                "en": "Bronya's Armor"
            }
        },
        "kr": "브로냐",
        "jp": "ブローニャ",
        "en": "Bronya"
    },
    "1006": {
        "type": "HG",
        "id": "1006",
        "cn": "德丽莎",
        "code": "Theresa",
        "icon": "Icon_Theresa.png",
        "modded": false,
        "rarity": 1,
        "skins": {
            "pic_Theresa.png": {
                "cn": "德丽莎",
                "kr": "테레사",
                "jp": "テレサ",
                "en": "Theresa",
                "alt": "pic_Theresa_D.png"
            }
        },
        "kr": "테레사",
        "jp": "テレサ",
        "en": "Theresa"
    },
    "1007": {
        "type": "AR",
        "id": "1007",
        "cn": "无量塔姬子",
        "code": "Himeko",
        "icon": "Icon_Himeko.png",
        "modded": false,
        "rarity": 1,
        "skins": {
            "pic_Himeko.png": {
                "cn": "无量塔姬子",
                "kr": "무라타 히메코",
                "jp": "無量塔 姫子",
                "en": "Himeko",
                "alt": "pic_Himeko_D.png"
            }
        },
        "kr": "무라타 히메코",
        "jp": "無量塔 姫子",
        "en": "Himeko"
    },
    "1008": {
        "type": "SG",
        "id": "1008",
        "cn": "希儿",
        "code": "Seele",
        "icon": "Icon_Seele.png",
        "modded": false,
        "rarity": 1,
        "skins": {
            "pic_Seele.png": {
                "cn": "希儿",
                "kr": "제레",
                "jp": "ゼーレ",
                "en": "Seele",
                "alt": "pic_Seele_D.png"
            },
            "pic_Seele_508.png": {
                "cn": "希儿-希儿的祭礼",
                "icon": "Icon_Seele_508.png",
                "alt": "pic_Seele_508_D.png",
                "kr": "제레 - 제레의 의식",
                "jp": "ゼーレ-ゼーレの祭礼",
                "en": "Seele's Ceremony"
            }
        },
        "kr": "제레",
        "jp": "ゼーレ",
        "en": "Seele"
    },
    "1009": {
        "type": "HG",
        "id": "1009",
        "cn": "克莉尔",
        "code": "CLEAR",
        "icon": "Icon_CLEAR.png",
        "modded": false,
        "rarity": 1,
        "skins": {
            "pic_CLEAR.png": {
                "cn": "克莉尔",
                "kr": "클리어",
                "jp": "エル・クレア",
                "en": "El Clear",
                "alt": "pic_CLEAR_D.png"
            },
            "pic_CLEAR_509.png": {
                "cn": "克莉尔-口袋城女王二世",
                "icon": "Icon_CLEAR_509.png",
                "alt": "pic_CLEAR_509_D.png",
                "kr": "클리어 - 포터블 여왕 2세",
                "jp": "ポケットシティ女王二世",
                "en": "Pocket City Queen the Second"
            }
        },
        "kr": "클리어",
        "jp": "エル・クレア",
        "en": "El Clear"
    },
    "1010": {
        "type": "HG",
        "id": "1010",
        "cn": "菲尔",
        "code": "FAIL",
        "icon": "Icon_FAIL.png",
        "modded": false,
        "rarity": 1,
        "skins": {
            "pic_FAIL.png": {
                "cn": "菲尔",
                "kr": "페일",
                "jp": "エル・フェイル",
                "en": "El Fail",
                "alt": "pic_FAIL_D.png"
            },
            "pic_FAIL_510.png": {
                "cn": "菲尔-口袋城女王三世",
                "icon": "Icon_FAIL_510.png",
                "alt": "pic_FAIL_510_D.png",
                "kr": "페일 - 포터블 여왕 3세",
                "jp": "ポケットシティ女王三世",
                "en": "Pocket City Queen the Third"
            }
        },
        "kr": "페일",
        "jp": "エル・フェイル",
        "en": "El Fail"
    },
    "1017": {
        "type": "HG",
        "id": "1017",
        "cn": "吉尔·斯汀雷",
        "code": "Jill",
        "icon": "Icon_Jill.png",
        "modded": false,
        "rarity": 1,
        "skins": {
            "pic_Jill.png": {
                "cn": "吉尔·斯汀雷",
                "kr": "질 스팅레이",
                "jp": "ジル・スティングレイ",
                "en": "Jill Stingray",
                "alt": "pic_Jill_D.png"
            },
            "pic_Jill_529.png": {
                "cn": "吉尔·斯汀雷-模特战士",
                "icon": "Icon_Jill_529.png",
                "alt": "pic_Jill_529_D.png",
                "kr": "질 스팅레이 - 마법소녀 줄리아나",
                "jp": "モデル戦士",
                "en": "Model Warrior"
            }
        },
        "kr": "질 스팅레이",
        "jp": "ジル・スティングレイ",
        "en": "Jill Stingray"
    },
    "1018": {
        "type": "HG",
        "id": "1018",
        "cn": "赛伊·朝雾",
        "code": "SEI",
        "icon": "Icon_SEI.png",
        "modded": false,
        "rarity": 1,
        "skins": {
            "pic_SEI.png": {
                "cn": "赛伊·朝雾",
                "kr": "세이 아사기리",
                "jp": "セイ・P・アサギリ",
                "en": "Sei Asagiri",
                "alt": "pic_SEI_D.png"
            },
            "pic_SEI_527.png": {
                "cn": "赛伊·朝雾-挚友的便装",
                "icon": "Icon_SEI_527.png",
                "alt": "pic_SEI_527_D.png",
                "kr": "세이 아사기리 - 친구의 사복",
                "jp": "親友の私服",
                "en": "Best Friend's Casual Dress"
            }
        },
        "kr": "세이 아사기리",
        "jp": "セイ・P・アサギリ",
        "en": "Sei Asagiri"
    },
    "1019": {
        "type": "SMG",
        "id": "1019",
        "cn": "多萝西·海兹",
        "code": "Dorothy",
        "icon": "Icon_Dorothy.png",
        "modded": false,
        "rarity": 1,
        "skins": {
            "pic_Dorothy.png": {
                "cn": "多萝西·海兹",
                "kr": "도로시 헤이즈",
                "jp": "ドロシー・ヘイズ",
                "en": "Dorothy Haze",
                "alt": "pic_Dorothy_D.png"
            },
            "pic_Dorothy_525.png": {
                "cn": "多萝西·海兹-珍稀圣诞礼服",
                "icon": "Icon_Dorothy_525.png",
                "alt": "pic_Dorothy_525_D.png",
                "kr": "도로시 헤이즈 - 메가 산타",
                "jp": "メガクリスマス・ドレス",
                "en": "Precious Christmas Outfit"
            }
        },
        "kr": "도로시 헤이즈",
        "jp": "ドロシー・ヘイズ",
        "en": "Dorothy Haze"
    },
    "1020": {
        "type": "RF",
        "id": "1020",
        "cn": "史黛拉·星井",
        "code": "Stella",
        "icon": "Icon_Stella.png",
        "modded": false,
        "rarity": 1,
        "skins": {
            "pic_Stella.png": {
                "cn": "史黛拉·星井",
                "kr": "스텔라 호시이",
                "jp": "ステラ・星井",
                "en": "Stella Hoshii",
                "alt": "pic_Stella_D.png"
            },
            "pic_Stella_524.png": {
                "cn": "史黛拉·星井-挚友的铠甲",
                "icon": "Icon_Stella_524.png",
                "alt": "pic_Stella_524_D.png",
                "kr": "스텔라 호시이 - 친구의 갑옷",
                "jp": "親友のアーマー",
                "en": "Best Friend's Armor"
            }
        },
        "kr": "스텔라 호시이",
        "jp": "ステラ・星井",
        "en": "Stella Hoshii"
    },
    "1021": {
        "type": "MG",
        "id": "1021",
        "cn": "阿尔玛·阿玛斯",
        "code": "Alma",
        "icon": "Icon_Alma.png",
        "modded": false,
        "rarity": 1,
        "skins": {
            "pic_Alma.png": {
                "cn": "阿尔玛·阿玛斯",
                "kr": "알마 알머스",
                "jp": "アルマ・アルマス",
                "en": "Alma Armas",
                "alt": "pic_Alma_D.png"
            },
            "pic_Alma_528.png": {
                "cn": "阿尔玛·阿玛斯-中学大冒险",
                "icon": "Icon_Alma_528.png",
                "alt": "pic_Alma_528_D.png",
                "kr": "알마 알머스 - 학교 대모험",
                "jp": "中学生大冒険",
                "en": "Middle School Adventure"
            }
        },
        "kr": "알마 알머스",
        "jp": "アルマ・アルマス",
        "en": "Alma Armas"
    },
    "1022": {
        "type": "SG",
        "id": "1022",
        "cn": "达娜·赞恩",
        "code": "Dana",
        "icon": "Icon_Dana.png",
        "modded": false,
        "rarity": 1,
        "skins": {
            "pic_Dana.png": {
                "cn": "达娜·赞恩",
                "kr": "다나 제인",
                "jp": "デイナ・ゼイン",
                "en": "Dana Zane",
                "alt": "pic_Dana_D.png"
            },
            "pic_Dana_526.png": {
                "cn": "达娜·赞恩-赤色彗星",
                "icon": "Icon_Dana_526.png",
                "alt": "pic_Dana_526_D.png",
                "kr": "다나 제인 - 붉은 혜성",
                "jp": "赤い彗星",
                "en": "Red Comet"
            }
        },
        "kr": "다나 제인",
        "jp": "デイナ・ゼイン",
        "en": "Dana Zane"
    },
    "1023": {
        "type": "SMG",
        "id": "1023",
        "cn": "海莉艾塔",
        "code": "Henrietta",
        "icon": "Icon_Henrietta.png",
        "modded": false,
        "rarity": 1,
        "skins": {
            "pic_Henrietta.png": {
                "cn": "海莉艾塔",
                "kr": "헨리에타",
                "jp": "ヘンリエッタ",
                "en": "Henrietta",
                "alt": "pic_Henrietta_D.png"
            },
            "pic_Henrietta_544.png": {
                "cn": "海莉艾塔-月神假日",
                "icon": "Icon_Henrietta_544.png",
                "alt": "pic_Henrietta_544_D.png",
                "kr": "헨리에타 - 달빛 휴가",
                "jp": "アルテミスの休日",
                "en": "Artemis' Vacation"
            }
        },
        "kr": "헨리에타",
        "jp": "ヘンリエッタ",
        "en": "Henrietta"
    },
    "1024": {
        "type": "RF",
        "id": "1024",
        "cn": "莉可",
        "code": "Rico",
        "icon": "Icon_Rico.png",
        "modded": false,
        "rarity": 1,
        "skins": {
            "pic_Rico.png": {
                "cn": "莉可",
                "kr": "리코",
                "jp": "リコ",
                "en": "Rico",
                "alt": "pic_Rico_D.png"
            },
            "pic_Rico_542.png": {
                "cn": "莉可-自由餐厅",
                "icon": "Icon_Rico_542.png",
                "alt": "pic_Rico_542_D.png",
                "kr": "리코 - 자유로운 레스토랑",
                "jp": "自由のレストラン",
                "en": "Ristorante of Freedom"
            }
        },
        "kr": "리코",
        "jp": "リコ",
        "en": "Rico"
    },
    "1025": {
        "type": "SG",
        "id": "1025",
        "cn": "崔耶拉",
        "code": "Triela",
        "icon": "Icon_Triela.png",
        "modded": false,
        "rarity": 1,
        "skins": {
            "pic_Triela.png": {
                "cn": "崔耶拉",
                "kr": "트리엘라",
                "jp": "トリエラ",
                "en": "Triela",
                "alt": "pic_Triela_D.png"
            },
            "pic_Triela_541.png": {
                "cn": "崔耶拉-暗影行动",
                "icon": "Icon_Triela_541.png",
                "alt": "pic_Triela_541_D.png",
                "kr": "트리엘라 - 비밀 작전",
                "jp": "シャドウ・オペレーション",
                "en": "Shadow Operations"
            }
        },
        "kr": "트리엘라",
        "jp": "トリエラ",
        "en": "Triela"
    },
    "1026": {
        "type": "MG",
        "id": "1026",
        "cn": "库拉耶丝",
        "code": "Claes",
        "icon": "Icon_Claes.png",
        "modded": false,
        "rarity": 1,
        "skins": {
            "pic_Claes.png": {
                "cn": "库拉耶丝",
                "kr": "클라에스",
                "jp": "クラエス",
                "en": "Claes",
                "alt": "pic_Claes_D.png"
            },
            "pic_Claes_545.png": {
                "cn": "库拉耶丝-晨风庭园",
                "icon": "Icon_Claes_545.png",
                "alt": "pic_Claes_545_D.png",
                "kr": "클라에스 - 산뜻한 정원",
                "jp": "朝風の箱庭",
                "en": "Morning Breeze in the Garden"
            }
        },
        "kr": "클라에스",
        "jp": "クラエス",
        "en": "Claes"
    },
    "1027": {
        "type": "AR",
        "id": "1027",
        "cn": "安洁莉卡",
        "code": "Angelica",
        "icon": "Icon_Angelica.png",
        "modded": false,
        "rarity": 1,
        "skins": {
            "pic_Angelica.png": {
                "cn": "安洁莉卡",
                "kr": "안젤리카",
                "jp": "アンジェリカ",
                "en": "Angelica",
                "alt": "pic_Angelica_D.png"
            },
            "pic_Angelica_543.png": {
                "cn": "安洁莉卡-童话起点",
                "icon": "Icon_Angelica_543.png",
                "alt": "pic_Angelica_543_D.png",
                "kr": "안젤리카 - 첫번째 페이지",
                "jp": "童話のはじまり",
                "en": "Fairy Tale Beginning"
            }
        },
        "kr": "안젤리카",
        "jp": "アンジェリカ",
        "en": "Angelica"
    },
    "1028": {
        "type": "SMG",
        "id": "1028",
        "cn": "特工维克托",
        "code": "VectorAgent",
        "icon": "Icon_VectorAgent.png",
        "modded": false,
        "rarity": 1,
        "skins": {
            "pic_VectorAgent.png": {
                "cn": "特工维克托",
                "kr": "요원 Vector",
                "jp": "エージェントVector",
                "en": "Agent Vector",
                "alt": "pic_VectorAgent_D.png"
            },
            "pic_VectorAgent_547.png": {
                "cn": "特工维克托-浴火凛锋",
                "icon": "Icon_VectorAgent_547.png",
                "alt": "pic_VectorAgent_547_D.png",
                "kr": "요원 Vector - 불길돌파",
                "jp": "ファイアアサルト",
                "en": "Searing Edge"
            }
        },
        "kr": "요원 Vector",
        "jp": "エージェントVector",
        "en": "Agent Vector"
    },
    "1029": {
        "type": "AR",
        "id": "1029",
        "cn": "特工416",
        "code": "HK416Agent",
        "icon": "Icon_HK416Agent.png",
        "modded": false,
        "rarity": 1,
        "skins": {
            "pic_HK416Agent.png": {
                "cn": "特工416",
                "kr": "요원 416",
                "jp": "エージェント416",
                "en": "Agent 416",
                "alt": "pic_HK416Agent_D.png"
            },
            "pic_HK416Agent_546.png": {
                "cn": "特工416-曼岛之盾",
                "icon": "Icon_HK416Agent_546.png",
                "alt": "pic_HK416Agent_546_D.png",
                "kr": "요원 416 - 맨섬의 방패",
                "jp": "マンハッタンの盾",
                "en": "Shield of Manhattan"
            }
        },
        "kr": "요원 416",
        "jp": "エージェント416",
        "en": "Agent 416"
    },
    "1030": {
        "type": "SMG",
        "id": "1030",
        "cn": "邪神酱",
        "code": "Jashinchan",
        "icon": "Icon_Jashinchan.png",
        "modded": false,
        "rarity": 1,
        "skins": {
            "pic_Jashinchan.png": {
                "cn": "邪神酱",
                "kr": "사신짱",
                "jp": "邪神ちゃん",
                "en": "Jashin-chan",
                "alt": "pic_Jashinchan_D.png"
            },
            "pic_Jashinchan_567.png": {
                "cn": "邪神酱-墨鸽爵士",
                "icon": "Icon_Jashinchan_567.png",
                "alt": "pic_Jashinchan_567_D.png",
                "kr": "사신짱 - 흑비둘기 남작",
                "jp": "ハト男爵",
                "en": "Pigeon Baron"
            }
        },
        "kr": "사신짱",
        "jp": "邪神ちゃん",
        "en": "Jashin-chan"
    },
    "1031": {
        "type": "RF",
        "id": "1031",
        "cn": "佩可拉",
        "code": "Pekora",
        "icon": "Icon_Pekora.png",
        "modded": false,
        "rarity": 1,
        "skins": {
            "pic_Pekora.png": {
                "cn": "佩可拉",
                "kr": "페코라",
                "jp": "ぺこら",
                "en": "Pekola",
                "alt": "pic_Pekora_D.png"
            },
            "pic_Pekora_570.png": {
                "cn": "佩可拉-打工吧！天使大人",
                "icon": "Icon_Pekora_570.png",
                "alt": "pic_Pekora_570_D.png",
                "kr": "페코라 - 알바 뛰는 천사님!",
                "jp": "はたらく天使さま！",
                "en": "The Angel is a Part-Timer!"
            }
        },
        "kr": "페코라",
        "jp": "ぺこら",
        "en": "Pekola"
    },
    "1032": {
        "type": "AR",
        "id": "1032",
        "cn": "美杜莎",
        "code": "Medusa",
        "icon": "Icon_Medusa.png",
        "modded": false,
        "rarity": 1,
        "skins": {
            "pic_Medusa.png": {
                "cn": "美杜莎",
                "kr": "메두사",
                "jp": "メデューサ",
                "en": "Medusa",
                "alt": "pic_Medusa_D.png"
            },
            "pic_Medusa_569.png": {
                "cn": "美杜莎-浓情生巧职人",
                "icon": "Icon_Medusa_569.png",
                "alt": "pic_Medusa_569_D.png",
                "kr": "메두사 - 정성 듬뿍 파티셰",
                "jp": "濃厚生チョコ職人",
                "en": "Chocolatier"
            }
        },
        "kr": "메두사",
        "jp": "メデューサ",
        "en": "Medusa"
    },
    "1033": {
        "type": "MG",
        "id": "1033",
        "cn": "花园百合铃",
        "code": "Yurine",
        "icon": "Icon_Yurine.png",
        "modded": false,
        "rarity": 1,
        "skins": {
            "pic_Yurine.png": {
                "cn": "花园百合铃",
                "kr": "하나조노 유리네",
                "jp": "花園ゆりね",
                "en": "Hanazono Yurine",
                "alt": "pic_Yurine_D.png"
            },
            "pic_Yurine_568.png": {
                "cn": "花园百合铃-恶魔在身边",
                "icon": "Icon_Yurine_568.png",
                "alt": "pic_Yurine_568_D.png",
                "kr": "하나조노 유리네 - 악마가 곁에 있어",
                "jp": "悪魔は隣にいる",
                "en": "Devil By Your Side"
            }
        },
        "kr": "하나조노 유리네",
        "jp": "花園ゆりね",
        "en": "Hanazono Yurine"
    },
    "1034": {
        "type": "SG",
        "id": "1034",
        "cn": "米诺斯",
        "code": "Minosu",
        "icon": "Icon_Minosu.png",
        "modded": false,
        "rarity": 1,
        "skins": {
            "pic_Minosu.png": {
                "cn": "米诺斯",
                "kr": "미노스",
                "jp": "ミノス",
                "en": "Minos",
                "alt": "pic_Minosu_D.png"
            },
            "pic_Minosu_571.png": {
                "cn": "米诺斯-湖畔对饮夜",
                "icon": "Icon_Minosu_571.png",
                "alt": "pic_Minosu_571_D.png",
                "kr": "미노스 - 호숫가에서 한잔",
                "jp": "湖畔対酌の夜",
                "en": "Lakeside Drinking Night"
            }
        },
        "kr": "미노스",
        "jp": "ミノス",
        "en": "Minos"
    }
}